export const DashboardIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9316 17.0327C14.9316 15.1317 14.9316 14.1812 15.5466 13.5906C16.1616 13 17.1513 13 19.1309 13C21.1104 13 22.1002 13 22.7151 13.5906C23.3301 14.1812 23.3301 15.1317 23.3301 17.0327V19.0491C23.3301 20.9501 23.3301 21.9006 22.7151 22.4912C22.1002 23.0818 21.1104 23.0818 19.1309 23.0818C17.1513 23.0818 16.1616 23.0818 15.5466 22.4912C14.9316 21.9006 14.9316 20.9501 14.9316 19.0491V17.0327Z"
      fill="#878785"
    />
    <path
      d="M5 11.0491C5 12.9501 5 13.9006 5.61496 14.4912C6.22993 15.0818 7.2197 15.0818 9.19924 15.0818C11.1788 15.0818 12.1685 15.0818 12.7835 14.4912C13.3985 13.9006 13.3985 12.9501 13.3985 11.0491V9.03271C13.3985 7.13167 13.3985 6.18115 12.7835 5.59058C12.1685 5 11.1788 5 9.19924 5C7.2197 5 6.22993 5 5.61496 5.59058C5 6.18115 5 7.13167 5 9.03271V11.0491Z"
      fill="#878785"
    />
    <path
      d="M14.9316 8.20784C14.9316 7.2114 14.9316 6.71317 15.0915 6.32017C15.3046 5.79616 15.7133 5.37984 16.2278 5.16279C16.6136 5 17.1028 5 18.0811 5H20.1807C21.159 5 21.6481 5 22.034 5.16279C22.5484 5.37984 22.9572 5.79616 23.1703 6.32017C23.3301 6.71317 23.3301 7.2114 23.3301 8.20784C23.3301 9.20428 23.3301 9.70251 23.1703 10.0955C22.9572 10.6195 22.5484 11.0358 22.034 11.2529C21.6481 11.4157 21.159 11.4157 20.1807 11.4157H18.0811C17.1028 11.4157 16.6136 11.4157 16.2278 11.2529C15.7133 11.0358 15.3046 10.6195 15.0915 10.0955C14.9316 9.70251 14.9316 9.20428 14.9316 8.20784Z"
      fill="#878785"
    />
    <path
      d="M5 20.2078C5 21.2043 5 21.7025 5.15982 22.0955C5.37292 22.6195 5.78166 23.0358 6.29613 23.2529C6.68198 23.4157 7.17113 23.4157 8.14943 23.4157H10.249C11.2273 23.4157 11.7165 23.4157 12.1023 23.2529C12.6168 23.0358 13.0255 22.6195 13.2386 22.0955C13.3985 21.7025 13.3985 21.2043 13.3985 20.2078C13.3985 19.2114 13.3985 18.7132 13.2386 18.3202C13.0255 17.7962 12.6168 17.3798 12.1023 17.1628C11.7165 17 11.2273 17 10.249 17H8.14943C7.17113 17 6.68198 17 6.29613 17.1628C5.78166 17.3798 5.37292 17.7962 5.15982 18.3202C5 18.7132 5 19.2114 5 20.2078Z"
      fill="#878785"
    />
  </svg>
);

export const InvestmentIcon = () => (
  <svg
    width="22"
    height="13"
    viewBox="0 0 22 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.72 5.57234H17.84C17.1124 5.56878 16.4136 5.85691 15.9 6.37234L11.48 10.7923V1.24234C11.4769 0.736585 11.1693 0.282548 10.7008 0.0920732C10.2323 -0.0984016 9.69513 0.0122258 9.34 0.372338L4.51 5.20234C4.27537 5.44064 3.95442 5.57407 3.62 5.57234H0.75C0.335786 5.57234 0 5.90813 0 6.32234C0 6.73655 0.335786 7.07234 0.75 7.07234H3.62C4.36939 7.08726 5.09219 6.79453 5.62 6.26234L9.96 1.85234V11.4023C9.95897 11.9066 10.2634 12.3612 10.73 12.5523C10.8812 12.6189 11.0448 12.653 11.21 12.6523C11.5412 12.6525 11.8584 12.5191 12.09 12.2823L16.96 7.43234C17.1945 7.20111 17.5107 7.07174 17.84 7.07234H20.72C21.1342 7.07234 21.47 6.73655 21.47 6.32234C21.47 5.90813 21.1342 5.57234 20.72 5.57234Z"
      fill="white"
    />
  </svg>
);

export const MarketplaceIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.36683 6.36683C5 7.73367 5 9.93356 5 14.3333C5 18.7331 5 20.933 6.36683 22.2998C7.73367 23.6667 9.93356 23.6667 14.3333 23.6667C18.7331 23.6667 20.933 23.6667 22.2998 22.2998C23.6667 20.933 23.6667 18.7331 23.6667 14.3333C23.6667 9.93356 23.6667 7.73367 22.2998 6.36683C20.933 5 18.7331 5 14.3333 5C9.93356 5 7.73367 5 6.36683 6.36683ZM19 10.8333C19.3866 10.8333 19.7 11.1467 19.7 11.5333V19.9333C19.7 20.3199 19.3866 20.6333 19 20.6333C18.6134 20.6333 18.3 20.3199 18.3 19.9333V11.5333C18.3 11.1467 18.6134 10.8333 19 10.8333ZM15.0333 14.3333C15.0333 13.9467 14.7199 13.6333 14.3333 13.6333C13.9467 13.6333 13.6333 13.9467 13.6333 14.3333V19.9333C13.6333 20.3199 13.9467 20.6333 14.3333 20.6333C14.7199 20.6333 15.0333 20.3199 15.0333 19.9333V14.3333ZM9.66667 16.4333C10.0533 16.4333 10.3667 16.7467 10.3667 17.1333V19.9333C10.3667 20.3199 10.0533 20.6333 9.66667 20.6333C9.28007 20.6333 8.96667 20.3199 8.96667 19.9333V17.1333C8.96667 16.7467 9.28007 16.4333 9.66667 16.4333Z"
      fill="#878785"
    />
  </svg>
);
export const SettingIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.5269 5.14209C15.1812 5 14.743 5 13.8667 5C12.9903 5 12.5521 5 12.2064 5.14209C11.7456 5.33155 11.3794 5.69494 11.1885 6.15232C11.1014 6.36112 11.0673 6.60393 11.0539 6.95812C11.0343 7.47863 10.7653 7.96043 10.3108 8.22087C9.8563 8.4813 9.3014 8.47157 8.83739 8.22817C8.52164 8.06255 8.2927 7.97045 8.06692 7.94095C7.57235 7.87633 7.07217 8.00934 6.67641 8.31072C6.37959 8.53675 6.1605 8.91337 5.72231 9.6666C5.28412 10.4198 5.06502 10.7965 5.01619 11.1646C4.95108 11.6554 5.0851 12.1518 5.38878 12.5446C5.52738 12.7239 5.72219 12.8746 6.02452 13.0631C6.46899 13.3403 6.75497 13.8124 6.75494 14.3334C6.75491 14.8543 6.46894 15.3263 6.02452 15.6035C5.72214 15.792 5.52731 15.9427 5.38868 16.122C5.08501 16.5148 4.95099 17.0112 5.0161 17.502C5.06493 17.8702 5.28403 18.2468 5.72222 19C6.16041 19.7532 6.3795 20.1298 6.67632 20.3559C7.07208 20.6573 7.57226 20.7903 8.06683 20.7257C8.29259 20.6962 8.52152 20.6041 8.83724 20.4385C9.30128 20.195 9.85623 20.1853 10.3108 20.4458C10.7653 20.7062 11.0343 21.188 11.0539 21.7086C11.0673 22.0628 11.1014 22.3056 11.1885 22.5143C11.3794 22.9717 11.7456 23.3351 12.2064 23.5246C12.5521 23.6667 12.9903 23.6667 13.8667 23.6667C14.743 23.6667 15.1812 23.6667 15.5269 23.5246C15.9878 23.3351 16.3539 22.9717 16.5448 22.5143C16.632 22.3055 16.6661 22.0627 16.6794 21.7085C16.699 21.188 16.968 20.7062 17.4225 20.4458C17.877 20.1853 18.432 20.195 18.896 20.4384C19.2117 20.604 19.4407 20.6961 19.6664 20.7256C20.161 20.7902 20.6612 20.6572 21.0569 20.3558C21.3537 20.1298 21.5728 19.7532 22.011 18.9999C22.4492 18.2467 22.6683 17.8701 22.7171 17.502C22.7823 17.0111 22.6482 16.5147 22.3446 16.122C22.2059 15.9427 22.0111 15.792 21.7088 15.6034C21.2643 15.3263 20.9784 14.8542 20.9784 14.3332C20.9784 13.8124 21.2644 13.3403 21.7088 13.0632C22.0112 12.8747 22.206 12.7239 22.3446 12.5446C22.6483 12.1519 22.7823 11.6555 22.7172 11.1646C22.6684 10.7965 22.4493 10.4199 22.0111 9.66667C21.5729 8.91343 21.3538 8.53682 21.057 8.31078C20.6613 8.0094 20.1611 7.87639 19.6665 7.94101C19.4407 7.97051 19.2118 8.0626 18.8961 8.22821C18.432 8.47162 17.8771 8.48135 17.4226 8.2209C16.968 7.96044 16.699 7.47862 16.6794 6.95808C16.6661 6.60391 16.632 6.36111 16.5448 6.15232C16.3539 5.69494 15.9878 5.33155 15.5269 5.14209ZM13.8667 17.1333C15.4248 17.1333 16.688 15.8797 16.688 14.3333C16.688 12.7869 15.4248 11.5333 13.8667 11.5333C12.3085 11.5333 11.0453 12.7869 11.0453 14.3333C11.0453 15.8797 12.3085 17.1333 13.8667 17.1333Z"
      fill="#898989"
    />
  </svg>
);
export const HelpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.2334 5.29C21.0342 4.03026 19.9865 3.07812 18.7134 3H5.40345C4.13045 3.07812 3.08268 4.03026 2.88345 5.29L2.01345 17.01C1.83345 19.45 3.48345 21.54 5.57345 21.54H18.3634C20.4234 21.54 22.0534 19.54 21.9134 17.1L21.2334 5.29ZM5.40345 4.54H18.7134C19.2257 4.62644 19.627 5.02776 19.7134 5.54L20.1334 12.7H16.8634C15.5508 12.7455 14.3719 13.516 13.8034 14.7C13.4484 15.4133 12.7202 15.8643 11.9234 15.8643C11.1267 15.8643 10.3985 15.4133 10.0434 14.7C9.47672 13.5144 8.2968 12.7432 6.98345 12.7H3.84345L4.37345 5.55C4.4626 5.0262 4.87801 4.61886 5.40345 4.54ZM18.3634 20.04C18.8606 20.026 19.3303 19.8092 19.6634 19.44C20.1994 18.8266 20.463 18.0216 20.3934 17.21L20.2234 14.21H16.8434C16.0875 14.2614 15.4201 14.7217 15.1034 15.41C14.4943 16.6151 13.2588 17.375 11.9084 17.375C10.5581 17.375 9.32263 16.6151 8.71345 15.41C8.39335 14.7202 7.72229 14.26 6.96345 14.21H3.73345L3.51345 17.12C3.4389 17.9552 3.70587 18.785 4.25345 19.42C4.58779 19.8016 5.06626 20.0264 5.57345 20.04H18.3634Z"
      fill="white"
    />
  </svg>
);

export const TransactionsIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 14.3333C5 9.93356 5 7.73367 6.36683 6.36683C7.73367 5 9.93356 5 14.3333 5C18.7331 5 20.933 5 22.2998 6.36683C23.6667 7.73367 23.6667 9.93356 23.6667 14.3333C23.6667 18.7331 23.6667 20.933 22.2998 22.2998C20.933 23.6667 18.7331 23.6667 14.3333 23.6667C9.93356 23.6667 7.73367 23.6667 6.36683 22.2998C5 20.933 5 18.7331 5 14.3333ZM10.1846 15.0291C9.92457 14.7431 9.48186 14.722 9.1958 14.982C8.90973 15.2421 8.88865 15.6848 9.14871 15.9709L11.482 18.5375C11.6147 18.6835 11.8028 18.7667 12 18.7667C12.1972 18.7667 12.3853 18.6835 12.518 18.5375L14.8513 15.9709C15.1113 15.6848 15.0903 15.2421 14.8042 14.982C14.5181 14.722 14.0754 14.7431 13.8154 15.0291L12.7 16.256V10.6C12.7 10.2134 12.3866 9.9 12 9.9C11.6134 9.9 11.3 10.2134 11.3 10.6V16.256L10.1846 15.0291ZM13.8625 13.6846C14.1485 13.9447 14.5912 13.9236 14.8513 13.6375L15.9667 12.4106L15.9667 18.0667C15.9667 18.4533 16.2801 18.7667 16.6667 18.7667C17.0533 18.7667 17.3667 18.4533 17.3667 18.0667L17.3667 12.4106L18.482 13.6375C18.7421 13.9236 19.1848 13.9447 19.4709 13.6846C19.7569 13.4246 19.778 12.9819 19.518 12.6958L17.1846 10.1291C17.052 9.9832 16.8639 9.9 16.6667 9.9C16.4694 9.9 16.2814 9.9832 16.1487 10.1291L13.8154 12.6958C13.5553 12.9819 13.5764 13.4246 13.8625 13.6846Z"
      fill="#878785"
    />
  </svg>
);
export const MoneyIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.867 6.5332H12.1337C8.61384 6.5332 6.85393 6.5332 5.76046 7.62667C4.97316 8.41398 4.75272 9.54677 4.69099 11.4332H23.3097C23.2479 9.54677 23.0275 8.41398 22.2402 7.62667C21.1467 6.5332 19.3868 6.5332 15.867 6.5332Z"
      fill="#787FFF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.867 21.4665H12.1337C8.61384 21.4665 6.85393 21.4665 5.76046 20.3731C4.66699 19.2796 4.66699 17.5197 4.66699 13.9999C4.66699 13.5874 4.66699 13.1991 4.66875 12.8332H23.3319C23.3337 13.1991 23.3337 13.5874 23.3337 13.9999C23.3337 17.5197 23.3337 19.2796 22.2402 20.3731C21.1467 21.4665 19.3868 21.4665 15.867 21.4665ZM17.7754 14.2332C18.1794 14.2332 18.5498 14.2331 18.8511 14.2736C19.1828 14.3182 19.5335 14.4232 19.8219 14.7116C20.1104 15 20.2153 15.3507 20.2599 15.6825C20.3004 15.9838 20.3004 16.3541 20.3003 16.7581V16.8416C20.3004 17.2456 20.3004 17.616 20.2599 17.9173C20.2153 18.249 20.1104 18.5997 19.8219 18.8881C19.5335 19.1766 19.1828 19.2815 18.8511 19.3261C18.5498 19.3666 18.1794 19.3666 17.7754 19.3665L17.7337 19.3665L17.6919 19.3665C17.2879 19.3666 16.9176 19.3666 16.6163 19.3261C16.2845 19.2815 15.9338 19.1766 15.6454 18.8881C15.357 18.5997 15.252 18.249 15.2074 17.9173C15.1669 17.616 15.1669 17.2456 15.167 16.8416L15.167 16.7999L15.167 16.7581C15.1669 16.3541 15.1669 15.9838 15.2074 15.6825C15.252 15.3507 15.357 15 15.6454 14.7116C15.9338 14.4232 16.2845 14.3182 16.6163 14.2736C16.9176 14.2331 17.2879 14.2332 17.6919 14.2332H17.7754ZM7.70033 15.3999C7.70033 15.0133 8.01373 14.6999 8.40033 14.6999H10.267C10.6536 14.6999 10.967 15.0133 10.967 15.3999C10.967 15.7865 10.6536 16.0999 10.267 16.0999H8.40033C8.01373 16.0999 7.70033 15.7865 7.70033 15.3999ZM7.70033 18.1999C7.70033 17.8133 8.01373 17.4999 8.40033 17.4999H12.1337C12.5203 17.4999 12.8337 17.8133 12.8337 18.1999C12.8337 18.5865 12.5203 18.8999 12.1337 18.8999H8.40033C8.01373 18.8999 7.70033 18.5865 7.70033 18.1999Z"
      fill="#787FFF"
    />
    <path
      d="M16.6354 15.7015L16.6376 15.7003C16.6394 15.6993 16.6425 15.6978 16.6472 15.6959C16.6676 15.6875 16.7127 15.6732 16.8028 15.6611C16.9995 15.6347 17.2739 15.6332 17.7337 15.6332C18.1934 15.6332 18.4678 15.6347 18.6645 15.6611C18.7546 15.6732 18.7998 15.6875 18.8201 15.6959C18.8248 15.6978 18.8279 15.6993 18.8297 15.7003L18.832 15.7016L18.8333 15.7038C18.8342 15.7056 18.8357 15.7087 18.8376 15.7134C18.846 15.7338 18.8603 15.7789 18.8724 15.869C18.8988 16.0657 18.9003 16.3401 18.9003 16.7999C18.9003 17.2596 18.8988 17.534 18.8724 17.7307C18.8603 17.8208 18.846 17.866 18.8376 17.8863C18.8357 17.891 18.8342 17.8941 18.8333 17.8959L18.832 17.8982L18.8297 17.8995C18.8279 17.9004 18.8248 17.9019 18.8201 17.9039C18.7998 17.9122 18.7546 17.9265 18.6645 17.9386C18.4678 17.965 18.1934 17.9665 17.7337 17.9665C17.2739 17.9665 16.9995 17.965 16.8028 17.9386C16.7127 17.9265 16.6676 17.9122 16.6472 17.9039C16.6425 17.9019 16.6394 17.9004 16.6376 17.8995L16.6353 17.8982L16.6341 17.8959C16.6331 17.8941 16.6316 17.891 16.6297 17.8863C16.6213 17.866 16.607 17.8208 16.5949 17.7307C16.5685 17.534 16.567 17.2596 16.567 16.7999C16.567 16.3401 16.5685 16.0657 16.5949 15.869C16.607 15.7789 16.6213 15.7338 16.6297 15.7134C16.6316 15.7087 16.6331 15.7056 16.6341 15.7038L16.6354 15.7015Z"
      fill="#787FFF"
    />
  </svg>
);

export const WalletIconSide = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9396 6.59156C18.8528 5.47112 17.914 4.58582 16.7717 4.58582H6.59483C5.39545 4.58582 4.41968 5.56159 4.41968 6.76097V16.8249C4.41968 18.0243 5.39545 19.0001 6.59483 19.0001H18.3517C19.551 19.0001 20.5268 18.0243 20.5268 16.8249V8.68529C20.5268 7.68968 19.8541 6.84877 18.9396 6.59156ZM6.59483 5.60194H16.7717C17.3247 5.60194 17.7881 5.99128 17.9031 6.51017H6.59483C6.16898 6.51017 5.77164 6.63367 5.43581 6.84604V6.76097C5.43581 6.12189 5.95575 5.60194 6.59483 5.60194ZM18.3516 17.9839H6.59483C5.95575 17.9839 5.43581 17.464 5.43581 16.8249V8.68529C5.43581 8.04621 5.95575 7.52627 6.59483 7.52627H18.3517C18.9907 7.52627 19.5107 8.04621 19.5107 8.68529V10.4584H16.271C14.9871 10.4584 13.9427 11.5029 13.9427 12.7867C13.9427 14.0705 14.9872 15.115 16.271 15.115H19.5107V16.8249C19.5107 17.464 18.9907 17.9839 18.3516 17.9839ZM19.5107 14.0988H16.271C15.5474 14.0988 14.9588 13.5102 14.9588 12.7867C14.9588 12.0631 15.5474 11.4745 16.271 11.4745H19.5107V14.0988Z"
      fill="#ECEEF1"
    />
    <path
      d="M16.4596 13.3541C16.7518 13.3541 16.9886 13.1172 16.9886 12.8251C16.9886 12.533 16.7518 12.2961 16.4596 12.2961C16.1675 12.2961 15.9307 12.533 15.9307 12.8251C15.9307 13.1172 16.1675 13.3541 16.4596 13.3541Z"
      fill="#ECEEF1"
    />
  </svg>
);

export const P2pIcon = () => (
  <svg
    width="26"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.01764 9.95616C9.955 8.45001 7.93055 6.32537 6.67357 5.87637C6.73791 5.82303 6.80657 5.77608 6.86663 5.71545C7.23952 5.33982 7.49531 4.85195 7.59968 4.31735C7.70404 3.78277 7.65197 3.22703 7.45045 2.7248C7.24894 2.22256 6.90763 1.79786 6.47235 1.50773C6.03708 1.21759 5.52866 1.07589 5.01541 1.10168C4.50214 1.12746 4.00859 1.31949 3.60102 1.65198C3.19346 1.98446 2.89139 2.44149 2.73536 2.96169C2.57935 3.48189 2.57686 4.04035 2.72823 4.5621C2.87959 5.08385 3.17757 5.54389 3.58216 5.88046C2.99722 6.12015 2.46873 6.49298 2.03384 6.97279C1.59895 7.45262 1.26817 8.02776 1.06477 8.65787C0.998981 8.87864 0.983035 9.11275 1.01819 9.34129C1.05336 9.56977 1.13865 9.78638 1.26715 9.9734C1.39568 10.1604 1.56381 10.3126 1.75798 10.4178C1.95214 10.523 2.16687 10.5781 2.38482 10.5788H7.88122C8.10362 10.5783 8.32273 10.5216 8.52042 10.4132C8.7181 10.305 8.88826 10.1482 9.01764 9.95616ZM4.38654 2.16267C4.74907 1.9779 5.16163 1.93622 5.55043 2.0451C5.93922 2.15396 6.27887 2.40629 6.50859 2.75691C6.73831 3.10753 6.84312 3.53355 6.80426 3.95878C6.7654 4.38399 6.58539 4.78064 6.29648 5.07774C4.33035 6.85368 2.13641 3.50831 4.38654 2.16267ZM2.38482 9.69862C2.29412 9.69828 2.20478 9.67512 2.1242 9.63098C2.04363 9.58668 1.97413 9.52259 1.92149 9.44418C1.87228 9.37299 1.83996 9.29025 1.82727 9.20297C1.81458 9.11568 1.82188 9.02641 1.84855 8.94276C2.08342 8.21565 2.52617 7.58465 3.11495 7.13789C3.70373 6.69114 4.40915 6.45097 5.13265 6.45092C5.85615 6.45087 6.56158 6.69095 7.15043 7.13762C7.73928 7.58427 8.18209 8.21522 8.41705 8.9423C8.44376 9.02602 8.45108 9.11536 8.43839 9.20273C8.42569 9.2901 8.39336 9.37292 8.34412 9.44418C8.29147 9.52259 8.22197 9.58668 8.1414 9.63098C8.06083 9.67512 7.97148 9.69828 7.88079 9.69862H2.38482ZM24.935 20.9758C24.731 20.3443 24.3989 19.7678 23.9623 19.2874C23.5256 18.8068 22.9952 18.4341 22.4081 18.1954C22.4726 18.1419 22.5407 18.0951 22.6012 18.0344C22.8501 17.7852 23.0482 17.4843 23.183 17.1505C23.3179 16.8166 23.3869 16.4567 23.3854 16.0935C23.282 12.5575 18.4447 12.558 18.3489 16.0935C18.3489 16.4995 18.4359 16.9003 18.6036 17.2652C18.7712 17.6301 19.015 17.9497 19.3163 18.1994C18.0611 18.653 16.0481 20.7704 16.9826 22.2745C17.1118 22.4668 17.2823 22.6235 17.4799 22.7319C17.6776 22.8403 17.8966 22.8971 18.1191 22.8978H23.6154C23.8334 22.8971 24.0481 22.8418 24.2424 22.7366C24.4366 22.6313 24.6048 22.4789 24.7332 22.2919C24.8616 22.1047 24.9469 21.8881 24.982 21.6595C25.017 21.4309 25.0009 21.1967 24.935 20.9758ZM20.1208 14.4817C20.4831 14.2969 20.8956 14.2553 21.2844 14.364C21.6732 14.4729 22.0128 14.725 22.2426 15.0755C22.4723 15.4261 22.5771 15.852 22.5385 16.2773C22.4996 16.7024 22.3198 17.0991 22.0311 17.3962C20.0641 19.1717 17.8709 15.8272 20.1208 14.4817ZM24.0783 21.7631C24.0257 21.8416 23.9561 21.9057 23.8756 21.9498C23.7951 21.9941 23.7056 22.0173 23.6149 22.0175H18.1194C18.0287 22.0173 17.9394 21.9941 17.8589 21.9498C17.7782 21.9057 17.7088 21.8416 17.6561 21.7631C17.6069 21.692 17.5746 21.6093 17.5619 21.5218C17.5492 21.4346 17.5565 21.3453 17.5832 21.2618C17.818 20.5345 18.2605 19.9033 18.8494 19.4563C19.4382 19.0094 20.1437 18.7691 20.8673 18.769C21.5909 18.769 22.2964 19.0089 22.8854 19.4557C23.4744 19.9024 23.9171 20.5336 24.152 21.2608C24.1789 21.3446 24.1862 21.4341 24.1735 21.5215C24.1608 21.6089 24.1277 21.6918 24.0783 21.7631ZM9.13064 2.83738C10.6135 2.08282 11.9936 1.78868 13.6341 1.90542C15.2747 2.02217 16.859 2.58683 18.234 3.54476C18.3256 3.60281 18.435 3.62103 18.5389 3.59561C18.643 3.57018 18.7338 3.50308 18.7924 3.4083C18.851 3.31351 18.8729 3.19835 18.8537 3.0868C18.8342 2.97525 18.7752 2.87592 18.6886 2.8095C17.1949 1.76595 15.4725 1.15088 13.6888 1.02411C11.9051 0.897361 10.3818 1.22224 8.77067 2.04513C8.72119 2.0699 8.67682 2.10484 8.64012 2.14794C8.60342 2.19103 8.57513 2.24144 8.55688 2.29621C8.53861 2.35099 8.53074 2.40908 8.53374 2.46711C8.53673 2.52515 8.55051 2.58196 8.57429 2.6343C8.59806 2.68663 8.63137 2.73346 8.67227 2.77204C8.71317 2.81061 8.76087 2.84021 8.8126 2.85909C8.86432 2.87797 8.91907 2.88578 8.97372 2.88204C9.02831 2.87832 9.08162 2.86314 9.13064 2.83738ZM15.3229 21.7775C14.0227 22.1516 12.8215 22.2141 11.4912 21.988C10.1611 21.762 8.89128 21.2383 7.76582 20.4516C7.67411 20.3936 7.56486 20.3754 7.46082 20.4009C7.35679 20.4263 7.26602 20.4934 7.20739 20.5881C7.14876 20.683 7.12681 20.7981 7.14613 20.9097C7.16545 21.0211 7.22453 21.1206 7.31107 21.187C8.99982 22.369 10.9778 22.9984 13 22.9975C13.9132 22.9989 14.6634 22.8832 15.5438 22.6262C15.5971 22.6117 15.6471 22.586 15.6908 22.5506C15.7346 22.5153 15.7714 22.4712 15.7987 22.4206C15.8263 22.37 15.8441 22.3142 15.8511 22.2562C15.8581 22.1982 15.8541 22.1394 15.8395 22.0832C15.8248 22.0269 15.7999 21.9742 15.7658 21.9283C15.7319 21.8825 15.6896 21.8441 15.6415 21.8159C15.5934 21.7875 15.5406 21.7696 15.486 21.7631C15.4313 21.7567 15.3756 21.7609 15.3229 21.7775ZM6.16478 17.7003C6.11054 17.6949 6.05584 17.7009 6.00385 17.7184C5.95186 17.7356 5.90361 17.7637 5.86189 17.8009C5.8202 17.8381 5.78586 17.8837 5.7609 17.9351C5.73593 17.9865 5.72083 18.0429 5.71647 18.1005L5.68644 18.4739C4.25404 16.6598 3.47118 14.3662 3.47619 11.9982C3.48757 11.9376 3.48716 11.8752 3.475 11.8147C3.46282 11.7543 3.43916 11.6972 3.40545 11.6468C3.37175 11.5964 3.32871 11.5539 3.27898 11.5218C3.22925 11.4897 3.17388 11.4689 3.11626 11.4603C3.04993 11.454 2.9831 11.4638 2.92094 11.4892C2.85878 11.5147 2.80295 11.555 2.75775 11.6069C2.71256 11.659 2.67922 11.7212 2.6603 11.789C2.64139 11.857 2.63739 11.9285 2.64865 11.9982C2.64177 14.5421 3.47134 17.0085 4.99402 18.9715L4.59333 18.9123C4.4858 18.8988 4.37758 18.9306 4.29186 19.001C4.20615 19.0713 4.14977 19.1744 4.13477 19.2882C4.1198 19.4022 4.14743 19.5179 4.21172 19.6104C4.27603 19.703 4.3719 19.7651 4.47878 19.7834L5.95499 20.0032C6.01061 20.0111 6.06717 20.0069 6.12127 19.991C6.17536 19.9751 6.22587 19.9479 6.26976 19.9107C6.31364 19.8735 6.35 19.8273 6.37663 19.7747C6.40327 19.7223 6.41963 19.6647 6.42475 19.6051L6.54144 18.1761C6.55083 18.0599 6.51643 17.9446 6.44581 17.8553C6.37518 17.7662 6.27409 17.7104 6.16478 17.7003ZM19.7681 6.26564C19.8771 6.27981 19.9869 6.24745 20.0735 6.17567C20.1599 6.10387 20.2162 5.99852 20.2296 5.88274L20.2769 5.47933C21.7316 7.29923 22.5281 9.61052 22.5235 11.9982C22.5558 12.4121 22.3185 13.1081 22.883 13.1807C23.4687 13.1898 23.3237 12.4204 23.3515 11.9982C23.3577 9.39565 22.4883 6.87642 20.9002 4.89495L21.3506 4.95376C21.4585 4.9656 21.5663 4.93206 21.6511 4.86035C21.7359 4.78865 21.7908 4.68449 21.8042 4.57023C21.8174 4.45597 21.7881 4.34072 21.7222 4.24922C21.6565 4.15772 21.5596 4.09727 21.4523 4.08083L20.0436 3.89576C19.9895 3.8885 19.9347 3.89265 19.8822 3.908C19.8297 3.92334 19.7807 3.94955 19.7377 3.98514C19.6947 4.02074 19.6589 4.06499 19.6322 4.11536C19.6055 4.16574 19.5884 4.22123 19.5819 4.27866L19.4076 5.77562C19.3944 5.89137 19.4248 6.00801 19.4925 6.0999C19.5599 6.19178 19.6591 6.25141 19.7681 6.26564Z"
      fill="#ECEEF1"
      stroke="#ECEEF1"
      stroke-width="0.7"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <path
        d="M9.8263 6.70033C9.5067 6.73717 9.2655 7.00777 9.2655 7.32949C9.2655 7.65121 9.5067 7.92182 9.8263 7.95866C9.99422 7.96099 10.1558 7.89474 10.2738 7.7752C10.3918 7.65567 10.4559 7.4932 10.4513 7.32533C10.4468 6.98202 10.1696 6.70481 9.8263 6.70033Z"
        fill="#45576F"
      />
      <path
        d="M9.8263 9.10033C9.65986 9.09806 9.49957 9.16318 9.38186 9.28089C9.26416 9.39859 9.19904 9.55888 9.2013 9.72533V12.3253C9.2013 12.6705 9.48112 12.9503 9.8263 12.9503C10.1715 12.9503 10.4513 12.6705 10.4513 12.3253V9.74199C10.4558 9.57336 10.3919 9.41008 10.2742 9.28924C10.1565 9.1684 9.99499 9.10027 9.8263 9.10033Z"
        fill="#45576F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.8263 1.66699C5.32248 1.67159 1.67256 5.32151 1.66797 9.82533C1.66797 14.331 5.32058 17.9837 9.8263 17.9837C14.332 17.9837 17.9846 14.331 17.9846 9.82533C17.98 5.32151 14.3301 1.67159 9.8263 1.66699ZM9.8263 16.7337C6.01093 16.7337 2.91797 13.6407 2.91797 9.82533C2.91797 6.00996 6.01093 2.91699 9.8263 2.91699C13.6417 2.91699 16.7346 6.00996 16.7346 9.82533C16.73 13.6388 13.6398 16.7291 9.8263 16.7337Z"
        fill="#45576F"
      />
    </g>
  </svg>
);

export const WarningIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.82707 4.23343C7.39951 3.16447 8.5145 2.49804 9.72707 2.50009C10.9611 2.49084 12.0993 3.16412 12.6854 4.25009L17.3854 12.9501C17.943 13.9831 17.9161 15.2332 17.3147 16.2413C16.7133 17.2494 15.6259 17.8668 14.4521 17.8668H5.00207C3.8247 17.867 2.73452 17.2462 2.13406 16.2334C1.5336 15.2207 1.51194 13.9663 2.07707 12.9334L6.82707 4.23343ZM11.5604 4.84176C11.1989 4.16614 10.4933 3.74598 9.72707 3.75009C8.9721 3.75533 8.27954 4.17022 7.91874 4.83343L3.17707 13.5168C2.82292 14.1607 2.83575 14.9439 3.21081 15.5758C3.58587 16.2078 4.26721 16.5942 5.00207 16.5918H14.4521C15.1843 16.5873 15.8609 16.2002 16.2359 15.5713C16.6109 14.9423 16.6297 14.163 16.2854 13.5168L11.5604 4.84176Z"
        fill="#E22020"
      />
      <path
        d="M9.72707 12.5002C9.3819 12.5002 9.10207 12.78 9.10207 13.1252C9.10207 13.4704 9.3819 13.7502 9.72707 13.7502C9.89352 13.7525 10.0538 13.6873 10.1715 13.5696C10.2892 13.4519 10.3543 13.2916 10.3521 13.1252C10.3521 12.9602 10.286 12.8021 10.1685 12.6862C10.0511 12.5703 9.89206 12.5063 9.72707 12.5085V12.5002Z"
        fill="#E22020"
      />
      <path
        d="M9.72707 11.3585C9.38377 11.354 9.10656 11.0768 9.10207 10.7335V8.15019C9.10207 7.80501 9.3819 7.52519 9.72707 7.52519C10.0723 7.52519 10.3521 7.80501 10.3521 8.15019V10.7335C10.3521 11.0787 10.0723 11.3585 9.72707 11.3585Z"
        fill="#E22020"
      />
    </g>
  </svg>
);

export const EyeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.60341 10.1232C7.60341 8.83618 8.59702 7.79289 9.82271 7.79289C11.0484 7.79289 12.042 8.83618 12.042 10.1232C12.042 11.4101 11.0484 12.4534 9.82271 12.4534C8.59702 12.4534 7.60341 11.4101 7.60341 10.1232ZM9.05078 10.1232C9.05078 10.5708 9.39638 10.9337 9.82271 10.9337C10.249 10.9337 10.5946 10.5708 10.5946 10.1232C10.5946 9.67551 10.249 9.31262 9.82271 9.31262C9.39638 9.31262 9.05078 9.67551 9.05078 10.1232Z"
      fill="#45576F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3674 5.83749L18.4008 9.22144C18.6616 9.44063 18.8134 9.77239 18.8134 10.1232C18.8134 10.4739 18.6616 10.8057 18.4008 11.0249L14.3674 14.4088C11.7091 16.6368 7.93629 16.6368 5.27797 14.4088L1.24464 11.0249C0.983837 10.8057 0.832031 10.4739 0.832031 10.1232C0.832031 9.77239 0.983837 9.44063 1.24464 9.22144L5.27797 5.83749C7.93629 3.60951 11.7091 3.60951 14.3674 5.83749ZM6.17534 13.2741C8.31011 15.0581 11.3353 15.0581 13.4701 13.2741L17.156 10.1232L13.4701 7.02289C11.3353 5.23888 8.31011 5.23888 6.17534 7.02289L2.48937 10.1232L6.17534 13.2741Z"
      fill="#45576F"
    />
  </svg>
);

export const CloseEye = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g
      id="Group_150118"
      data-name="Group 150118"
      transform="translate(-9191 16949)"
    >
      <g
        id="Rectangle_54648"
        data-name="Rectangle 54648"
        transform="translate(9191 -16949)"
        fill="#fff"
        stroke="#707070"
        strokeWidth="1"
        opacity="0"
      >
        <rect width="24" height="24" stroke="none" />
        <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
      </g>
      <g
        id="Group_150117"
        data-name="Group 150117"
        transform="translate(9191.915 -16948.373)"
      >
        <path
          id="Path_102631"
          data-name="Path 102631"
          d="M9.2,7.717A6.071,6.071,0,0,1,11.084,7.4c3.455,0,6.5,3.36,7.414,4.479a16.888,16.888,0,0,1-1.72,1.807.608.608,0,0,0,.815.9,16.979,16.979,0,0,0,2.169-2.352.608.608,0,0,0,0-.714c-.158-.217-3.93-5.336-8.677-5.336a7.285,7.285,0,0,0-2.258.374A.608.608,0,1,0,9.2,7.717ZM3.3,3.78a.608.608,0,0,0-.8.916L6.18,7.9a17.049,17.049,0,0,0-3.773,3.62.609.609,0,0,0,0,.714c.158.218,3.93,5.336,8.677,5.336A8.484,8.484,0,0,0,15.6,16.112l3.272,2.852a.607.607,0,1,0,.8-.916Zm6.178,7L12.2,13.152a1.849,1.849,0,0,1-2.971-1.473A1.83,1.83,0,0,1,9.476,10.776Zm1.608,5.584c-3.455,0-6.5-3.36-7.413-4.479A15.9,15.9,0,0,1,7.134,8.735L8.542,9.962a3.039,3.039,0,0,0-.526,1.717A3.064,3.064,0,0,0,13.13,13.96l1.51,1.316A7.067,7.067,0,0,1,11.084,16.36Z"
          transform="translate(0 0)"
          fill="#45576f"
        />
      </g>
    </g>
  </svg>
);

export const EyeCloseIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2001_9913)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.550941 5.07374C1.01242 4.87596 1.54686 5.08973 1.74464 5.55122L0.909049 5.90932C1.74464 5.55122 1.74476 5.55151 1.74464 5.55122L1.74417 5.55012C1.74391 5.54953 1.7441 5.54996 1.74417 5.55012L1.74773 5.55818C1.75137 5.56638 1.75763 5.5803 1.76653 5.59958C1.78435 5.63814 1.8127 5.69803 1.85178 5.7762C1.93002 5.93268 2.05085 6.16156 2.21579 6.43866C2.5467 6.99458 3.04945 7.735 3.73432 8.47255C3.89574 8.6464 4.06658 8.81941 4.24702 8.98937C4.25457 8.99622 4.26203 9.00323 4.2694 9.01038C5.61911 10.2742 7.50206 11.3639 9.99996 11.3639C11.099 11.3639 12.0712 11.154 12.9281 10.8168C14.0426 10.3781 14.9769 9.71762 15.7414 8.99997C16.6047 8.18967 17.2388 7.31845 17.6575 6.64659C17.866 6.31197 18.0188 6.03039 18.1181 5.83577C18.1676 5.73856 18.2037 5.66335 18.2265 5.61442C18.2379 5.58997 18.246 5.57211 18.2508 5.56139L18.2553 5.55122C18.4532 5.08999 18.9876 4.87601 19.449 5.07374C19.9105 5.27152 20.1242 5.80595 19.9265 6.26743L19.0909 5.90932C19.9265 6.26743 19.9265 6.26722 19.9265 6.26743L19.9245 6.272L19.9212 6.27947L19.9108 6.30297C19.9022 6.32236 19.89 6.34912 19.8744 6.3827C19.8431 6.44984 19.7977 6.54436 19.7378 6.66181C19.6181 6.8965 19.44 7.22394 19.2006 7.60812C18.8346 8.19553 18.32 8.92405 17.6451 9.65868L18.3701 10.3836C18.7251 10.7386 18.7251 11.3143 18.3701 11.6693C18.015 12.0243 17.4394 12.0243 17.0844 11.6693L16.3206 10.9055C15.8076 11.3198 15.2336 11.7106 14.5961 12.0477L15.3074 13.1408C15.5812 13.5616 15.4621 14.1248 15.0412 14.3986C14.6204 14.6724 14.0573 14.5532 13.7834 14.1324L12.8876 12.7556C12.2703 12.9448 11.6109 13.0789 10.909 13.1417V14.5457C10.909 15.0478 10.502 15.4548 9.99996 15.4548C9.49788 15.4548 9.09087 15.0478 9.09087 14.5457V13.1419C8.38665 13.079 7.7274 12.9446 7.11213 12.7559L6.21649 14.1324C5.94266 14.5532 5.37953 14.6724 4.9587 14.3986C4.53786 14.1248 4.41869 13.5616 4.69252 13.1408L5.40379 12.0477C4.76732 11.7108 4.19314 11.32 3.67951 10.9053L2.91551 11.6693C2.56049 12.0243 1.98488 12.0243 1.62986 11.6693C1.27484 11.3143 1.27484 10.7386 1.62986 10.3836L2.35481 9.65868C1.58663 8.82254 1.0252 7.99318 0.653442 7.36863C0.46327 7.04914 0.321317 6.78085 0.22555 6.58932C0.177632 6.49348 0.141173 6.41665 0.115929 6.362C0.103303 6.33467 0.0934731 6.31286 0.0864079 6.29697L0.0778763 6.27762L0.0751563 6.27136L0.0741813 6.26911L0.0737899 6.2682C0.0736209 6.2678 0.0734625 6.26743 0.909049 5.90932L0.0737899 6.2682C-0.123988 5.80671 0.0894588 5.27152 0.550941 5.07374Z"
        fill="#161827"
      />
    </g>
    <defs>
      <clipPath id="clip0_2001_9913">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const NotificationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1066 15.48C20.6623 15.1 20.4065 14.5446 20.4066 13.96V9.14C20.4066 5.19 16.8266 2 12.4066 2C7.98657 2 4.40657 5.19 4.40657 9.14V13.96C4.40661 14.5446 4.15084 15.1 3.70657 15.48C2.19657 16.83 3.26657 19.13 5.40657 19.13H9.20657C9.69141 20.4804 10.9718 21.3811 12.4066 21.3811C13.8414 21.3811 15.1217 20.4804 15.6066 19.13H19.4066C21.5466 19.13 22.6166 16.83 21.1066 15.48ZM12.4066 19.88C11.8114 19.8778 11.2505 19.601 10.8866 19.13H13.8866C13.5342 19.5936 12.9888 19.87 12.4066 19.88ZM19.4166 17.63C19.7801 17.6629 20.1263 17.468 20.2866 17.14C20.3644 16.9424 20.2935 16.7173 20.1166 16.6C19.3631 15.9279 18.9275 14.9696 18.9166 13.96V9.14C18.9166 6.03 15.9966 3.5 12.4166 3.5C8.83657 3.5 5.91657 6.03 5.91657 9.14V13.96C5.9056 14.9696 5.47001 15.9279 4.71657 16.6C4.53589 16.7144 4.46065 16.9401 4.53657 17.14C4.69686 17.468 5.04301 17.6629 5.40657 17.63H19.4166Z"
      fill="#172935"
    />
  </svg>
);
export const NotificationNewIcon = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.35179 18.2418C6.19288 19.311 7.51418 20 9 20C10.4858 20 11.8071 19.311 12.6482 18.2418C10.2264 18.57 7.77357 18.57 5.35179 18.2418Z"
      fill="#878785"
    />
    <path
      d="M15.7491 7V7.7041C15.7491 8.54909 15.9903 9.37517 16.4422 10.0782L17.5496 11.8012C18.5612 13.3749 17.789 15.5139 16.0296 16.0116C11.4273 17.3134 6.57274 17.3134 1.97036 16.0116C0.211046 15.5139 -0.561177 13.3749 0.450359 11.8012L1.5578 10.0782C2.00972 9.37517 2.25087 8.54909 2.25087 7.7041V7C2.25087 3.13401 5.27256 0 9 0C12.7274 0 15.7491 3.13401 15.7491 7Z"
      fill="#878785"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.77764 8.00537L13.8413 2.95881C14.0529 2.74527 14.0529 2.39933 13.8413 2.18579C13.6335 1.96843 13.2903 1.9619 13.0745 2.1712L8.01085 7.21775L3.01226 2.1712C2.90978 2.06192 2.76719 2 2.61802 2C2.46884 2 2.32625 2.06192 2.22377 2.1712C2.0362 2.37752 2.0362 2.69416 2.22377 2.90047L7.22236 7.93973L2.15867 12.979C1.94711 13.1925 1.94711 13.5385 2.15867 13.752C2.25938 13.856 2.3979 13.914 2.54206 13.9125C2.689 13.9245 2.83468 13.8773 2.94716 13.7812L8.01085 8.73464L13.0745 13.8395C13.1753 13.9435 13.3138 14.0015 13.4579 14C13.6019 14.0007 13.7401 13.9428 13.8413 13.8395C14.0529 13.626 14.0529 13.28 13.8413 13.0665L8.77764 8.00537Z"
      fill="#172935"
    />
  </svg>
);

export const DownArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g opacity="0.6">
      <path
        d="M13.2788 5.9668L8.93208 10.3135C8.41875 10.8268 7.57875 10.8268 7.06542 10.3135L2.71875 5.9668"
        stroke="#45576F"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const MyAccountIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3159 13.9244L16.5159 14.8744C16.7054 15.6957 16.5182 16.5588 16.0056 17.2278C15.4929 17.8969 14.7082 18.3021 13.8659 18.3327H6.13252C5.29016 18.3021 4.50549 17.8969 3.99281 17.2278C3.48012 16.5588 3.29299 15.6957 3.48252 14.8744L3.68252 13.9244C3.91255 12.6384 5.01804 11.6933 6.32418 11.666H13.6742C14.9803 11.6933 16.0858 12.6384 16.3159 13.9244ZM13.8659 17.0744C14.289 17.0695 14.6872 16.8734 14.9492 16.541V16.5494C15.2706 16.1462 15.3958 15.6209 15.2909 15.116L15.0909 14.166C14.9799 13.462 14.3864 12.9348 13.6742 12.9077H6.32419C5.61199 12.9348 5.01849 13.462 4.90752 14.166L4.70752 15.116C4.60515 15.6182 4.73024 16.1399 5.04919 16.541C5.31113 16.8734 5.70936 17.0695 6.13252 17.0744H13.8659Z"
      fill="#172935"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4158 9.99936H9.5825C7.74155 9.99936 6.24917 8.50698 6.24917 6.66603V4.46603C6.24695 3.72274 6.54123 3.00926 7.06682 2.48368C7.5924 1.95809 8.30589 1.66381 9.04917 1.66603H10.9492C11.6925 1.66381 12.4059 1.95809 12.9315 2.48368C13.4571 3.00926 13.7514 3.72274 13.7492 4.46603V6.66603C13.7492 8.50698 12.2568 9.99936 10.4158 9.99936ZM9.04917 2.91603C8.19313 2.91603 7.49917 3.60999 7.49917 4.46603V6.66603C7.49917 7.81662 8.43191 8.74936 9.5825 8.74936H10.4158C11.5664 8.74936 12.4992 7.81662 12.4992 6.66603V4.46603C12.4992 4.05494 12.3359 3.66069 12.0452 3.37001C11.7545 3.07933 11.3603 2.91603 10.9492 2.91603H9.04917Z"
      fill="#172935"
    />
  </svg>
);

export const CartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.89062 3.54102H3.72396L3.76562 3.54935C4.92076 3.57176 5.93007 4.33547 6.26563 5.44102L6.43229 6.01602H15.124C15.8915 6.01951 16.6203 6.35354 17.124 6.93268C17.6262 7.51549 17.8485 8.2888 17.7323 9.04935L17.2323 12.4993C17.0658 13.8218 15.9484 14.8181 14.6156 14.8327H9.71562C8.54504 14.8283 7.51415 14.0611 7.17396 12.941L5.06562 5.83268C4.90418 5.22283 4.35479 4.79629 3.72396 4.79102H2.89062C2.54545 4.79102 2.26562 4.51119 2.26562 4.16602C2.26562 3.82084 2.54545 3.54102 2.89062 3.54102ZM8.37396 12.541C8.55086 13.1344 9.09648 13.541 9.71562 13.541H14.6156C15.3054 13.5335 15.8894 13.0304 15.999 12.3493L16.499 8.89102C16.5671 8.48846 16.456 8.07624 16.195 7.76233C15.9339 7.44842 15.5488 7.26411 15.1406 7.25768H6.80729L8.37396 12.541Z"
      fill="#172935"
    />
    <path
      d="M9.52396 15.8327C9.06372 15.8327 8.69063 16.2058 8.69063 16.666C8.69063 17.1263 9.06372 17.4993 9.52396 17.4993C9.9842 17.4993 10.3573 17.1263 10.3573 16.666C10.3573 16.2058 9.9842 15.8327 9.52396 15.8327Z"
      fill="#172935"
    />
    <path
      d="M14.524 15.8327C14.0637 15.8327 13.6906 16.2058 13.6906 16.666C13.6906 17.1263 14.0637 17.4993 14.524 17.4993C14.9842 17.4993 15.3573 17.1263 15.3573 16.666C15.3573 16.2058 14.9842 15.8327 14.524 15.8327Z"
      fill="#172935"
    />
  </svg>
);

export const LogoutIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4289 16.7029H11.3314C8.00145 16.7029 6.39641 15.3904 6.11891 12.4504C6.08891 12.1429 6.31391 11.8654 6.62891 11.8354C6.92891 11.8054 7.21391 12.0379 7.24391 12.3454C7.46141 14.7004 8.57145 15.5779 11.339 15.5779H11.4365C14.4889 15.5779 15.569 14.4979 15.569 11.4454V6.55535C15.569 3.50285 14.4889 2.42285 11.4365 2.42285H11.339C8.55645 2.42285 7.44641 3.31535 7.24391 5.71535C7.20641 6.02285 6.94391 6.25535 6.62891 6.22535C6.31391 6.20285 6.08891 5.92535 6.11141 5.61785C6.36641 2.63285 7.97895 1.29785 11.3314 1.29785H11.4289C15.1115 1.29785 16.6865 2.87285 16.6865 6.55535V11.4454C16.6865 15.1279 15.1115 16.7029 11.4289 16.7029Z"
      fill="white"
    />
    <path
      d="M11.2493 9.5625H2.71436C2.40686 9.5625 2.15186 9.3075 2.15186 9C2.15186 8.6925 2.40686 8.4375 2.71436 8.4375H11.2493C11.5568 8.4375 11.8118 8.6925 11.8118 9C11.8118 9.3075 11.5568 9.5625 11.2493 9.5625Z"
      fill="white"
    />
    <path
      d="M4.38709 12.0749C4.24459 12.0749 4.10209 12.0224 3.98959 11.9099L1.47709 9.39735C1.25959 9.17985 1.25959 8.81985 1.47709 8.60235L3.98959 6.08988C4.20709 5.87238 4.56709 5.87238 4.78459 6.08988C5.00209 6.30738 5.00209 6.66738 4.78459 6.88488L2.66959 8.99985L4.78459 11.1149C5.00209 11.3324 5.00209 11.6924 4.78459 11.9099C4.67959 12.0224 4.52959 12.0749 4.38709 12.0749Z"
      fill="white"
    />
  </svg>
);

export const ToggleIcon = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.85957e-05 15.25C6.85957e-05 15.6642 0.335855 16 0.750069 16H13.7501C14.1643 16 14.5001 15.6642 14.5001 15.25C14.5001 14.8358 14.1643 14.5 13.7501 14.5H0.750069C0.550335 14.4973 0.357987 14.5754 0.216741 14.7167C0.0754953 14.8579 -0.00264924 15.0503 6.85957e-05 15.25Z"
      fill="white"
    />
    <path
      d="M6.85957e-05 8.25C6.85957e-05 8.66421 0.335855 9 0.750069 9H13.7501C14.1643 9 14.5001 8.66421 14.5001 8.25C14.5001 7.83579 14.1643 7.5 13.7501 7.5H0.750069C0.550335 7.49728 0.357987 7.57543 0.216741 7.71667C0.0754953 7.85792 -0.00264924 8.05027 6.85957e-05 8.25Z"
      fill="white"
    />
    <path
      d="M6.85957e-05 1.25C6.85957e-05 1.66421 0.335855 2 0.750069 2H13.7501C14.1643 2 14.5001 1.66421 14.5001 1.25C14.5001 0.835785 14.1643 0.499998 13.7501 0.499998H0.750069C0.550335 0.49728 0.357987 0.575425 0.216741 0.716671C0.0754953 0.857917 -0.00264924 1.05027 6.85957e-05 1.25Z"
      fill="white"
    />
  </svg>
);

export const ToggleIconClose = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1665 9.00805L17.762 1.43822C18.0793 1.11791 18.0793 0.598995 17.762 0.278681C17.4503 -0.0473594 16.9355 -0.0571515 16.6118 0.256802L9.01628 7.82663L1.51839 0.256802C1.36467 0.0928811 1.15078 0 0.927025 0C0.703266 0 0.489378 0.0928811 0.335658 0.256802C0.0543006 0.566276 0.0543006 1.04123 0.335658 1.35071L7.83354 8.9096L0.238001 16.4685C-0.0793336 16.7888 -0.0793336 17.3077 0.238001 17.628C0.389074 17.784 0.596845 17.871 0.813092 17.8687C1.03351 17.8867 1.25202 17.8159 1.42074 17.6718L9.01628 10.102L16.6118 17.7593C16.7629 17.9153 16.9707 18.0022 17.1869 18C17.4029 18.001 17.6102 17.9142 17.762 17.7593C18.0793 17.439 18.0793 16.9201 17.762 16.5998L10.1665 9.00805Z"
      fill="white"
    />
  </svg>
);

export const NoOptionsMessageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.31437 13.7668C7.38937 13.8418 7.48312 13.8755 7.58062 13.8755C7.67812 13.8755 7.77188 13.838 7.84688 13.7668C7.99313 13.6205 7.99313 13.3843 7.84688 13.238L7.09688 12.488L7.84688 11.738C7.99313 11.5918 7.99313 11.3555 7.84688 11.2093C7.70063 11.063 7.46438 11.063 7.31813 11.2093L6.56813 11.9593L5.81813 11.2093C5.67188 11.063 5.43563 11.063 5.28938 11.2093C5.14312 11.3555 5.14312 11.5918 5.28938 11.738L6.03938 12.488L5.28938 13.238C5.14312 13.3843 5.14312 13.6205 5.28938 13.7668C5.36438 13.8418 5.45813 13.8755 5.55563 13.8755C5.65313 13.8755 5.74688 13.838 5.82188 13.7668L6.57188 13.0168L7.32188 13.7668H7.31437Z"
      fill="#45576F"
    />
    <path
      d="M14.218 11.2054C14.0717 11.0591 13.8355 11.0591 13.6892 11.2054L12.9392 11.9554L12.1892 11.2054C12.043 11.0591 11.8067 11.0591 11.6605 11.2054C11.5142 11.3516 11.5142 11.5879 11.6605 11.7341L12.4105 12.4841L11.6605 13.2341C11.5142 13.3804 11.5142 13.6166 11.6605 13.7629C11.7355 13.8379 11.8292 13.8716 11.9267 13.8716C12.0242 13.8716 12.118 13.8341 12.193 13.7629L12.943 13.0129L13.693 13.7629C13.768 13.8379 13.8617 13.8716 13.9592 13.8716C14.0567 13.8716 14.1505 13.8341 14.2255 13.7629C14.3717 13.6166 14.3717 13.3804 14.2255 13.2341L13.4755 12.4841L14.2255 11.7341C14.3717 11.5879 14.3717 11.3516 14.2255 11.2054H14.218Z"
      fill="#45576F"
    />
    <path
      d="M20.25 12.75C19.6313 12.75 19.125 13.2563 19.125 13.875C19.125 14.4937 19.6313 15 20.25 15C20.8687 15 21.375 14.4937 21.375 13.875C21.375 13.2563 20.8687 12.75 20.25 12.75ZM20.25 14.25C20.0437 14.25 19.875 14.0812 19.875 13.875C19.875 13.6687 20.0437 13.5 20.25 13.5C20.4562 13.5 20.625 13.6687 20.625 13.875C20.625 14.0812 20.4562 14.25 20.25 14.25Z"
      fill="#45576F"
    />
    <path
      d="M7.2731 16.5744C7.1081 16.6981 7.0706 16.9344 7.19435 17.0994C7.3181 17.2644 7.55435 17.3019 7.71935 17.1781C9.08435 16.1656 10.4081 16.1656 11.7731 17.1781C11.8406 17.2269 11.9194 17.2531 11.9981 17.2531C12.1144 17.2531 12.2269 17.2006 12.2981 17.1031C12.4219 16.9381 12.3881 16.7019 12.2194 16.5781C10.5769 15.3594 8.91185 15.3594 7.2731 16.5781V16.5744Z"
      fill="#45576F"
    />
    <path
      d="M3.91797 6.375H17.3617C17.568 6.375 17.7367 6.20625 17.7367 6C17.7367 5.79375 17.568 5.625 17.3617 5.625H3.91797C3.71172 5.625 3.54297 5.79375 3.54297 6C3.54297 6.20625 3.71172 6.375 3.91797 6.375Z"
      fill="#45576F"
    />
    <path
      d="M21.75 10.875V8.25C21.75 7.63125 21.2437 7.125 20.625 7.125H19.875V5.25C19.875 4.63125 19.3687 4.125 18.75 4.125H3C1.965 4.125 1.125 4.965 1.125 6V19.125C1.125 20.16 1.965 21 3 21H20.625C21.2437 21 21.75 20.4937 21.75 19.875V16.875C22.3687 16.875 22.875 16.3687 22.875 15.75V12C22.875 11.3812 22.3687 10.875 21.75 10.875ZM3 4.875H18.75C18.9562 4.875 19.125 5.04375 19.125 5.25V7.125H3C2.38125 7.125 1.875 6.61875 1.875 6C1.875 5.38125 2.38125 4.875 3 4.875ZM21 19.875C21 20.0813 20.8312 20.25 20.625 20.25H3C2.38125 20.25 1.875 19.7437 1.875 19.125V7.48875C2.19 7.725 2.57625 7.875 3 7.875H20.625C20.8312 7.875 21 8.04375 21 8.25V10.875H19.5C18.465 10.875 17.625 11.715 17.625 12.75V15C17.625 16.035 18.465 16.875 19.5 16.875H21V19.875ZM22.125 15.75C22.125 15.9563 21.9562 16.125 21.75 16.125H19.5C18.8813 16.125 18.375 15.6187 18.375 15V12.75C18.375 12.1313 18.8813 11.625 19.5 11.625H21.75C21.9562 11.625 22.125 11.7937 22.125 12V15.75Z"
      fill="#45576F"
    />
  </svg>
);

export const RightUpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
  >
    <path
      d="M1.12521 10.1244L9.37479 1.87479M9.37479 1.87479H1.12521M9.37479 1.87479V10.1244"
      stroke="#12B76A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NoContentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.31437 13.7668C7.38937 13.8418 7.48312 13.8755 7.58062 13.8755C7.67812 13.8755 7.77188 13.838 7.84688 13.7668C7.99313 13.6205 7.99313 13.3843 7.84688 13.238L7.09688 12.488L7.84688 11.738C7.99313 11.5918 7.99313 11.3555 7.84688 11.2093C7.70063 11.063 7.46438 11.063 7.31813 11.2093L6.56813 11.9593L5.81813 11.2093C5.67188 11.063 5.43563 11.063 5.28938 11.2093C5.14312 11.3555 5.14312 11.5918 5.28938 11.738L6.03938 12.488L5.28938 13.238C5.14312 13.3843 5.14312 13.6205 5.28938 13.7668C5.36438 13.8418 5.45813 13.8755 5.55563 13.8755C5.65313 13.8755 5.74688 13.838 5.82188 13.7668L6.57188 13.0168L7.32188 13.7668H7.31437Z"
      fill="#45576F"
    />
    <path
      d="M14.218 11.2054C14.0717 11.0591 13.8355 11.0591 13.6892 11.2054L12.9392 11.9554L12.1892 11.2054C12.043 11.0591 11.8067 11.0591 11.6605 11.2054C11.5142 11.3516 11.5142 11.5879 11.6605 11.7341L12.4105 12.4841L11.6605 13.2341C11.5142 13.3804 11.5142 13.6166 11.6605 13.7629C11.7355 13.8379 11.8292 13.8716 11.9267 13.8716C12.0242 13.8716 12.118 13.8341 12.193 13.7629L12.943 13.0129L13.693 13.7629C13.768 13.8379 13.8617 13.8716 13.9592 13.8716C14.0567 13.8716 14.1505 13.8341 14.2255 13.7629C14.3717 13.6166 14.3717 13.3804 14.2255 13.2341L13.4755 12.4841L14.2255 11.7341C14.3717 11.5879 14.3717 11.3516 14.2255 11.2054H14.218Z"
      fill="#45576F"
    />
    <path
      d="M20.25 12.75C19.6313 12.75 19.125 13.2563 19.125 13.875C19.125 14.4937 19.6313 15 20.25 15C20.8687 15 21.375 14.4937 21.375 13.875C21.375 13.2563 20.8687 12.75 20.25 12.75ZM20.25 14.25C20.0437 14.25 19.875 14.0812 19.875 13.875C19.875 13.6687 20.0437 13.5 20.25 13.5C20.4562 13.5 20.625 13.6687 20.625 13.875C20.625 14.0812 20.4562 14.25 20.25 14.25Z"
      fill="#45576F"
    />
    <path
      d="M7.2731 16.5744C7.1081 16.6981 7.0706 16.9344 7.19435 17.0994C7.3181 17.2644 7.55435 17.3019 7.71935 17.1781C9.08435 16.1656 10.4081 16.1656 11.7731 17.1781C11.8406 17.2269 11.9194 17.2531 11.9981 17.2531C12.1144 17.2531 12.2269 17.2006 12.2981 17.1031C12.4219 16.9381 12.3881 16.7019 12.2194 16.5781C10.5769 15.3594 8.91185 15.3594 7.2731 16.5781V16.5744Z"
      fill="#45576F"
    />
    <path
      d="M3.91797 6.375H17.3617C17.568 6.375 17.7367 6.20625 17.7367 6C17.7367 5.79375 17.568 5.625 17.3617 5.625H3.91797C3.71172 5.625 3.54297 5.79375 3.54297 6C3.54297 6.20625 3.71172 6.375 3.91797 6.375Z"
      fill="#45576F"
    />
    <path
      d="M21.75 10.875V8.25C21.75 7.63125 21.2437 7.125 20.625 7.125H19.875V5.25C19.875 4.63125 19.3687 4.125 18.75 4.125H3C1.965 4.125 1.125 4.965 1.125 6V19.125C1.125 20.16 1.965 21 3 21H20.625C21.2437 21 21.75 20.4937 21.75 19.875V16.875C22.3687 16.875 22.875 16.3687 22.875 15.75V12C22.875 11.3812 22.3687 10.875 21.75 10.875ZM3 4.875H18.75C18.9562 4.875 19.125 5.04375 19.125 5.25V7.125H3C2.38125 7.125 1.875 6.61875 1.875 6C1.875 5.38125 2.38125 4.875 3 4.875ZM21 19.875C21 20.0813 20.8312 20.25 20.625 20.25H3C2.38125 20.25 1.875 19.7437 1.875 19.125V7.48875C2.19 7.725 2.57625 7.875 3 7.875H20.625C20.8312 7.875 21 8.04375 21 8.25V10.875H19.5C18.465 10.875 17.625 11.715 17.625 12.75V15C17.625 16.035 18.465 16.875 19.5 16.875H21V19.875ZM22.125 15.75C22.125 15.9563 21.9562 16.125 21.75 16.125H19.5C18.8813 16.125 18.375 15.6187 18.375 15V12.75C18.375 12.1313 18.8813 11.625 19.5 11.625H21.75C21.9562 11.625 22.125 11.7937 22.125 12V15.75Z"
      fill="#45576F"
    />
  </svg>
);

export const DownArrowTable = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g opacity="0.6">
      <path
        d="M7.9987 3.33398V12.6673M7.9987 12.6673L12.6654 8.00065M7.9987 12.6673L3.33203 8.00065"
        stroke="#45576F"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const GoldSTBLIcon = () => (
  <svg
    width="146"
    height="159"
    viewBox="0 0 146 159"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M145.055 56.5593V52.7312C145.055 48.8911 144.068 45.1184 142.192 41.7926C140.317 38.4668 137.619 35.7051 134.37 33.785L83.6804 3.83302C80.432 1.91311 76.747 0.902344 72.996 0.902344C69.245 0.902344 65.56 1.91311 62.3116 3.83302L11.6219 33.7932C8.37314 35.7133 5.67541 38.4751 3.79988 41.8008C1.92435 45.1266 0.937126 48.8993 0.9375 52.7395V57.8773L7.74615 61.2788V54.9516C7.74576 51.6613 8.59181 48.4289 10.1992 45.5796C11.8066 42.7304 14.1186 40.3646 16.9027 38.7205L61.9937 12.0716V24.8847L18.5989 50.5438V110.481L61.9937 136.129V148.942L16.9027 122.298C14.1184 120.653 11.8063 118.286 10.1989 115.436C8.59158 112.586 7.74563 109.353 7.74615 106.062V70.3842L0.9375 66.9827V108.271C0.937126 112.111 1.92435 115.884 3.79988 119.21C5.67541 122.536 8.37314 125.297 11.6219 127.217L62.2555 157.139C63.2889 157.749 64.3699 158.271 65.4875 158.698V10.0017L68.3937 8.2845C69.8269 7.43656 71.4528 6.98957 73.1082 6.98842H73.1403C74.9382 6.98977 76.6985 7.51521 78.2154 8.50326L80.5018 10.0017V158.703C81.6222 158.28 82.7052 157.759 83.7392 157.148L134.367 127.226C137.616 125.306 140.314 122.544 142.189 119.218C144.065 115.892 145.052 112.12 145.052 108.279V65.6975L138.243 69.1755V106.051C138.244 109.341 137.398 112.574 135.792 115.424C134.186 118.274 131.875 120.641 129.092 122.287L84.001 148.936V136.129L127.39 110.47V50.5438L84.001 24.8902V12.0716L129.089 38.7205C131.872 40.3658 134.183 42.7319 135.789 45.581C137.395 48.4301 138.241 51.6619 138.24 54.9516V60.0347L145.055 56.5593ZM61.983 92.6116L25.5892 70.4416V54.6863L61.983 33.178V92.6116ZM101.272 78.9399L109.433 83.9109L120.384 90.5827V106.324L83.9956 127.833V68.4072L101.272 78.9399Z"
      fill="white"
    />
  </svg>
);

export const STBLIcon = () => (
  <svg
    width="146"
    height="159"
    viewBox="0 0 146 159"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M145.055 56.5593V52.7312C145.055 48.8911 144.068 45.1184 142.193 41.7926C140.317 38.4668 137.619 35.7051 134.371 33.785L83.681 3.83302C80.4325 1.91311 76.7476 0.902344 72.9966 0.902344C69.2455 0.902344 65.5606 1.91311 62.3121 3.83302L11.6225 33.7932C8.37369 35.7133 5.67595 38.4751 3.80043 41.8008C1.9249 45.1266 0.937676 48.8993 0.938049 52.7395V57.8773L7.7467 61.2788V54.9516C7.74631 51.6613 8.59235 48.4289 10.1997 45.5796C11.8071 42.7304 14.1192 40.3646 16.9033 38.7205L61.9943 12.0716V24.8847L18.5995 50.5438V110.481L61.9943 136.129V148.942L16.9033 122.298C14.1189 120.653 11.8068 118.286 10.1995 115.436C8.59213 112.586 7.74618 109.353 7.7467 106.062V70.3842L0.938049 66.9827V108.271C0.937676 112.111 1.9249 115.884 3.80043 119.21C5.67595 122.536 8.37369 125.297 11.6225 127.217L62.256 157.139C63.2895 157.749 64.3705 158.271 65.488 158.698V10.0017L68.3942 8.2845C69.8274 7.43656 71.4534 6.98957 73.1087 6.98842H73.1408C74.9387 6.98977 76.6991 7.51521 78.2159 8.50326L80.5024 10.0017V158.703C81.6228 158.28 82.7058 157.759 83.7397 157.148L134.368 127.226C137.617 125.306 140.314 122.544 142.19 119.218C144.066 115.892 145.053 112.12 145.052 108.279V65.6975L138.244 69.1755V106.051C138.244 109.341 137.399 112.574 135.793 115.424C134.186 118.274 131.875 120.641 129.092 122.287L84.0015 148.936V136.129L127.391 110.47V50.5438L84.0015 24.8902V12.0716L129.09 38.7205C131.873 40.3658 134.183 42.7319 135.79 45.581C137.396 48.4301 138.241 51.6619 138.241 54.9516V60.0347L145.055 56.5593ZM61.9836 92.6116L25.5897 70.4416V54.6863L61.9836 33.178V92.6116ZM101.273 78.9399L109.433 83.9109L120.385 90.5827V106.324L83.9962 127.833V68.4072L101.273 78.9399Z"
      fill="url(#paint0_linear_1199_19318)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1199_19318"
        x1="72.9966"
        y1="-5.68251"
        x2="72.9966"
        y2="165.096"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B16D17" />
        <stop offset="0.14" stop-color="#F1AA36" />
        <stop offset="0.27" stop-color="#FCD74E" />
        <stop offset="0.41" stop-color="#F1AA36" />
        <stop offset="0.53" stop-color="#E38C05" />
        <stop offset="0.65" stop-color="#FCD74E" />
        <stop offset="0.77" stop-color="#F1AA36" />
        <stop offset="0.87" stop-color="#B16D17" />
        <stop offset="1" stop-color="#F1AA36" />
      </linearGradient>
    </defs>
  </svg>
);

export const DownArrowChevron = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0008 16.7508C11.8018 16.7518 11.6107 16.6725 11.4708 16.5308L3.47082 8.53082C3.19546 8.23531 3.20359 7.77481 3.4892 7.4892C3.77481 7.20359 4.23531 7.19546 4.53082 7.47082L12.0008 14.9408L19.4708 7.47082C19.7663 7.19546 20.2268 7.20359 20.5124 7.4892C20.7981 7.77481 20.8062 8.23531 20.5308 8.53082L12.5308 16.5308C12.3909 16.6725 12.1999 16.7518 12.0008 16.7508Z"
      fill="white"
    />
  </svg>
);

export const LeftArrowIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.12549 16.266C9.2449 16.3787 9.40297 16.4413 9.56716 16.441C9.73074 16.4424 9.8876 16.376 10.0005 16.2577C10.1196 16.1416 10.1868 15.9823 10.1868 15.816C10.1868 15.6497 10.1196 15.4904 10.0005 15.3743L5.25044 10.6243H16.2673C16.6125 10.6243 16.8923 10.3444 16.8923 9.99927C16.8923 9.65409 16.6125 9.37427 16.2673 9.37427H5.24861L10.0088 4.59932C10.1279 4.48325 10.1951 4.32398 10.1951 4.15765C10.1951 3.99133 10.1279 3.83206 10.0088 3.71599C9.76481 3.47228 9.36951 3.47228 9.12549 3.71599L3.29216 9.54932C3.04845 9.79333 3.04845 10.1886 3.29216 10.4327L9.12549 16.266Z"
      fill="white"
    />
  </svg>
);

export const WalletIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.8275 10.67C21.7746 10.6666 21.717 10.6666 21.6573 10.6667L21.6424 10.6667H19.3012C17.3713 10.6667 15.7201 12.1857 15.7201 14.1667C15.7201 16.1476 17.3713 17.6667 19.3012 17.6667H21.6424L21.6573 17.6667C21.717 17.6667 21.7746 17.6667 21.8275 17.6634C22.6114 17.6139 23.3046 17.0005 23.3629 16.1437C23.3667 16.0875 23.3667 16.0269 23.3667 15.9708L23.3666 15.9556V12.3778L23.3667 12.3626C23.3667 12.3064 23.3667 12.2459 23.3629 12.1897C23.3046 11.3329 22.6114 10.7195 21.8275 10.67ZM19.0936 15.1C19.5904 15.1 19.9932 14.6821 19.9932 14.1667C19.9932 13.6512 19.5904 13.2333 19.0936 13.2333C18.5967 13.2333 18.194 13.6512 18.194 14.1667C18.194 14.6821 18.5967 15.1 19.0936 15.1Z"
      fill="#878785"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.6567 19.0667C21.7959 19.0631 21.9012 19.192 21.8634 19.3259C21.6761 19.9909 21.3787 20.5576 20.9015 21.0348C20.203 21.7333 19.3173 22.0433 18.2231 22.1904C17.1598 22.3334 15.8012 22.3333 14.086 22.3333H12.114C10.3988 22.3333 9.04018 22.3334 7.97691 22.1904C6.88265 22.0433 5.99697 21.7333 5.29849 21.0348C4.60002 20.3364 4.29005 19.4507 4.14293 18.3564C3.99997 17.2932 3.99999 15.9346 4 14.2193V14.114C3.99999 12.3988 3.99997 11.0402 4.14293 9.97691C4.29005 8.88265 4.60002 7.99697 5.29849 7.29849C5.99697 6.60002 6.88265 6.29005 7.97691 6.14293C9.04018 5.99997 10.3988 5.99999 12.114 6L14.086 6C15.8012 5.99999 17.1598 5.99997 18.2231 6.14293C19.3173 6.29005 20.203 6.60002 20.9015 7.29849C21.3787 7.77569 21.6761 8.34243 21.8634 9.00737C21.9012 9.14137 21.7959 9.27028 21.6567 9.26667L19.3011 9.26667C16.6535 9.26667 14.32 11.3582 14.32 14.1667C14.32 16.9752 16.6535 19.0667 19.3011 19.0667L21.6567 19.0667ZM7.5 9.73333C7.1134 9.73333 6.8 10.0467 6.8 10.4333C6.8 10.8199 7.1134 11.1333 7.5 11.1333H11.2333C11.6199 11.1333 11.9333 10.8199 11.9333 10.4333C11.9333 10.0467 11.6199 9.73333 11.2333 9.73333H7.5Z"
      fill="#878785"
    />
  </svg>
);

export const ShoppingCartIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.3125 2.83301H2.97917L3.0125 2.83967C3.93661 2.8576 4.74406 3.46857 5.0125 4.35301L5.14583 4.81301H12.0992C12.7132 4.8158 13.2962 5.08303 13.6992 5.54634C14.101 6.01259 14.2788 6.63124 14.1858 7.23967L13.7858 9.99967C13.6526 11.0576 12.7587 11.8547 11.6925 11.8663H7.7725C6.83603 11.8629 6.01132 11.2491 5.73917 10.353L4.0525 4.66634C3.92334 4.17846 3.48384 3.83723 2.97917 3.83301H2.3125C2.03636 3.83301 1.8125 3.60915 1.8125 3.33301C1.8125 3.05687 2.03636 2.83301 2.3125 2.83301ZM6.69917 10.033C6.84068 10.5077 7.27718 10.833 7.7725 10.833H11.6925C12.2443 10.827 12.7116 10.4245 12.7992 9.87967L13.1992 7.11301C13.2536 6.79096 13.1648 6.46119 12.956 6.21006C12.7471 5.95894 12.4391 5.81149 12.1125 5.80634H5.44583L6.69917 10.033Z"
      fill="#45576F"
    />
    <path
      d="M7.61917 12.6663C7.25098 12.6663 6.9525 12.9648 6.9525 13.333C6.9525 13.7012 7.25098 13.9997 7.61917 13.9997C7.98736 13.9997 8.28583 13.7012 8.28583 13.333C8.28583 12.9648 7.98736 12.6663 7.61917 12.6663Z"
      fill="#45576F"
    />
    <path
      d="M11.6192 12.6663C11.251 12.6663 10.9525 12.9648 10.9525 13.333C10.9525 13.7012 11.251 13.9997 11.6192 13.9997C11.9874 13.9997 12.2858 13.7012 12.2858 13.333C12.2858 12.9648 11.9874 12.6663 11.6192 12.6663Z"
      fill="#45576F"
    />
  </svg>
);

export const TickIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="79"
    height="80"
    viewBox="0 0 79 80"
    fill="none"
  >
    <path
      d="M28.7959 79.2585C27.8548 79.679 26.7484 79.3154 26.2401 78.4187L20.6597 68.5724C20.3841 68.0862 19.9176 67.7374 19.3732 67.6107L8.83127 65.1565C7.85952 64.9303 7.20314 64.0224 7.29286 63.0287L8.33454 51.4923C8.38227 50.9637 8.21791 50.4378 7.87765 50.0304L0.570831 41.2821C-0.049153 40.5398 -0.049153 39.4602 0.570831 38.7179L7.87765 29.9696C8.21791 29.5622 8.38227 29.0363 8.33454 28.5077L7.29286 16.9713C7.20314 15.9776 7.85952 15.0697 8.83128 14.8435L19.3732 12.3893C19.9176 12.2626 20.3841 11.9138 20.6597 11.4276L26.2401 1.58134C26.7484 0.684617 27.8548 0.321003 28.7959 0.741457L38.6842 5.15931C39.2033 5.39126 39.7967 5.39126 40.3158 5.15931L50.2041 0.741457C51.1452 0.321002 52.2517 0.684619 52.7599 1.58135L58.3403 11.4276C58.6159 11.9138 59.0824 12.2626 59.6268 12.3893L70.1687 14.8435C71.1405 15.0697 71.7969 15.9776 71.7071 16.9713L70.6655 28.5077C70.6177 29.0363 70.7821 29.5622 71.1224 29.9696L78.4292 38.7179C79.0492 39.4602 79.0492 40.5398 78.4292 41.2821L71.1224 50.0304C70.7821 50.4378 70.6177 50.9637 70.6655 51.4923L71.7071 63.0287C71.7969 64.0224 71.1405 64.9303 70.1687 65.1565L59.6268 67.6107C59.0824 67.7374 58.6159 68.0862 58.3403 68.5724L52.7599 78.4187C52.2517 79.3154 51.1452 79.679 50.2041 79.2585L40.3158 74.8407C39.7967 74.6087 39.2033 74.6087 38.6842 74.8407L28.7959 79.2585ZM34.2351 52.0082C35.023 52.8336 36.3407 52.8336 37.1285 52.0082L54.932 33.3569C55.6604 32.5939 55.6709 31.3963 54.956 30.6206L52.5814 28.0441C51.7988 27.1949 50.4615 27.1832 49.6641 28.0186L37.1116 41.1688C36.3301 41.9875 35.0256 41.9952 34.2345 41.1857L29.3109 36.1476C28.5199 35.3382 27.2153 35.3458 26.4339 36.1645L24.0909 38.619C23.3532 39.3919 23.3532 40.6081 24.0909 41.381L34.2351 52.0082Z"
      fill="#0E61D1"
    />
  </svg>
);

export const LocationIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.4">
      <path
        d="M14.017 12.9035C13.7129 12.7507 13.3425 12.8692 13.1837 13.1702C13.0369 13.4767 13.1582 13.8445 13.4587 14.0035C14.192 14.3785 14.6087 14.8368 14.6087 15.2785C14.6087 16.2202 12.642 17.2702 10.0087 17.2702C7.37533 17.2702 5.40033 16.2285 5.40033 15.3118C5.40033 14.8785 5.81699 14.4118 6.55033 14.0368C6.77024 13.9487 6.92139 13.7437 6.94065 13.5075C6.95992 13.2714 6.84399 13.0447 6.64127 12.922C6.43856 12.7993 6.18391 12.8019 5.98366 12.9285C4.97191 13.3098 4.26656 14.2352 4.16699 15.3118C4.16699 17.1618 6.66699 18.5535 10.0003 18.5535C13.3337 18.5535 15.8337 17.1618 15.8337 15.3118C15.7433 14.2259 15.0364 13.2887 14.017 12.9035Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.37533 15.6785V12.0785C6.63107 11.7479 4.6191 9.33709 4.78471 6.57795C4.95033 3.81882 7.23622 1.66602 10.0003 1.66602C12.7644 1.66602 15.0503 3.81882 15.2159 6.57795C15.3816 9.33709 13.3696 11.7479 10.6253 12.0785V15.6785C10.6253 16.0237 10.3455 16.3035 10.0003 16.3035C9.65515 16.3035 9.37533 16.0237 9.37533 15.6785ZM13.6872 5.36696C13.0685 3.87773 11.6129 2.90846 10.0003 2.91183C7.8069 2.91642 6.02991 4.6934 6.02533 6.88683C6.02196 8.49945 6.99123 9.955 8.48045 10.5737C9.96968 11.1924 11.685 10.8521 12.8253 9.7118C13.9656 8.5715 14.3059 6.85618 13.6872 5.36696Z"
        fill="white"
      />
      <path
        d="M7.99199 7.81183C8.33717 7.81183 8.61699 7.53201 8.61699 7.18683C8.61699 6.22954 9.39303 5.4535 10.3503 5.4535C10.6955 5.4535 10.9753 5.17368 10.9753 4.8285C10.9753 4.48332 10.6955 4.2035 10.3503 4.2035C9.55689 4.20571 8.79682 4.52302 8.23734 5.08563C7.67785 5.64824 7.36478 6.41006 7.36699 7.2035C7.36919 7.36706 7.43627 7.52304 7.55349 7.63713C7.6707 7.75121 7.82844 7.81406 7.99199 7.81183Z"
        fill="white"
      />
    </g>
  </svg>
);

export const badgeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Logo"
      d="M23.2942 8.46488V7.88267C23.2942 7.29861 23.1395 6.72483 22.8455 6.21901C22.5516 5.71319 22.1287 5.29315 21.6195 5.00113L13.6747 0.445727C13.1655 0.153727 12.588 0 12.0001 0C11.4121 0 10.8346 0.153727 10.3254 0.445727L2.38056 5.00238C1.87136 5.2944 1.44853 5.71444 1.15457 6.22026C0.860607 6.72608 0.705874 7.29986 0.705933 7.88392V8.66533L1.77309 9.18267V8.22036C1.77303 7.71994 1.90563 7.22833 2.15757 6.79498C2.4095 6.36163 2.77188 6.00183 3.20825 5.75177L10.2756 1.69873V3.64748L3.4741 7.54998V16.6658L10.2756 20.5666V22.5154L3.20825 18.4631C2.77184 18.2129 2.40946 17.853 2.15753 17.4195C1.9056 16.986 1.77301 16.4943 1.77309 15.9937V10.5675L0.705933 10.0502V16.3298C0.705874 16.9138 0.860607 17.4876 1.15457 17.9934C1.44853 18.4992 1.87136 18.9193 2.38056 19.2113L10.3166 23.7621C10.4786 23.8549 10.648 23.9342 10.8232 23.9992V1.38392L11.2787 1.12275C11.5033 0.99379 11.7582 0.925808 12.0176 0.925633H12.0227C12.3045 0.925838 12.5804 1.00575 12.8181 1.15603L13.1765 1.38392V24C13.3521 23.9356 13.5218 23.8564 13.6839 23.7634L21.6191 19.2125C22.1283 18.9205 22.5512 18.5005 22.8451 17.9947C23.1391 17.4888 23.2938 16.9151 23.2937 16.331V9.8547L22.2266 10.3837V15.9921C22.2267 16.4925 22.0942 16.9841 21.8424 17.4176C21.5906 17.8511 21.2285 18.2111 20.7923 18.4615L13.7249 22.5145V20.5666L20.5256 16.6641V7.54998L13.7249 3.64832V1.69873L20.7919 5.75177C21.228 6.002 21.5902 6.36186 21.8419 6.79519C22.0937 7.22851 22.2262 7.72004 22.2262 8.22036V8.99345L23.2942 8.46488ZM10.2739 13.9481L4.56972 10.5762V8.18001L10.2739 4.90881V13.9481ZM16.432 11.8688L17.711 12.6248L19.4274 13.6395V16.0337L13.7241 19.3049V10.2668L16.432 11.8688Z"
      fill="url(#paint0_linear_1947_6425)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1947_6425"
        x1="11.9998"
        y1="-1.00098"
        x2="11.9998"
        y2="24.9703"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.03" stop-color="#E1E1E1" />
        <stop offset="0.06" stop-color="#C1C1C1" />
        <stop offset="0.1" stop-color="#A7A7A7" />
        <stop offset="0.14" stop-color="#929292" />
        <stop offset="0.19" stop-color="#848484" />
        <stop offset="0.25" stop-color="#7C7C7C" />
        <stop offset="0.34" stop-color="#797979" />
        <stop offset="0.39" stop-color="#7C7C7C" />
        <stop offset="0.44" stop-color="#878787" />
        <stop offset="0.48" stop-color="#999999" />
        <stop offset="0.52" stop-color="#B3B3B3" />
        <stop offset="0.56" stop-color="#D4D4D4" />
        <stop offset="0.6" stop-color="white" />
        <stop offset="0.64" stop-color="#F9F9F9" />
        <stop offset="0.68" stop-color="#E9E9E9" />
        <stop offset="0.72" stop-color="#CFCFCF" />
        <stop offset="0.77" stop-color="#AAAAAA" />
        <stop offset="0.82" stop-color="#797979" />
        <stop offset="0.88" stop-color="#7C7C7C" />
        <stop offset="0.93" stop-color="#878787" />
        <stop offset="0.98" stop-color="#999999" />
        <stop offset="1" stop-color="#A3A3A3" />
      </linearGradient>
    </defs>
  </svg>
);
export const FilterIcon = () => (
  <svg
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7691 4.61792C11.6701 4.59628 12.4749 4.04908 12.8263 3.21925C12.9013 3.25087 12.9815 3.2683 13.0629 3.27067H17.1771C17.6032 3.27067 17.9486 2.92534 17.9486 2.49935C17.9486 2.07336 17.6032 1.72802 17.1771 1.72802H13.1143C13.0699 1.72221 13.025 1.72221 12.9806 1.72802C12.686 0.570625 11.5523 -0.166973 10.3746 0.0324988C9.19695 0.231971 8.3695 1.30174 8.47256 2.49158C8.57563 3.68142 9.5747 4.59301 10.7691 4.58707V4.61792ZM10.7691 1.58404C11.1838 1.58404 11.52 1.92017 11.52 2.3348C11.52 2.74943 11.1838 3.08556 10.7691 3.08556C10.3545 3.08556 10.0183 2.74943 10.0183 2.3348C10.0183 1.92017 10.3545 1.58404 10.7691 1.58404Z"
      fill="#45576F"
    />
    <path
      d="M0.771429 1.72802H6.94286C7.36891 1.72802 7.71429 2.07336 7.71429 2.49935C7.71429 2.92534 7.36891 3.27067 6.94286 3.27067H0.771429C0.34538 3.27067 0 2.92534 0 2.49935C0 2.07336 0.34538 1.72802 0.771429 1.72802Z"
      fill="#45576F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.736 9.95549C3.05818 9.04436 3.91918 8.43473 4.88571 8.43341V8.41284C6.04884 8.41136 7.02895 9.28058 7.1663 10.4354C7.30366 11.5902 6.55477 12.6651 5.42374 12.9364C4.29271 13.2077 3.13762 12.5896 2.736 11.4981H0.771429C0.34538 11.4981 0 11.1528 0 10.7268C0 10.3008 0.34538 9.95549 0.771429 9.95549H2.736ZM4.1361 10.7809C4.14317 11.19 4.47652 11.5181 4.88571 11.5187V11.4776C5.3004 11.4776 5.63657 11.1414 5.63657 10.7268C5.61415 10.3183 5.26871 10.0029 4.85978 10.0177C4.45086 10.0324 4.12903 10.3718 4.1361 10.7809Z"
      fill="#45576F"
    />
    <path
      d="M9 9.95549H17.2286C17.6546 9.95549 18 10.3008 18 10.7268C18 11.1528 17.6546 11.4981 17.2286 11.4981H9C8.57395 11.4981 8.22857 11.1528 8.22857 10.7268C8.22857 10.3008 8.57395 9.95549 9 9.95549Z"
      fill="#45576F"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.44 0H10.56C15.7736 0 20 4.22643 20 9.44V10.56C20 15.7736 15.7736 20 10.56 20H9.44C4.22643 20 0 15.7736 0 10.56V9.44C0 4.22643 4.22643 0 9.44 0ZM10.56 18.5C14.9315 18.4673 18.4673 14.9315 18.5 10.56V9.44C18.4673 5.06846 14.9315 1.53267 10.56 1.5H9.44C5.06846 1.53267 1.53267 5.06846 1.5 9.44V10.56C1.53267 14.9315 5.06846 18.4673 9.44 18.5H10.56Z"
      fill="#45576F"
    />
    <path
      d="M14 9.25H10.75V6C10.75 5.58579 10.4142 5.25 10 5.25C9.58579 5.25 9.25 5.58579 9.25 6V9.25H6C5.58579 9.25 5.25 9.58579 5.25 10C5.25 10.4142 5.58579 10.75 6 10.75H9.25V14C9.25 14.4142 9.58579 14.75 10 14.75C10.4142 14.75 10.75 14.4142 10.75 14V10.75H14C14.4142 10.75 14.75 10.4142 14.75 10C14.75 9.58579 14.4142 9.25 14 9.25Z"
      fill="#45576F"
    />
  </svg>
);

export const MinusIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.44 0H10.56C15.7736 0 20 4.22643 20 9.44V10.56C20 15.7736 15.7736 20 10.56 20H9.44C4.22643 20 0 15.7736 0 10.56V9.44C0 4.22643 4.22643 0 9.44 0ZM10.56 18.5C14.9315 18.4673 18.4673 14.9315 18.5 10.56V9.44C18.4673 5.06846 14.9315 1.53267 10.56 1.5H9.44C5.06846 1.53267 1.53266 5.06846 1.5 9.44V10.56C1.53266 14.9315 5.06846 18.4673 9.44 18.5H10.56Z"
      fill="#45576F"
    />
    <path
      d="M14 9.25H6C5.58579 9.25 5.25 9.58579 5.25 10C5.25 10.4142 5.58579 10.75 6 10.75H14C14.4142 10.75 14.75 10.4142 14.75 10C14.75 9.58579 14.4142 9.25 14 9.25Z"
      fill="#45576F"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2922 4.11158C11.3414 1.82849 9.11359 0.338723 6.64044 0.332117C3.97498 0.318081 1.60491 2.0254 0.774031 4.5581C-0.0568485 7.09079 0.841268 9.87028 2.99706 11.4379C5.15285 13.0055 8.07383 13.0032 10.2271 11.4321L12.1471 13.3521C12.3423 13.5471 12.6586 13.5471 12.8538 13.3521C13.0487 13.1569 13.0487 12.8407 12.8538 12.6455L10.9938 10.7855C12.7312 9.02534 13.243 6.39467 12.2922 4.11158ZM11.4007 8.44474C10.6024 10.3685 8.72328 11.6215 6.64044 11.6188V11.5921C3.81358 11.5885 1.51875 9.30559 1.50044 6.47878C1.49774 4.39594 2.7507 2.51681 4.67448 1.7185C6.59826 0.920182 8.81355 1.36008 10.2863 2.83288C11.7591 4.30567 12.199 6.52096 11.4007 8.44474Z"
      fill="#78848C"
    />
  </svg>
);

export const LockIcon = () => (
  <svg
    width="16"
    height="21"
    viewBox="0 0 16 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.46265 11.902C9.46265 10.9852 8.71944 10.242 7.80265 10.242C6.88585 10.242 6.14265 10.9852 6.14265 11.902C6.14127 12.2907 6.27969 12.6669 6.53265 12.962C6.78752 13.2276 6.87588 13.6118 6.76265 13.962L6.55265 14.582C6.47143 14.8608 6.52512 15.1616 6.69778 15.3951C6.87045 15.6286 7.14227 15.768 7.43265 15.772H8.17265C8.47264 15.7719 8.75416 15.6271 8.92872 15.3832C9.10327 15.1392 9.14942 14.826 9.05265 14.542L8.80265 13.922C8.68942 13.5718 8.77777 13.1876 9.03265 12.922C9.2913 12.6431 9.44352 12.282 9.46265 11.902Z"
      fill="#ECEEF1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5526 6.12202V3.00202C12.5532 2.18694 12.2221 1.40672 11.6354 0.840841C11.0488 0.27496 10.2572 -0.0278667 9.44265 0.0020198H6.16265C5.34812 -0.0278667 4.55648 0.27496 3.96985 0.840841C3.38322 1.40672 3.0521 2.18694 3.05265 3.00202V6.12202C0.981163 6.85136 -0.278635 8.95102 0.0526476 11.122L1.00265 16.892C1.47121 19.1904 3.51752 20.8241 5.86265 20.772H9.74265C12.1045 20.8313 14.1655 19.18 14.6226 16.862L15.5726 11.092C15.886 8.92593 14.6195 6.84179 12.5526 6.12202ZM4.55264 3.00202C4.5905 2.14965 5.31011 1.48815 6.16264 1.52202H9.44264C10.2952 1.48815 11.0148 2.14965 11.0526 3.00202V5.77202H4.55264V3.00202ZM12.8026 16.562L13.8026 10.772C13.9019 10.023 13.6638 9.26847 13.1526 8.71202C12.531 8.00708 11.6324 7.60892 10.6926 7.62202H4.91265C3.97604 7.60387 3.07796 7.99449 2.45265 8.69202C1.95367 9.26184 1.73381 10.024 1.85265 10.772L2.80265 16.562C3.1127 17.9884 4.40434 18.9845 5.86265 18.922H9.74265C11.2009 18.9845 12.4926 17.9884 12.8026 16.562Z"
      fill="#ECEEF1"
    />
  </svg>
);

export const TruckIcon = () => (
  <svg
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.94 5.54938L19.89 4.49937C19.3896 3.99337 18.7115 3.70273 18 3.68937H14V3.10938C14 1.59059 12.7688 0.359375 11.25 0.359375H3C2.58579 0.359375 2.25 0.695161 2.25 1.10938C2.25 1.52359 2.58579 1.85938 3 1.85938H11.22C11.9104 1.85938 12.47 2.41902 12.47 3.10938V9.43937C12.47 9.85359 12.8058 10.1894 13.22 10.1894C13.6342 10.1894 13.97 9.85359 13.97 9.43937V5.18937H17.97C18.3014 5.18806 18.6191 5.32163 18.85 5.55937L19.9 6.55937C20.0432 6.70784 20.1464 6.89019 20.2 7.08938H16C15.5858 7.08938 15.25 7.42516 15.25 7.83938C15.25 8.25359 15.5858 8.58937 16 8.58937H20.25V12.8394C20.2636 13.1795 20.138 13.5104 19.902 13.7558C19.6661 14.0011 19.3404 14.1396 19 14.1394H17.89C17.6439 12.9856 16.6247 12.1609 15.445 12.1609C14.2653 12.1609 13.2461 12.9856 13 14.1394H7.66C7.39085 12.9468 6.29272 12.1283 5.07293 12.211C3.85315 12.2938 2.87567 13.2532 2.77011 14.4712C2.66454 15.6892 3.4624 16.8025 4.64975 17.0939C5.83711 17.3853 7.05968 16.7679 7.53 15.6394H13.14C13.5298 16.5676 14.4383 17.1714 15.445 17.1714C16.4517 17.1714 17.3602 16.5676 17.75 15.6394H19C20.5188 15.6394 21.75 14.4082 21.75 12.8894V7.49937C21.7514 6.76726 21.4597 6.06506 20.94 5.54938ZM5.22 15.4794C4.88428 15.4958 4.57256 15.3056 4.43351 14.9996C4.29446 14.6936 4.35624 14.3337 4.58939 14.0916C4.82254 13.8494 5.17983 13.7741 5.49087 13.9015C5.80191 14.0289 6.0037 14.3333 6 14.6694C6.0003 15.1053 5.65559 15.4632 5.22 15.4794ZM14.6815 14.9708C14.8078 15.2785 15.1074 15.4794 15.44 15.4794C15.889 15.4794 16.2545 15.1183 16.26 14.6694C16.2641 14.3368 16.0669 14.0348 15.7608 13.9047C15.4547 13.7746 15.1004 13.8423 14.8638 14.076C14.6272 14.3097 14.5552 14.6632 14.6815 14.9708Z"
      fill="#ECEEF1"
    />
    <path
      d="M9.75 5.99937C9.74461 5.58741 9.41196 5.25476 9 5.24937H1C0.585786 5.24937 0.25 5.58516 0.25 5.99937C0.25 6.41359 0.585786 6.74937 1 6.74937H9C9.41196 6.74399 9.74461 6.41134 9.75 5.99937Z"
      fill="#ECEEF1"
    />
    <path
      d="M9 8.24937H4C3.58579 8.24937 3.25 8.58516 3.25 8.99937C3.25 9.41359 3.58579 9.74937 4 9.74937H9C9.41421 9.74937 9.75 9.41359 9.75 8.99937C9.75 8.58516 9.41421 8.24937 9 8.24937Z"
      fill="#ECEEF1"
    />
  </svg>
);

export const WalletIcon2 = () => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 11.8182C20 14.3286 17.9649 16.3636 15.4545 16.3636H4.54545C2.03507 16.3636 0 14.3286 0 11.8182V4.54545C0 2.03507 2.03507 0 4.54545 0H15.4545C17.9649 0 20 2.03507 20 4.54545V11.8182ZM4.54545 1.62727H15.4545C17.0662 1.62727 18.3727 2.93379 18.3727 4.54545V5.45455H15.4545C13.9483 5.45455 12.7273 6.67559 12.7273 8.18182C12.7273 9.68805 13.9483 10.9091 15.4545 10.9091H18.3727V11.8182C18.3727 13.4298 17.0662 14.7364 15.4545 14.7364H4.54545C2.93379 14.7364 1.62727 13.4298 1.62727 11.8182V4.54545C1.62727 2.93379 2.93379 1.62727 4.54545 1.62727ZM18.3727 9.28182V7.08182H15.4545C14.847 7.08182 14.3545 7.57431 14.3545 8.18182C14.3545 8.78933 14.847 9.28182 15.4545 9.28182H18.3727Z"
      fill="#ECEEF1"
    />
  </svg>
);

export const CryptoWalletIcon = () => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 20.00 20.00"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 3.5C15.1716 3.5 14.5 4.17157 14.5 5C14.5 5.65311 14.9174 6.20873 15.5 6.41465V7.5H7C6.17157 7.5 5.5 8.17157 5.5 9V15C5.5 15.8284 6.17157 16.5 7 16.5H8.5V17.5854C7.9174 17.7913 7.5 18.3469 7.5 19C7.5 19.8284 8.17157 20.5 9 20.5C9.82843 20.5 10.5 19.8284 10.5 19C10.5 18.3469 10.0826 17.7913 9.5 17.5854V16.5H17C17.8284 16.5 18.5 15.8284 18.5 15V13.4146C19.0826 13.2087 19.5 12.6531 19.5 12C19.5 11.3469 19.0826 10.7913 18.5 10.5854V9C18.5 8.17157 17.8284 7.5 17 7.5H16.5V6.41465C17.0826 6.20873 17.5 5.65311 17.5 5C17.5 4.17157 16.8284 3.5 16 3.5ZM15.5 5C15.5 4.72386 15.7239 4.5 16 4.5C16.2761 4.5 16.5 4.72386 16.5 5C16.5 5.27614 16.2761 5.5 16 5.5C15.7239 5.5 15.5 5.27614 15.5 5ZM17.5 10.5V9C17.5 8.72386 17.2761 8.5 17 8.5H7C6.72386 8.5 6.5 8.72386 6.5 9V15C6.5 15.2761 6.72386 15.5 7 15.5H17C17.2761 15.5 17.5 15.2761 17.5 15V13.5H14C13.1716 13.5 12.5 12.8284 12.5 12C12.5 11.1716 13.1716 10.5 14 10.5H17.5ZM9 18.5C8.72386 18.5 8.5 18.7239 8.5 19C8.5 19.2761 8.72386 19.5 9 19.5C9.27614 19.5 9.5 19.2761 9.5 19C9.5 18.7239 9.27614 18.5 9 18.5ZM13.5 12C13.5 11.7239 13.7239 11.5 14 11.5H18C18.2761 11.5 18.5 11.7239 18.5 12C18.5 12.2761 18.2761 12.5 18 12.5H14C13.7239 12.5 13.5 12.2761 13.5 12Z"
        fill="#ECEEF1"
      ></path>{" "}
    </g>
  </svg>
);

export const ReportsIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.36683 22.2998C7.73367 23.6667 9.93356 23.6667 14.3333 23.6667C18.7331 23.6667 20.933 23.6667 22.2998 22.2998C23.6667 20.933 23.6667 18.7331 23.6667 14.3333C23.6667 9.93356 23.6667 7.73367 22.2998 6.36683C20.933 5 18.7331 5 14.3333 5C9.93356 5 7.73367 5 6.36683 6.36683C5 7.73367 5 9.93356 5 14.3333C5 18.7331 5 20.933 6.36683 22.2998ZM20.6333 18.0667C20.6333 18.4533 20.3199 18.7667 19.9333 18.7667H8.73333C8.34673 18.7667 8.03333 18.4533 8.03333 18.0667C8.03333 17.6801 8.34673 17.3667 8.73333 17.3667H19.9333C20.3199 17.3667 20.6333 17.6801 20.6333 18.0667ZM19.9333 15.0333C20.3199 15.0333 20.6333 14.7199 20.6333 14.3333C20.6333 13.9467 20.3199 13.6333 19.9333 13.6333H8.73333C8.34673 13.6333 8.03333 13.9467 8.03333 14.3333C8.03333 14.7199 8.34673 15.0333 8.73333 15.0333H19.9333ZM20.6333 10.6C20.6333 10.9866 20.3199 11.3 19.9333 11.3H8.73333C8.34673 11.3 8.03333 10.9866 8.03333 10.6C8.03333 10.2134 8.34673 9.9 8.73333 9.9H19.9333C20.3199 9.9 20.6333 10.2134 20.6333 10.6Z"
      fill="#878785"
    />
  </svg>
);

export const AddressIcon = () => (
  <svg
    width="14"
    height="21"
    viewBox="0 0 14 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.82 13.485C11.4551 13.3016 11.0106 13.4439 10.82 13.805C10.6438 14.1729 10.7895 14.6142 11.15 14.805C12.03 15.255 12.53 15.805 12.53 16.335C12.53 17.465 10.17 18.725 7.01 18.725C3.85 18.725 1.48 17.475 1.48 16.375C1.48 15.855 1.98 15.295 2.86 14.845C3.1239 14.7392 3.30528 14.4932 3.3284 14.2098C3.35151 13.9265 3.2124 13.6544 2.96914 13.5072C2.72588 13.36 2.4203 13.363 2.18 13.515C0.965898 13.9726 0.119478 15.083 0 16.375C0 18.595 3 20.265 7 20.265C11 20.265 14 18.595 14 16.375C13.8916 15.0718 13.0432 13.9472 11.82 13.485Z"
      fill="#45576F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 16.815V12.495C2.95689 12.0982 0.542527 9.20529 0.741265 5.89433C0.940003 2.58336 3.68308 0 7 0C10.3169 0 13.06 2.58336 13.2587 5.89433C13.4575 9.20529 11.0431 12.0982 7.75 12.495V16.815C7.75 17.2292 7.41421 17.565 7 17.565C6.58579 17.565 6.25 17.2292 6.25 16.815ZM11.4242 4.44113C10.6818 2.65406 8.93515 1.49094 7 1.49498C4.36789 1.50048 2.2355 3.63287 2.23 6.26498C2.22596 8.20013 3.38908 9.94678 5.17615 10.6892C6.96322 11.4316 9.02161 11.0233 10.39 9.65494C11.7583 8.28659 12.1666 6.2282 11.4242 4.44113Z"
      fill="#45576F"
    />
    <path
      d="M4.59 7.37498C5.00422 7.37498 5.34 7.0392 5.34 6.62498C5.34 5.47623 6.27125 4.54498 7.42 4.54498C7.83421 4.54498 8.17 4.2092 8.17 3.79498C8.17 3.38077 7.83421 3.04498 7.42 3.04498C6.46787 3.04763 5.55579 3.4284 4.88441 4.10354C4.21303 4.77867 3.83735 5.69285 3.84 6.64498C3.84264 6.84125 3.92314 7.02843 4.06379 7.16533C4.20445 7.30224 4.39374 7.37765 4.59 7.37498Z"
      fill="#45576F"
    />
  </svg>
);

export const PaymentIcon = () => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 0H4C1.79086 0 0 1.79086 0 4V10C0 12.2091 1.79086 14 4 14H16C18.2091 14 20 12.2091 20 10V4C20 1.79086 18.2091 0 16 0ZM4 1.5H16C16.663 1.5 17.2989 1.76339 17.7678 2.23223C18.2366 2.70107 18.5 3.33696 18.5 4V8.25H1.5V4C1.5 2.61929 2.61929 1.5 4 1.5ZM4 12.5H16C16.663 12.5 17.2989 12.2366 17.7678 11.7678C18.2366 11.2989 18.5 10.663 18.5 10V9.75H1.5V10C1.5 11.3807 2.61929 12.5 4 12.5Z"
      fill="#45576F"
    />
  </svg>
);

export const CloseIcon2 = () => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.44561 6.00537L12.5093 0.958814C12.7209 0.745271 12.7209 0.39933 12.5093 0.185787C12.3015 -0.031573 11.9583 -0.038101 11.7425 0.171202L6.67882 5.21775L1.68023 0.171202C1.57775 0.0619207 1.43516 0 1.28599 0C1.13681 0 0.994221 0.0619207 0.891741 0.171202C0.704169 0.377518 0.704169 0.694156 0.891741 0.900472L5.89033 5.93973L0.826636 10.979C0.61508 11.1925 0.61508 11.5385 0.826636 11.752C0.927351 11.856 1.06587 11.914 1.21003 11.9125C1.35697 11.9245 1.50265 11.8773 1.61513 11.7812L6.67882 6.73464L11.7425 11.8395C11.8432 11.9435 11.9817 12.0015 12.1259 12C12.2699 12.0007 12.4081 11.9428 12.5093 11.8395C12.7209 11.626 12.7209 11.28 12.5093 11.0665L7.44561 6.00537Z"
      fill="white"
    />
  </svg>
);

export const PlusIcon2 = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1662 5.33312H6.33308V0.49998C6.33308 0.223849 6.10923 0 5.8331 0C5.55697 0 5.33312 0.223849 5.33312 0.49998V5.33312H0.49998C0.223849 5.33312 0 5.55697 0 5.8331C0 6.10923 0.223849 6.33308 0.49998 6.33308H5.33312V11.1662C5.33312 11.4423 5.55697 11.6662 5.8331 11.6662C6.10923 11.6662 6.33308 11.4423 6.33308 11.1662V6.33308H11.1662C11.4423 6.33308 11.6662 6.10923 11.6662 5.8331C11.6662 5.55697 11.4423 5.33312 11.1662 5.33312Z"
      fill="white"
    />
  </svg>
);

export const WarningIcon2 = () => (
  <svg
    width="130"
    height="123"
    viewBox="0 0 130 123"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <p
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.6049 13.8674C46.1843 5.31579 55.1043 -0.0156687 64.8049 0.000753526C74.6771 -0.0732805 83.7824 5.31296 88.4715 14.0008L126.072 83.6008C130.532 91.8646 130.317 101.866 125.506 109.93C120.694 117.995 111.996 122.934 102.605 122.934H27.0049C17.5859 122.936 8.86443 117.969 4.06074 109.867C-0.742948 101.766 -0.91623 91.7304 3.60488 83.4674L41.6049 13.8674ZM79.4715 18.7341C76.5797 13.3291 70.9347 9.96784 64.8049 10.0008C58.7651 10.0426 53.2246 13.3618 50.3382 18.6674L12.4049 88.1341C9.57161 93.2853 9.67426 99.5508 12.6747 104.606C15.6752 109.662 21.1259 112.754 27.0049 112.734H102.605C108.463 112.698 113.876 109.602 116.876 104.57C119.875 99.5385 120.026 93.3044 117.272 88.1341L79.4715 18.7341Z"
      fill="#78848C"
    />
    <path
      d="M64.8049 80.0015C62.0435 80.0015 59.8049 82.2401 59.8049 85.0015C59.8049 87.7629 62.0435 90.0015 64.8049 90.0015C66.1364 90.0196 67.4188 89.4986 68.3604 88.557C69.302 87.6154 69.823 86.333 69.8049 85.0015C69.805 83.6814 69.2761 82.4164 68.3364 81.4893C67.3968 80.5622 66.1248 80.0503 64.8049 80.0682V80.0015Z"
      fill="#78848C"
    />
    <path
      d="M64.8049 70.8682C62.0585 70.8323 59.8408 68.6146 59.8049 65.8682V45.2015C59.8049 42.4401 62.0434 40.2015 64.8049 40.2015C67.5663 40.2015 69.8049 42.4401 69.8049 45.2015V65.8682C69.8049 68.6296 67.5663 70.8682 64.8049 70.8682Z"
      fill="#78848C"
    />
  </svg>
);

export const CopyIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9987 2.9987V8.33203C10.9987 9.80479 9.80479 10.9987 8.33203 10.9987H2.9987C1.52594 10.9987 0.332031 9.80479 0.332031 8.33203V2.9987C0.332031 1.52594 1.52594 0.332031 2.9987 0.332031H8.33203C9.80479 0.332031 10.9987 1.52594 10.9987 2.9987ZM1.33203 2.9987V8.33203C1.33203 8.77406 1.50763 9.19798 1.82019 9.51054C2.13275 9.8231 2.55667 9.9987 2.9987 9.9987H8.33203C9.25251 9.9987 9.9987 9.25251 9.9987 8.33203V2.9987C9.9987 2.07822 9.25251 1.33203 8.33203 1.33203H2.9987C2.07822 1.33203 1.33203 2.07822 1.33203 2.9987Z"
      fill="#45576F"
    />
    <path
      d="M12.9987 4.4987C12.7241 4.50229 12.5023 4.72406 12.4987 4.9987V10.332C12.495 11.5271 11.5271 12.495 10.332 12.4987H4.9987C4.72256 12.4987 4.4987 12.7226 4.4987 12.9987C4.4987 13.2748 4.72256 13.4987 4.9987 13.4987H10.332C12.0809 13.4987 13.4987 12.0809 13.4987 10.332V4.9987C13.4951 4.72406 13.2733 4.50229 12.9987 4.4987Z"
      fill="#45576F"
    />
  </svg>
);

export const LeftArrow = () => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66492 11.8339C6.53221 11.8345 6.40485 11.7816 6.31159 11.6872L0.978258 6.35388C0.783289 6.15867 0.783289 5.84243 0.978258 5.64722L6.31159 0.313882C6.5086 0.13031 6.8156 0.135727 7.00601 0.326135C7.19641 0.516543 7.20183 0.823543 7.01826 1.02055L2.03826 6.00055L7.01826 10.9805C7.21323 11.1758 7.21323 11.492 7.01826 11.6872C6.925 11.7816 6.79764 11.8345 6.66492 11.8339Z"
      fill="#172935"
    />
  </svg>
);

export const RightArrow = () => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33159 11.8339C1.4643 11.8345 1.59167 11.7816 1.68492 11.6872L7.01826 6.35388C7.21323 6.15867 7.21323 5.84243 7.01826 5.64722L1.68492 0.313882C1.48792 0.13031 1.18092 0.135727 0.99051 0.326135C0.800102 0.516543 0.794685 0.823543 0.978258 1.02055L5.95826 6.00055L0.978258 10.9805C0.783289 11.1758 0.783289 11.492 0.978258 11.6872C1.07151 11.7816 1.19888 11.8345 1.33159 11.8339Z"
      fill="#172935"
    />
  </svg>
);

export const TickIcon2 = () => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.47315 7.1173C3.29994 7.11718 3.13211 7.05711 2.99815 6.9473L0.758154 5.1123C0.451862 4.84621 0.412702 4.3848 0.66977 4.0709C0.926839 3.75701 1.38692 3.70446 1.70815 3.9523L3.44315 5.3723L8.44315 0.767296C8.63109 0.543832 8.93163 0.449752 9.21344 0.526171C9.49525 0.60259 9.70709 0.835615 9.75638 1.12341C9.80568 1.4112 9.68347 1.70145 9.44315 1.8673L3.98315 6.9173C3.845 7.04675 3.66248 7.11833 3.47315 7.1173Z"
      fill="#0E61D1"
    />
  </svg>
);

export const EditIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.19338 9.18126L4.68005 6.90792C4.7509 6.59201 4.91049 6.3029 5.14005 6.07459L9.58672 1.66792C10.0376 1.20857 10.6499 0.94311 11.2934 0.927921C11.7787 0.920967 12.2467 1.10817 12.5934 1.44792C13.3508 2.3429 13.2531 3.6794 12.3734 4.45459L7.92672 8.90125C7.69841 9.13081 7.4093 9.2904 7.09338 9.36126L4.82005 9.84792H4.69338C4.52719 9.85428 4.36846 9.77868 4.26867 9.64563C4.16888 9.51257 4.14074 9.33902 4.19338 9.18126ZM5.84672 6.78792C5.75331 6.87844 5.68842 6.99431 5.66005 7.12126L5.33338 8.67459L6.88672 8.34126C7.01366 8.31288 7.12953 8.248 7.22005 8.15459L11.6667 3.70792C12.1538 3.31794 12.2505 2.61491 11.8867 2.10792C11.7274 1.95573 11.5136 1.87403 11.2934 1.88125C10.9138 1.8965 10.555 2.05912 10.2934 2.33459L5.84672 6.78792Z"
      fill="#78848C"
    />
    <path
      d="M12.2734 6.28792C11.9987 6.29151 11.777 6.51328 11.7734 6.78792V10.5813C11.7823 11.1174 11.5756 11.6348 11.1995 12.0171C10.8235 12.3994 10.3096 12.6147 9.77339 12.6146H3.42005C2.31163 12.5929 1.42346 11.6899 1.42005 10.5813V4.25459C1.43825 3.14465 2.3433 2.25444 3.45339 2.25459H7.24672C7.52286 2.25459 7.74672 2.03073 7.74672 1.75459C7.74672 1.47845 7.52286 1.25459 7.24672 1.25459H3.42005C1.75772 1.25449 0.404986 2.59236 0.386719 4.25459V10.5813C0.386719 12.2565 1.74479 13.6146 3.42005 13.6146H9.74672C11.4194 13.6109 12.7734 12.2539 12.7734 10.5813V6.78792C12.7698 6.51328 12.548 6.29151 12.2734 6.28792Z"
      fill="#78848C"
    />
  </svg>
);

export const KycDone = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2280_8669)">
      <path
        d="M6.25391 8.00005L7.86057 9.61339L11.0806 6.38672"
        stroke="#0E61D1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.83391 1.63289C8.29391 1.23956 9.04724 1.23956 9.51391 1.63289L10.5672 2.53956C10.7672 2.71289 11.1406 2.85289 11.4072 2.85289H12.5406C13.2472 2.85289 13.8272 3.43289 13.8272 4.13956V5.27289C13.8272 5.53289 13.9672 5.91289 14.1406 6.11289L15.0472 7.16622C15.4406 7.62622 15.4406 8.37956 15.0472 8.84622L14.1406 9.89956C13.9672 10.0996 13.8272 10.4729 13.8272 10.7396V11.8729C13.8272 12.5796 13.2472 13.1596 12.5406 13.1596H11.4072C11.1472 13.1596 10.7672 13.2996 10.5672 13.4729L9.51391 14.3796C9.05391 14.7729 8.30057 14.7729 7.83391 14.3796L6.78057 13.4729C6.58057 13.2996 6.20724 13.1596 5.94057 13.1596H4.78724C4.08057 13.1596 3.50057 12.5796 3.50057 11.8729V10.7329C3.50057 10.4729 3.36057 10.0996 3.19391 9.89956L2.29391 8.83956C1.90724 8.37956 1.90724 7.63289 2.29391 7.17289L3.19391 6.11289C3.36057 5.91289 3.50057 5.53956 3.50057 5.27956V4.13289C3.50057 3.42622 4.08057 2.84622 4.78724 2.84622H5.94057C6.20057 2.84622 6.58057 2.70622 6.78057 2.53289L7.83391 1.63289Z"
        stroke="#0E61D1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2280_8669">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.667969)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.526 3.66732C10.2351 3.66732 9.99935 3.90311 9.99935 4.19398V10.0873C9.99935 11.3281 8.99348 12.334 7.75268 12.334H3.96602C2.72522 12.334 1.71935 11.3281 1.71935 10.0873V4.19398C1.71935 3.90311 1.48355 3.66732 1.19268 3.66732C0.901812 3.66732 0.666016 3.90311 0.666016 4.19398V10.0873C0.684296 11.9152 2.17134 13.3874 3.99935 13.3873H7.78602C9.60102 13.3693 11.068 11.9023 11.086 10.0873V4.19398C11.0863 4.04833 11.0263 3.90906 10.9202 3.80928C10.8141 3.70949 10.6714 3.6581 10.526 3.66732Z"
      fill="#E22020"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.526 2.72065H1.19268C0.901812 2.72065 0.666016 2.48485 0.666016 2.19398C0.666016 1.90311 0.901812 1.66732 1.19268 1.66732H2.95935L3.74602 0.813984C4.04673 0.508258 4.45719 0.335435 4.88602 0.333984H6.83268C7.25526 0.333979 7.66054 0.501844 7.95935 0.800651L8.75935 1.66732H10.526C10.8169 1.66732 11.0527 1.90311 11.0527 2.19398C11.0527 2.48485 10.8169 2.72065 10.526 2.72065ZM6.83268 1.38732H4.88602C4.75274 1.38736 4.62431 1.43731 4.52602 1.52732L4.39935 1.66065H7.31935L7.19268 1.52732C7.09511 1.43616 6.96621 1.38603 6.83268 1.38732Z"
      fill="#E22020"
    />
    <path
      d="M3.35935 4.86065V6.86065C3.35935 7.13679 3.58321 7.36065 3.85935 7.36065C4.13549 7.36065 4.35935 7.13679 4.35935 6.86065V4.86065C4.35935 4.58451 4.13549 4.36065 3.85935 4.36065C3.58321 4.36065 3.35935 4.58451 3.35935 4.86065Z"
      fill="#E22020"
    />
    <path
      d="M5.35935 4.86065V10.194C5.35935 10.4701 5.58321 10.694 5.85935 10.694C6.13549 10.694 6.35935 10.4701 6.35935 10.194V4.86065C6.35935 4.58451 6.13549 4.36065 5.85935 4.36065C5.58321 4.36065 5.35935 4.58451 5.35935 4.86065Z"
      fill="#E22020"
    />
    <path
      d="M7.35935 4.86065V6.86065C7.35935 7.13679 7.58321 7.36065 7.85935 7.36065C8.13549 7.36065 8.35935 7.13679 8.35935 6.86065V4.86065C8.35935 4.58451 8.13549 4.36065 7.85935 4.36065C7.58321 4.36065 7.35935 4.58451 7.35935 4.86065Z"
      fill="#E22020"
    />
  </svg>
);

export const StripeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="40"
    viewBox="0 0 29 40"
    fill="none"
  >
    <path
      d="M17.5801 15.25C13.958 13.9067 11.9836 12.8733 11.9836 11.235C11.9836 9.85 13.1225 9.06 15.1537 9.06C18.8675 9.06 22.683 10.49 25.3095 11.7783L26.7937 2.62167C24.7109 1.625 20.4501 0 14.56 0C10.3943 0 6.92898 1.09 4.45256 3.12C1.87775 5.245 0.538643 8.32 0.538643 12.03C0.538643 18.7617 4.65267 21.63 11.3382 24.0617C15.649 25.595 17.0832 26.685 17.0832 28.3667C17.0832 30 15.6823 30.9417 13.1576 30.9417C10.0308 30.9417 4.8778 29.4067 1.50086 27.4267L0 36.685C2.90334 38.3167 8.25641 40 13.8079 40C18.2121 40 21.8842 38.96 24.3607 36.9783C27.1356 34.8033 28.5714 31.585 28.5714 27.425C28.5714 20.545 24.3623 17.6733 17.5751 15.25H17.5801Z"
      fill="#172935"
    />
  </svg>
);

export const DirectDepositIcon = () => (
  <svg
    width="27"
    height="36"
    viewBox="0 0 27 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.1587 3H3.15868C2.33025 3 1.65868 2.32843 1.65868 1.5C1.65868 0.671573 2.33025 0 3.15868 0H23.1587C23.9871 0 24.6587 0.671573 24.6587 1.5C24.6587 2.32843 23.9871 3 23.1587 3Z"
      fill="#172935"
    />
    <path
      d="M24.8187 20.5129C25.2179 20.5129 25.6001 20.6741 25.8787 20.96C26.4636 21.5456 26.4636 22.4944 25.8787 23.08L14.2187 34.72C13.633 35.3049 12.6843 35.3049 12.0987 34.72L0.43868 23.08C-0.146227 22.4944 -0.146227 21.5456 0.43868 20.96C0.717256 20.6741 1.09951 20.5129 1.49868 20.5129C1.89786 20.5129 2.2801 20.6741 2.55868 20.96L11.6587 30.04V7.6C11.6587 6.77157 12.3303 6.1 13.1587 6.1C13.9871 6.1 14.6587 6.77157 14.6587 7.6V30.04L23.7587 20.96C24.0373 20.6741 24.4195 20.5129 24.8187 20.5129Z"
      fill="#172935"
    />
  </svg>
);
export const WireTransferIcon = () => (
  <svg
    width="34"
    height="42"
    viewBox="0 0 34 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.55919 28.8809L12.3792 22.0609C12.9701 21.4754 12.9746 20.5218 12.3892 19.9309C11.8038 19.3399 10.8501 19.3354 10.2592 19.9209L0.999194 29.3009C0.863 29.4467 0.754557 29.6161 0.679194 29.8009C0.539227 30.168 0.539227 30.5738 0.679194 30.9409C0.754557 31.1256 0.863 31.2951 0.999194 31.4409L10.3792 40.8209C10.6649 41.0952 11.0432 41.2523 11.4392 41.2609C11.8369 41.2605 12.2182 41.1023 12.4992 40.8209C12.7851 40.5423 12.9463 40.16 12.9463 39.7609C12.9463 39.3617 12.7851 38.9794 12.4992 38.7009L5.61919 31.8809H23.6192C24.4476 31.8809 25.1192 31.2093 25.1192 30.3809C25.1192 29.5524 24.4476 28.8809 23.6192 28.8809H5.55919Z"
      fill="#172935"
    />
    <path
      d="M33.3792 11.0009C33.2797 10.8327 33.1511 10.6837 32.9992 10.5609L23.6792 1.18087C23.0936 0.595961 22.1448 0.595961 21.5592 1.18087C21.2733 1.45944 21.1121 1.84169 21.1121 2.24087C21.1121 2.64004 21.2733 3.02229 21.5592 3.30087L28.3792 10.1409H10.3792C9.55077 10.1409 8.87919 10.8124 8.87919 11.6409C8.87919 12.4693 9.55077 13.1409 10.3792 13.1409H28.3792L21.5592 19.9609C21.2733 20.2394 21.1121 20.6217 21.1121 21.0209C21.1121 21.42 21.2733 21.8023 21.5592 22.0809C21.8402 22.3623 22.2215 22.5205 22.6192 22.5209C23.0152 22.5123 23.3935 22.3552 23.6792 22.0809L32.9992 12.7009C33.1354 12.5551 33.2438 12.3856 33.3192 12.2009C33.4943 11.8239 33.5158 11.3935 33.3792 11.0009Z"
      fill="#172935"
    />
  </svg>
);

export const UploadIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.2083 39.4167H14.2083C4.25333 39.4167 0 35.1633 0 25.2083V14.2083C0 4.25333 4.25333 0 14.2083 0H25.2083C35.1633 0 39.4167 4.25333 39.4167 14.2083V25.2083C39.4167 35.1633 35.1633 39.4167 25.2083 39.4167ZM14.2083 2.75C5.75667 2.75 2.75 5.75667 2.75 14.2083V25.2083C2.75 33.66 5.75667 36.6667 14.2083 36.6667H25.2083C33.66 36.6667 36.6667 33.66 36.6667 25.2083V14.2083C36.6667 5.75667 33.66 2.75 25.2083 2.75H14.2083Z"
      fill="#878785"
    />
    <path
      d="M14.2077 17.4163C11.421 17.4163 9.16602 15.1613 9.16602 12.3747C9.16602 9.58801 11.421 7.33301 14.2077 7.33301C16.9943 7.33301 19.2493 9.58801 19.2493 12.3747C19.2493 15.1613 16.9943 17.4163 14.2077 17.4163ZM14.2077 10.083C12.9427 10.083 11.916 11.1097 11.916 12.3747C11.916 13.6397 12.9427 14.6663 14.2077 14.6663C15.4727 14.6663 16.4993 13.6397 16.4993 12.3747C16.4993 11.1097 15.4727 10.083 14.2077 10.083Z"
      fill="#878785"
    />
    <path
      d="M2.60373 33.8253C2.16373 33.8253 1.72373 33.6053 1.46706 33.2204C1.0454 32.597 1.2104 31.7353 1.85206 31.3137L10.8904 25.2453C12.8704 23.907 15.6021 24.072 17.3988 25.5937L18.0038 26.1254C18.9205 26.9137 20.4788 26.9137 21.3771 26.1254L29.0038 19.5804C30.9471 17.912 34.0088 17.912 35.9705 19.5804L38.9588 22.147C39.5271 22.642 39.6004 23.5037 39.1054 24.0903C38.6104 24.6587 37.7488 24.732 37.1621 24.237L34.1738 21.6704C33.2571 20.882 31.6988 20.882 30.7821 21.6704L23.1554 28.2154C21.2121 29.8837 18.1504 29.8837 16.1888 28.2154L15.5837 27.6837C14.7404 26.9687 13.3471 26.8953 12.4121 27.537L3.37373 33.6053C3.1354 33.752 2.8604 33.8253 2.60373 33.8253Z"
      fill="#878785"
    />
  </svg>
);

export const HomeIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.29 5.00048L12.73 0.890481C11.1036 -0.296827 8.89636 -0.296827 7.27 0.890481L1.72 5.00048C0.645442 5.77462 0.00610336 7.01612 0 8.34048V15.7705C0.0600245 18.1637 2.04665 20.0564 4.44 20.0005H15.56C17.9534 20.0564 19.94 18.1637 20 15.7705V8.33048C19.9914 7.01185 19.3567 5.77576 18.29 5.00048ZM18.5 15.7705C18.4404 17.3354 17.1251 18.5568 15.56 18.5005H4.44C2.87698 18.5512 1.56502 17.333 1.5 15.7705V8.34048C1.50534 7.4904 1.91817 6.69448 2.61 6.20048L8.16 2.10048C9.25609 1.30006 10.7439 1.30006 11.84 2.10048L17.39 6.21048C18.0812 6.6959 18.4948 7.48583 18.5 8.33048V15.7705ZM5.5 13.7505H14.5C14.9142 13.7505 15.25 14.0863 15.25 14.5005C15.25 14.9147 14.9142 15.2505 14.5 15.2505H5.5C5.08579 15.2505 4.75 14.9147 4.75 14.5005C4.75 14.0863 5.08579 13.7505 5.5 13.7505Z"
      fill="black"
    />
  </svg>
);

export const TrashIcon = () => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M18 6V16.2C18 17.8802 18 18.7202 17.673 19.362C17.3854 19.9265 16.9265 20.3854 16.362 20.673C15.7202 21 14.8802 21 13.2 21H10.8C9.11984 21 8.27976 21 7.63803 20.673C7.07354 20.3854 6.6146 19.9265 6.32698 19.362C6 18.7202 6 17.8802 6 16.2V6M14 10V17M10 10V17"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ExportIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6267 2.30667C13.5475 2.12243 13.3672 2.00219 13.1667 2H9.83334C9.55719 2 9.33334 2.22386 9.33334 2.5C9.33334 2.77614 9.55719 3 9.83334 3H11.96L8.14667 6.81333C7.9517 7.00854 7.9517 7.32479 8.14667 7.52C8.34188 7.71497 8.65812 7.71497 8.85334 7.52L12.6667 3.70667V5.83333C12.6667 6.10948 12.8905 6.33333 13.1667 6.33333C13.4428 6.33333 13.6667 6.10948 13.6667 5.83333V2.5C13.6663 2.43354 13.6527 2.36781 13.6267 2.30667Z"
        fill="white"
      />
      <path
        d="M11.8333 7.33333C11.5587 7.33692 11.3369 7.55869 11.3333 7.83333V10.5C11.3297 11.6951 10.3618 12.663 9.16667 12.6667H5.16667C3.97157 12.663 3.00366 11.6951 3 10.5V6.5C3.00366 5.3049 3.97157 4.33699 5.16667 4.33333H7.83333C8.10948 4.33333 8.33333 4.10948 8.33333 3.83333C8.33333 3.55719 8.10948 3.33333 7.83333 3.33333H5.16667C3.41777 3.33333 2 4.7511 2 6.5V10.5C2 12.2489 3.41777 13.6667 5.16667 13.6667H9.16667C10.9156 13.6667 12.3333 12.2489 12.3333 10.5V7.83333C12.3297 7.55869 12.108 7.33692 11.8333 7.33333Z"
        fill="white"
      />
    </svg>
  );
};

export const ClockIcons = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width="50px"
    height="50px"
    fill="#0E61D1"
  >
    <path d="M 16 4 C 9.382813 4 4 9.382813 4 16 C 4 22.617188 9.382813 28 16 28 C 22.617188 28 28 22.617188 28 16 C 28 9.382813 22.617188 4 16 4 Z M 14.96875 6.0625 C 14.980469 6.0625 14.988281 6.0625 15 6.0625 C 15.035156 6.585938 15.46875 7 16 7 C 16.53125 7 16.964844 6.585938 17 6.0625 C 21.738281 6.527344 25.472656 10.261719 25.9375 15 C 25.414063 15.035156 25 15.46875 25 16 C 25 16.53125 25.414063 16.964844 25.9375 17 C 25.472656 21.738281 21.738281 25.472656 17 25.9375 C 16.964844 25.414063 16.53125 25 16 25 C 15.46875 25 15.035156 25.414063 15 25.9375 C 10.261719 25.472656 6.527344 21.738281 6.0625 17 C 6.585938 16.964844 7 16.53125 7 16 C 7 15.46875 6.585938 15.035156 6.0625 15 C 6.527344 10.269531 10.246094 6.539063 14.96875 6.0625 Z M 15 9 L 15 16.40625 L 15.28125 16.71875 L 19.28125 20.71875 L 20.71875 19.28125 L 17 15.5625 L 17 9 Z" />
  </svg>
);

export const HistoryIcons = () => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0" />
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M3 5.67541V3C3 2.44772 2.55228 2 2 2C1.44772 2 1 2.44772 1 3V7C1 8.10457 1.89543 9 3 9H7C7.55229 9 8 8.55229 8 8C8 7.44772 7.55229 7 7 7H4.52186C4.54218 6.97505 4.56157 6.94914 4.57995 6.92229C5.621 5.40094 7.11009 4.22911 8.85191 3.57803C10.9074 2.80968 13.173 2.8196 15.2217 3.6059C17.2704 4.3922 18.9608 5.90061 19.9745 7.8469C20.9881 9.79319 21.2549 12.043 20.7247 14.1724C20.1945 16.3018 18.9039 18.1638 17.0959 19.4075C15.288 20.6513 13.0876 21.1909 10.9094 20.9247C8.73119 20.6586 6.72551 19.605 5.27028 17.9625C4.03713 16.5706 3.27139 14.8374 3.06527 13.0055C3.00352 12.4566 2.55674 12.0079 2.00446 12.0084C1.45217 12.0088 0.995668 12.4579 1.04626 13.0078C1.25994 15.3309 2.2082 17.5356 3.76666 19.2946C5.54703 21.3041 8.00084 22.5931 10.6657 22.9188C13.3306 23.2444 16.0226 22.5842 18.2345 21.0626C20.4464 19.541 22.0254 17.263 22.6741 14.6578C23.3228 12.0526 22.9963 9.30013 21.7562 6.91897C20.5161 4.53782 18.448 2.69239 15.9415 1.73041C13.4351 0.768419 10.6633 0.756291 8.14853 1.69631C6.06062 2.47676 4.26953 3.86881 3 5.67541Z"
        fill="#0F0F0F"
      />{" "}
      <path
        d="M12 5C11.4477 5 11 5.44771 11 6V12.4667C11 12.4667 11 12.7274 11.1267 12.9235C11.2115 13.0898 11.3437 13.2344 11.5174 13.3346L16.1372 16.0019C16.6155 16.278 17.2271 16.1141 17.5032 15.6358C17.7793 15.1575 17.6155 14.546 17.1372 14.2698L13 11.8812V6C13 5.44772 12.5523 5 12 5Z"
        fill="#0F0F0F"
      />{" "}
    </g>
  </svg>
);

export const KycApproveIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26 13C26 14.11 24.64 15 24.36 16.05C24.08 17.1 24.8 18.58 24.26 19.5C23.72 20.42 22.08 20.55 21.32 21.32C20.56 22.09 20.44 23.72 19.5 24.26C18.56 24.8 17.1 24.08 16.05 24.36C15 24.64 14.11 26 13 26C11.89 26 11 24.64 10 24.36C9 24.08 7.47 24.8 6.55 24.26C5.63 23.72 5.5 22.08 4.73 21.32C3.96 20.56 2.33 20.44 1.79 19.5C1.25 18.56 1.97 17.1 1.69 16.05C1.41 15 0 14.11 0 13C0 11.89 1.36 11 1.64 10C1.92 9 1.2 7.47 1.74 6.55C2.28 5.63 3.92 5.45 4.68 4.68C5.44 3.91 5.56 2.28 6.5 1.74C7.44 1.2 8.9 1.92 9.95 1.64C11 1.36 11.89 0 13 0C14.11 0 15 1.36 16.05 1.64C17.1 1.92 18.58 1.2 19.5 1.74C20.42 2.28 20.55 3.92 21.32 4.68C22.09 5.44 23.72 5.56 24.26 6.5C24.8 7.44 24.08 8.9 24.36 9.95C24.64 11 26 11.89 26 13Z"
      fill="#34C759"
    />
    <path
      d="M13 21.5C17.6944 21.5 21.5 17.6944 21.5 13C21.5 8.30558 17.6944 4.5 13 4.5C8.30558 4.5 4.5 8.30558 4.5 13C4.5 17.6944 8.30558 21.5 13 21.5Z"
      fill="#60F385"
    />
    <path
      className="check"
      d="M12.1301 15.3692C12.0316 15.3696 11.9339 15.3504 11.8429 15.3126C11.7519 15.2749 11.6694 15.2193 11.6001 15.1492L9.27012 12.8592C9.12967 12.7185 9.05078 12.5279 9.05078 12.3292C9.05078 12.1304 9.12967 11.9398 9.27012 11.7992C9.41075 11.6587 9.60137 11.5798 9.80012 11.5798C9.99887 11.5798 10.1895 11.6587 10.3301 11.7992L12.1301 13.5792L15.6701 10.0892C15.812 9.94861 16.0039 9.87016 16.2037 9.8711C16.4034 9.87204 16.5946 9.95228 16.7351 10.0942C16.8757 10.2361 16.9541 10.428 16.9532 10.6277C16.9523 10.8274 16.872 11.0186 16.7301 11.1592L12.6501 15.1592C12.5826 15.2281 12.5016 15.2824 12.4121 15.3185C12.3226 15.3547 12.2266 15.3719 12.1301 15.3692Z"
      fill="#141414"
    />
  </svg>
);

export const NoDataIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_130_41457)">
      <path
        d="M39.5373 28.2482C38.683 27.3938 37.298 27.3938 36.4438 28.2482L35.8127 28.8793L35.1816 28.2482C34.3272 27.3938 32.9422 27.3938 32.088 28.2482C31.2338 29.1025 31.2337 30.4875 32.088 31.3417L32.7191 31.9728L32.088 32.6039C31.2337 33.4582 31.2337 34.8433 32.088 35.6975C32.5151 36.1246 33.0749 36.3382 33.6348 36.3382C34.1947 36.3382 34.7545 36.1246 35.1816 35.6975L35.8127 35.0664L36.4438 35.6975C36.8709 36.1246 37.4307 36.3382 37.9905 36.3382C38.5504 36.3382 39.1102 36.1246 39.5373 35.6975C40.3917 34.8432 40.3917 33.4581 39.5373 32.6039L38.9062 31.9728L39.5373 31.3417C40.3917 30.4874 40.3917 29.1024 39.5373 28.2482Z"
        fill="#878785"
      />
      <path
        d="M16.463 35.6975C16.8901 36.1246 17.4499 36.3382 18.0098 36.3382C18.5697 36.3382 19.1295 36.1246 19.5566 35.6975L20.1877 35.0664L20.8188 35.6975C21.2459 36.1246 21.8057 36.3382 22.3655 36.3382C22.9254 36.3382 23.4852 36.1246 23.9123 35.6975C24.7667 34.8432 24.7667 33.4581 23.9123 32.6039L23.2812 31.9728L23.9123 31.3417C24.7667 30.4874 24.7667 29.1024 23.9123 28.2482C23.058 27.3939 21.673 27.3938 20.8188 28.2482L20.1877 28.8793L19.5566 28.2482C18.7022 27.3938 17.3172 27.3938 16.463 28.2482C15.6088 29.1025 15.6087 30.4875 16.463 31.3417L17.0941 31.9728L16.463 32.6039C15.6087 33.4581 15.6087 34.8432 16.463 35.6975Z"
        fill="#878785"
      />
      <path
        d="M25.2442 44.3877C26.7641 42.8679 29.2368 42.8679 30.7566 44.3877C31.1837 44.8149 31.7435 45.0285 32.3034 45.0285C32.8632 45.0285 33.423 44.8149 33.8501 44.3877C34.7045 43.5334 34.7045 42.1484 33.8501 41.2942C30.6246 38.0686 25.3761 38.0686 22.1505 41.2942C21.2962 42.1485 21.2962 43.5335 22.1505 44.3877C23.0048 45.242 24.39 45.2421 25.2442 44.3877Z"
        fill="#878785"
      />
      <path
        d="M47.25 0.974609H8.75C3.92525 0.974609 0 4.89986 0 9.72461V46.2737C0 51.0984 3.92525 55.0237 8.75 55.0237H47.25C52.0574 55.0237 55.9823 51.1125 55.9995 46.3052C56.0037 45.0971 55.0279 44.1142 53.8197 44.1099H53.8117C52.6073 44.1099 51.6287 45.0841 51.6243 46.2897C51.6158 48.6933 49.6534 50.6488 47.2499 50.6488H8.75C6.33763 50.6488 4.375 48.6862 4.375 46.2738V22.7702H51.625V35.3599C51.625 36.568 52.6043 37.5474 53.8125 37.5474C55.0207 37.5474 56 36.568 56 35.3599V9.72461C56 4.89986 52.0747 0.974609 47.25 0.974609ZM4.375 18.3951V9.72461C4.375 7.31223 6.33763 5.34961 8.75 5.34961H47.25C49.6624 5.34961 51.625 7.31223 51.625 9.72461V18.3951H4.375Z"
        fill="#878785"
      />
      <path
        d="M11.847 9.68359H10.7109C9.50278 9.68359 8.52344 10.6629 8.52344 11.8711C8.52344 13.0793 9.50278 14.0586 10.7109 14.0586H11.847C13.0552 14.0586 14.0345 13.0793 14.0345 11.8711C14.0345 10.6629 13.0552 9.68359 11.847 9.68359Z"
        fill="#878785"
      />
      <path
        d="M20.8236 9.68359H19.6875C18.4793 9.68359 17.5 10.6629 17.5 11.8711C17.5 13.0793 18.4793 14.0586 19.6875 14.0586H20.8236C22.0317 14.0586 23.0111 13.0793 23.0111 11.8711C23.0111 10.6629 22.0317 9.68359 20.8236 9.68359Z"
        fill="#878785"
      />
      <path
        d="M29.8001 9.68359H28.6641C27.4559 9.68359 26.4766 10.6629 26.4766 11.8711C26.4766 13.0793 27.4559 14.0586 28.6641 14.0586H29.8001C31.0083 14.0586 31.9876 13.0793 31.9876 11.8711C31.9876 10.6629 31.0083 9.68359 29.8001 9.68359Z"
        fill="#878785"
      />
    </g>
    <defs>
      <clipPath id="clip0_130_41457">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TransferWireIcon = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="50" height="50" rx="25" fill="#F6F6F6" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.666 25.0003C15.666 20.6006 15.666 18.4007 17.0329 17.0338C18.3997 15.667 20.5996 15.667 24.9993 15.667C29.3991 15.667 31.599 15.667 32.9658 17.0338C34.3327 18.4007 34.3327 20.6006 34.3327 25.0003C34.3327 29.4001 34.3327 31.6 32.9658 32.9668C31.599 34.3337 29.3991 34.3337 24.9993 34.3337C20.5996 34.3337 18.3997 34.3337 17.0329 32.9668C15.666 31.6 15.666 29.4001 15.666 25.0003ZM29.666 26.167C29.9578 26.167 30.219 26.348 30.3214 26.6212C30.4239 26.8944 30.3461 27.2025 30.1263 27.3944L26.918 30.1944C26.6267 30.4486 26.1845 30.4185 25.9303 30.1273C25.6761 29.836 25.7061 29.3938 25.9974 29.1396L27.7993 27.567L20.3327 27.567C19.9461 27.567 19.6327 27.2536 19.6327 26.867C19.6327 26.4804 19.9461 26.167 20.3327 26.167L29.666 26.167ZM24.0684 19.8734C24.3226 20.1647 24.2926 20.6069 24.0013 20.8611L22.1993 22.4337H29.666C30.0526 22.4337 30.366 22.7471 30.366 23.1337C30.366 23.5203 30.0526 23.8337 29.666 23.8337H20.3327C20.0409 23.8337 19.7797 23.6527 19.6773 23.3794C19.5748 23.1062 19.6526 22.7981 19.8724 22.6063L23.0807 19.8063C23.372 19.5521 23.8142 19.5821 24.0684 19.8734Z"
      fill="#141414"
    />
  </svg>
);

export const CloseCircleIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_100_19524)">
      <path
        d="M13 26C5.83151 26 0 20.1685 0 13C0 5.83151 5.83151 0 13 0C20.1685 0 26 5.83151 26 13C26 20.1685 20.1685 26 13 26ZM13 1.625C6.72752 1.625 1.625 6.72752 1.625 13C1.625 19.2725 6.72752 24.375 13 24.375C19.2725 24.375 24.375 19.2725 24.375 13C24.375 6.72752 19.2725 1.625 13 1.625Z"
        fill="black"
      />
      <path
        d="M8.97832 17.8335C8.77023 17.8335 8.56215 17.7546 8.40405 17.5953C8.08667 17.2779 8.08667 16.7634 8.40405 16.446L16.4477 8.4021C16.7653 8.08472 17.2799 8.08472 17.5972 8.4021C17.9146 8.71948 17.9146 9.23404 17.5972 9.55162L9.55338 17.5953C9.3931 17.7546 9.18521 17.8335 8.97832 17.8335Z"
        fill="black"
      />
      <path
        d="M17.0219 17.8335C16.8141 17.8335 16.606 17.7545 16.4479 17.5952L8.4042 9.55255C8.08662 9.23516 8.08662 8.72061 8.4042 8.40322C8.72158 8.08564 9.23614 8.08564 9.55352 8.40322L17.5972 16.4469C17.9148 16.7643 17.9148 17.2788 17.5972 17.5962C17.4381 17.7545 17.23 17.8335 17.0219 17.8335Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_100_19524">
        <rect width="26" height="26" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DeactivateIcon = () => (
  <svg
    width="67"
    height="67"
    viewBox="0 0 67 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_100_19823)">
      <path
        d="M33.5 0C15.0279 0 0 15.0279 0 33.5C0 51.9721 15.0279 67 33.5 67C51.9721 67 67 51.9721 67 33.5C67 15.0279 51.9721 0 33.5 0ZM33.5 52.5625C31.2166 52.5625 28.9511 52.15 26.8277 51.3572L51.3572 26.8287C52.15 28.9511 52.5625 31.2166 52.5625 33.5C52.5625 44.0107 44.0107 52.5625 33.5 52.5625ZM33.5 14.4375C35.7834 14.4375 38.0489 14.85 40.1723 15.6428L15.6428 40.1713C14.85 38.0489 14.4375 35.7834 14.4375 33.5C14.4375 22.9893 22.9893 14.4375 33.5 14.4375Z"
        fill="#FF3939"
      />
      <path
        d="M40.1723 15.6428L33.5 22.3151V44.6849L51.3572 26.8287C52.15 28.9511 52.5625 31.2166 52.5625 33.5C52.5625 44.0107 44.0107 52.5625 33.5 52.5625V67C51.9721 67 67 51.9721 67 33.5C67 15.0279 51.9721 0 33.5 0V14.4375C35.7834 14.4375 38.0489 14.85 40.1723 15.6428Z"
        fill="#B00000"
      />
    </g>
    <defs>
      <clipPath id="clip0_100_19823">
        <rect width="67" height="67" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DepositArrowIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.46447 6.46447C5 7.92893 5 10.286 5 15C5 19.714 5 22.0711 6.46447 23.5355C7.92893 25 10.286 25 15 25C19.714 25 22.0711 25 23.5355 23.5355C25 22.0711 25 19.714 25 15C25 10.286 25 7.92893 23.5355 6.46447C22.0711 5 19.714 5 15 5C10.286 5 7.92893 5 6.46447 6.46447ZM15 10.25C15.4142 10.25 15.75 10.5858 15.75 11V17.1893L17.4697 15.4697C17.7626 15.1768 18.2374 15.1768 18.5303 15.4697C18.8232 15.7626 18.8232 16.2374 18.5303 16.5303L15.5303 19.5303C15.3897 19.671 15.1989 19.75 15 19.75C14.8011 19.75 14.6103 19.671 14.4697 19.5303L11.4697 16.5303C11.1768 16.2374 11.1768 15.7626 11.4697 15.4697C11.7626 15.1768 12.2374 15.1768 12.5303 15.4697L14.25 17.1893V11C14.25 10.5858 14.5858 10.25 15 10.25Z"
      fill="#141414"
    />
  </svg>
);

export const WithdrawArrowIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.46447 23.5355C5 22.0711 5 19.714 5 15C5 10.286 5 7.92893 6.46447 6.46447C7.92893 5 10.286 5 15 5C19.714 5 22.0711 5 23.5355 6.46447C25 7.92893 25 10.286 25 15C25 19.714 25 22.0711 23.5355 23.5355C22.0711 25 19.714 25 15 25C10.286 25 7.92893 25 6.46447 23.5355ZM15 19.75C15.4142 19.75 15.75 19.4142 15.75 19V12.8107L17.4697 14.5303C17.7626 14.8232 18.2374 14.8232 18.5303 14.5303C18.8232 14.2374 18.8232 13.7626 18.5303 13.4697L15.5303 10.4697C15.3897 10.329 15.1989 10.25 15 10.25C14.8011 10.25 14.6103 10.329 14.4697 10.4697L11.4697 13.4697C11.1768 13.7626 11.1768 14.2374 11.4697 14.5303C11.7626 14.8232 12.2374 14.8232 12.5303 14.5303L14.25 12.8107V19C14.25 19.4142 14.5858 19.75 15 19.75Z"
      fill="#141414"
    />
  </svg>
);

export const ReciveBuyIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.4697 23.5303C21.7626 23.8232 22.2374 23.8232 22.5303 23.5303L24.5303 21.5303C24.8232 21.2374 24.8232 20.7626 24.5303 20.4697C24.2374 20.1768 23.7626 20.1768 23.4697 20.4697L22.75 21.1893V17C22.75 16.5858 22.4142 16.25 22 16.25C21.5858 16.25 21.25 16.5858 21.25 17V21.1893L20.5303 20.4697C20.2374 20.1768 19.7626 20.1768 19.4697 20.4697C19.1768 20.7626 19.1768 21.2374 19.4697 21.5303L21.4697 23.5303Z"
      fill="#141414"
    />
    <path
      d="M13 7H17C20.7712 7 22.6569 7 23.8284 8.17157C24.672 9.01511 24.9082 10.2288 24.9743 12.25H5.02572C5.09185 10.2288 5.32803 9.01511 6.17157 8.17157C7.34315 7 9.22876 7 13 7Z"
      fill="#141414"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 23H17C17.6595 23 18.2613 23 18.8118 22.9937L18.409 22.591C17.5303 21.7123 17.5303 20.2877 18.409 19.409C18.7847 19.0334 19.2601 18.8183 19.75 18.7638V17C19.75 15.7574 20.7574 14.75 22 14.75C23.2426 14.75 24.25 15.7574 24.25 17V18.7638C24.4739 18.7887 24.6947 18.8471 24.9044 18.9391C25 17.9172 25 16.636 25 15C25 14.5581 25 14.142 24.9981 13.75H5.00189C5 14.142 5 14.5581 5 15C5 18.7712 5 20.6569 6.17157 21.8284C7.34315 23 9.22876 23 13 23ZM9 18.25C8.58579 18.25 8.25 18.5858 8.25 19C8.25 19.4142 8.58579 19.75 9 19.75H13C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25H9ZM15.5 18.25C15.0858 18.25 14.75 18.5858 14.75 19C14.75 19.4142 15.0858 19.75 15.5 19.75H17C17.4142 19.75 17.75 19.4142 17.75 19C17.75 18.5858 17.4142 18.25 17 18.25H15.5Z"
      fill="#141414"
    />
  </svg>
);

export const SendSellIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.4697 16.4697C21.7626 16.1768 22.2374 16.1768 22.5303 16.4697L24.5303 18.4697C24.8232 18.7626 24.8232 19.2374 24.5303 19.5303C24.2374 19.8232 23.7626 19.8232 23.4697 19.5303L22.75 18.8107V23C22.75 23.4142 22.4142 23.75 22 23.75C21.5858 23.75 21.25 23.4142 21.25 23V18.8107L20.5303 19.5303C20.2374 19.8232 19.7626 19.8232 19.4697 19.5303C19.1768 19.2374 19.1768 18.7626 19.4697 18.4697L21.4697 16.4697Z"
      fill="#141414"
    />
    <path
      d="M13 7H17C20.7712 7 22.6569 7 23.8284 8.17157C24.672 9.01511 24.9082 10.2288 24.9743 12.25H5.02572C5.09185 10.2288 5.32803 9.01511 6.17157 8.17157C7.34315 7 9.22876 7 13 7Z"
      fill="#141414"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 23H17C18.0559 23 18.964 23 19.75 22.9743V21.2362C19.2601 21.1817 18.7847 20.9666 18.409 20.591C17.5303 19.7123 17.5303 18.2877 18.409 17.409L20.409 15.409C21.2877 14.5303 22.7123 14.5303 23.591 15.409L24.9937 16.8118C25 16.2613 25 15.6595 25 15C25 14.5581 25 14.142 24.9981 13.75H5.00189C5 14.142 5 14.5581 5 15C5 18.7712 5 20.6569 6.17157 21.8284C7.34315 23 9.22876 23 13 23ZM8.25 19C8.25 18.5858 8.58579 18.25 9 18.25H13C13.4142 18.25 13.75 18.5858 13.75 19C13.75 19.4142 13.4142 19.75 13 19.75H9C8.58579 19.75 8.25 19.4142 8.25 19ZM15.5 18.25C15.0858 18.25 14.75 18.5858 14.75 19C14.75 19.4142 15.0858 19.75 15.5 19.75H17C17.4142 19.75 17.75 19.4142 17.75 19C17.75 18.5858 17.4142 18.25 17 18.25H15.5Z"
      fill="#141414"
    />
  </svg>
);

export const CheckCircleIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.49167 5.4252C4.25833 5.19186 3.90833 5.19186 3.675 5.4252C3.44167 5.65853 3.44167 6.00853 3.675 6.24186L5.425 7.99186C5.54167 8.10853 5.65833 8.16686 5.83333 8.16686C6.00833 8.16686 6.125 8.10853 6.24167 7.99186L10.325 3.3252C10.5 3.03353 10.5 2.68353 10.2083 2.50853C9.975 2.33353 9.625 2.33353 9.45 2.56686L5.83333 6.70853L4.49167 5.4252Z"
      fill="#878785"
    />
    <path
      d="M11.0833 5.25C10.7333 5.25 10.5 5.48333 10.5 5.83333C10.5 8.4 8.4 10.5 5.83333 10.5C3.26667 10.5 1.16667 8.4 1.16667 5.83333C1.16667 4.60833 1.63333 3.44167 2.50833 2.56667C3.38333 1.63333 4.55 1.16667 5.83333 1.16667C6.18333 1.16667 6.59167 1.225 6.94167 1.28333C7.23333 1.4 7.58333 1.225 7.7 0.875C7.81667 0.525 7.58333 0.291667 7.29167 0.175H7.23333C6.76667 0.0583333 6.3 0 5.83333 0C2.625 0 0 2.625 0 5.89167C0 7.40833 0.641667 8.925 1.69167 9.975C2.8 11.0833 4.25833 11.6667 5.775 11.6667C8.98333 11.6667 11.6083 9.04167 11.6083 5.83333C11.6667 5.48333 11.375 5.25 11.0833 5.25Z"
      fill="#878785"
    />
  </svg>
);

export const CircleadditionIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_73_2774)">
      <path
        d="M7 14C3.14005 14 0 10.86 0 7C0 3.14005 3.14005 0 7 0C10.86 0 14 3.14005 14 7C14 10.86 10.86 14 7 14ZM7 0.875C3.62251 0.875 0.875 3.62251 0.875 7C0.875 10.3775 3.62251 13.125 7 13.125C10.3775 13.125 13.125 10.3775 13.125 7C13.125 3.62251 10.3775 0.875 7 0.875Z"
        fill="black"
      />
      <path
        d="M10.0625 7.4375H3.9375C3.696 7.4375 3.5 7.2415 3.5 7C3.5 6.7585 3.696 6.5625 3.9375 6.5625H10.0625C10.304 6.5625 10.5 6.7585 10.5 7C10.5 7.2415 10.304 7.4375 10.0625 7.4375Z"
        fill="black"
      />
      <path
        d="M7 10.5C6.7585 10.5 6.5625 10.304 6.5625 10.0625V3.9375C6.5625 3.696 6.7585 3.5 7 3.5C7.2415 3.5 7.4375 3.696 7.4375 3.9375V10.0625C7.4375 10.304 7.2415 10.5 7 10.5Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_73_2774">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CirclesubtractionIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_73_2769)">
      <path
        d="M7 14C3.14005 14 0 10.86 0 7C0 3.14005 3.14005 0 7 0C10.86 0 14 3.14005 14 7C14 10.86 10.86 14 7 14ZM7 0.875C3.62251 0.875 0.875 3.62251 0.875 7C0.875 10.3775 3.62251 13.125 7 13.125C10.3775 13.125 13.125 10.3775 13.125 7C13.125 3.62251 10.3775 0.875 7 0.875Z"
        fill="black"
      />
      <path
        d="M3.5 7C3.5 6.7585 3.696 6.5625 3.9375 6.5625L10.0625 6.5625C10.304 6.5625 10.5 6.7585 10.5 7C10.5 7.2415 10.304 7.4375 10.0625 7.4375L3.9375 7.4375C3.696 7.4375 3.5 7.2415 3.5 7Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_73_2769">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FullArrowIcon = () => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1613 0.25C9.88559 0.25 9.66213 0.460322 9.66213 0.719767C9.66213 0.979213 9.88559 1.18953 10.1613 1.18953H12.8542L9.04774 4.77209C8.85282 4.95554 8.85282 5.25298 9.04774 5.43644C9.24266 5.61989 9.55869 5.61989 9.75361 5.43644L13.5601 1.85389V4.38843C13.5601 4.64787 13.7835 4.85819 14.0592 4.85819C14.3349 4.85819 14.5583 4.64787 14.5583 4.38843V0.719767C14.5583 0.460322 14.3349 0.25 14.0592 0.25H10.1613Z"
      fill="#1F2937"
    />
    <path
      d="M4.64708 13.7167C4.92274 13.7167 5.14621 13.5063 5.14621 13.2469C5.14621 12.9875 4.92274 12.7771 4.64708 12.7771H1.95413L5.76059 9.19458C5.95551 9.01112 5.95551 8.71368 5.76059 8.53023C5.56567 8.34677 5.24964 8.34677 5.05472 8.53023L1.24826 12.1128V9.57824C1.24826 9.31879 1.02479 9.10847 0.749128 9.10847C0.473467 9.10847 0.25 9.31879 0.25 9.57824V13.2469C0.25 13.5063 0.473467 13.7167 0.749128 13.7167H4.64708Z"
      fill="#1F2937"
    />
    <path
      d="M10.1613 0.25C9.88559 0.25 9.66213 0.460322 9.66213 0.719767C9.66213 0.979213 9.88559 1.18953 10.1613 1.18953H12.8542L9.04774 4.77209C8.85282 4.95554 8.85282 5.25298 9.04774 5.43644C9.24266 5.61989 9.55869 5.61989 9.75361 5.43644L13.5601 1.85389V4.38843C13.5601 4.64787 13.7835 4.85819 14.0592 4.85819C14.3349 4.85819 14.5583 4.64787 14.5583 4.38843V0.719767C14.5583 0.460322 14.3349 0.25 14.0592 0.25H10.1613Z"
      stroke="#1F2937"
      stroke-width="0.5"
    />
    <path
      d="M4.64708 13.7167C4.92274 13.7167 5.14621 13.5063 5.14621 13.2469C5.14621 12.9875 4.92274 12.7771 4.64708 12.7771H1.95413L5.76059 9.19458C5.95551 9.01112 5.95551 8.71368 5.76059 8.53023C5.56567 8.34677 5.24964 8.34677 5.05472 8.53023L1.24826 12.1128V9.57824C1.24826 9.31879 1.02479 9.10847 0.749128 9.10847C0.473467 9.10847 0.25 9.31879 0.25 9.57824V13.2469C0.25 13.5063 0.473467 13.7167 0.749128 13.7167H4.64708Z"
      stroke="#1F2937"
      stroke-width="0.5"
    />
  </svg>
);

export const CameraIcon = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.049 13.9991H9.50557C11.9329 13.9991 13.1465 13.9991 14.0184 13.4272C14.3958 13.1796 14.7198 12.8614 14.972 12.4908C15.5546 11.6349 15.5546 10.4433 15.5546 8.06009C15.5546 5.67691 15.5546 4.48533 14.972 3.62935C14.7198 3.25879 14.3958 2.94062 14.0184 2.69302C13.4582 2.32551 12.7568 2.19415 11.683 2.1472C11.1706 2.1472 10.7294 1.76597 10.629 1.27265C10.4782 0.532657 9.81645 0 9.04783 0H6.50674C5.73812 0 5.07635 0.532657 4.92561 1.27265C4.82512 1.76597 4.38394 2.1472 3.87153 2.1472C2.79775 2.19415 2.09641 2.32551 1.5362 2.69302C1.15878 2.94062 0.834723 3.25879 0.582537 3.62935C0 4.48533 0 5.67691 0 8.06009C0 10.4433 0 11.6349 0.582537 12.4908C0.834723 12.8614 1.15878 13.1796 1.5362 13.4272C2.40803 13.9991 3.62169 13.9991 6.049 13.9991Z"
      fill="#1F2937"
    />
    <path
      className="circleicon"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.77728 6.15112C6.70346 6.15112 5.83296 7.0058 5.83296 8.06009C5.83296 9.11439 6.70346 9.96906 7.77728 9.96906C8.8511 9.96906 9.7216 9.11439 9.7216 8.06009C9.7216 7.0058 8.8511 6.15112 7.77728 6.15112ZM4.53675 8.06009C4.53675 6.30294 5.98759 4.87848 7.77728 4.87848C9.56698 4.87848 11.0178 6.30294 11.0178 8.06009C11.0178 9.81725 9.56698 11.2417 7.77728 11.2417C5.98759 11.2417 4.53675 9.81725 4.53675 8.06009Z"
      fill="white"
    />
    <path
      className="circleicon"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4499 5.5148C11.4499 5.16337 11.7401 4.87848 12.098 4.87848H12.9621C13.3201 4.87848 13.6102 5.16337 13.6102 5.5148C13.6102 5.86623 13.3201 6.15112 12.9621 6.15112H12.098C11.7401 6.15112 11.4499 5.86623 11.4499 5.5148Z"
      fill="white"
    />
  </svg>
);

export const StblPaymentIcon = () => (
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5583 0H7.03889C3.72072 0 2.06164 0 1.03082 1.03082C0.288623 1.77302 0.0808123 2.84092 0.0226269 4.61927H17.5746C17.5164 2.84092 17.3086 1.77302 16.5664 1.03082C15.5356 0 13.8765 0 10.5583 0Z"
      fill="#878785"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5583 14.0778H7.03889C3.72072 14.0778 2.06164 14.0778 1.03082 13.047C0 12.0161 0 10.3571 0 7.03889C0 6.65005 0 6.28399 0.0016588 5.93906H17.5956C17.5972 6.28399 17.5972 6.65005 17.5972 7.03889C17.5972 10.3571 17.5972 12.0161 16.5664 13.047C15.5356 14.0778 13.8765 14.0778 10.5583 14.0778ZM12.3574 7.25885C12.7382 7.25881 13.0874 7.25877 13.3714 7.29695C13.6842 7.339 14.0148 7.43794 14.2867 7.70984C14.5586 7.98174 14.6575 8.31232 14.6996 8.6251C14.7378 8.90913 14.7377 9.25828 14.7377 9.6391V9.71784C14.7377 10.0987 14.7378 10.4478 14.6996 10.7318C14.6575 11.0446 14.5586 11.3752 14.2867 11.6471C14.0148 11.919 13.6842 12.0179 13.3714 12.06C13.0874 12.0982 12.7382 12.0981 12.3574 12.0981L12.3181 12.0981L12.2787 12.0981C11.8979 12.0981 11.5487 12.0982 11.2647 12.06C10.9519 12.0179 10.6213 11.919 10.3494 11.6471C10.0775 11.3752 9.97859 11.0446 9.93653 10.7318C9.89835 10.4478 9.89839 10.0987 9.89843 9.71784L9.89844 9.67847L9.89843 9.6391C9.89839 9.25828 9.89835 8.90913 9.93653 8.6251C9.97859 8.31232 10.0775 7.98174 10.3494 7.70984C10.6213 7.43794 10.9519 7.339 11.2647 7.29695C11.5487 7.25877 11.8979 7.25881 12.2787 7.25885H12.3574ZM2.85955 8.35868C2.85955 7.99423 3.15499 7.69878 3.51944 7.69878H5.27917C5.64362 7.69878 5.93906 7.99423 5.93906 8.35868C5.93906 8.72313 5.64362 9.01858 5.27917 9.01858H3.51944C3.15499 9.01858 2.85955 8.72313 2.85955 8.35868ZM2.85955 10.9983C2.85955 10.6338 3.15499 10.3384 3.51944 10.3384H7.03889C7.40334 10.3384 7.69878 10.6338 7.69878 10.9983C7.69878 11.3627 7.40334 11.6582 7.03889 11.6582H3.51944C3.15499 11.6582 2.85955 11.3627 2.85955 10.9983Z"
      fill="#878785"
    />
    <path
      d="M11.2827 8.64303L11.2848 8.64187C11.2865 8.64099 11.2894 8.63956 11.2939 8.63774C11.313 8.62985 11.3556 8.6164 11.4405 8.60497C11.6259 8.58005 11.8846 8.57865 12.3181 8.57865C12.7515 8.57865 13.0102 8.58005 13.1956 8.60497C13.2805 8.6164 13.3231 8.62985 13.3422 8.63774C13.3467 8.63956 13.3496 8.64099 13.3513 8.64187L13.3534 8.64308L13.3547 8.64523C13.3555 8.64693 13.357 8.64984 13.3588 8.65428C13.3667 8.67345 13.3801 8.716 13.3916 8.80096C13.4165 8.98636 13.4179 9.24505 13.4179 9.67847C13.4179 10.1119 13.4165 10.3706 13.3916 10.556C13.3801 10.6409 13.3667 10.6835 13.3588 10.7027C13.357 10.7071 13.3555 10.71 13.3547 10.7117L13.3534 10.7139L13.3513 10.7151C13.3496 10.716 13.3467 10.7174 13.3422 10.7192C13.3231 10.7271 13.2805 10.7405 13.1956 10.752C13.0102 10.7769 12.7515 10.7783 12.3181 10.7783C11.8846 10.7783 11.6259 10.7769 11.4405 10.752C11.3556 10.7405 11.313 10.7271 11.2939 10.7192C11.2894 10.7174 11.2865 10.716 11.2848 10.7151L11.2827 10.7139L11.2815 10.7117C11.2806 10.71 11.2791 10.7071 11.2773 10.7027C11.2694 10.6835 11.256 10.6409 11.2446 10.556C11.2196 10.3706 11.2182 10.1119 11.2182 9.67847C11.2182 9.24505 11.2196 8.98636 11.2446 8.80096C11.256 8.716 11.2694 8.67345 11.2773 8.65428C11.2791 8.64984 11.2806 8.64693 11.2815 8.64523L11.2827 8.64303Z"
      fill="#878785"
    />
  </svg>
);

export const CartNewIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.877666 0.034392C0.52837 -0.0820399 0.150824 0.106733 0.034392 0.456029C-0.0820399 0.805325 0.106733 1.18287 0.456029 1.2993L0.691505 1.37779C1.29276 1.57821 1.69027 1.71178 1.98311 1.84801C2.26041 1.97701 2.3803 2.08083 2.45712 2.18741C2.53393 2.29399 2.59451 2.44055 2.6292 2.74442C2.66584 3.06531 2.66685 3.48466 2.66685 4.11844L2.66685 6.4934C2.66683 7.70904 2.66681 8.68888 2.77042 9.45951C2.87799 10.2596 3.10812 10.9333 3.64316 11.4683C4.1782 12.0034 4.85186 12.2335 5.65196 12.341C6.42259 12.4447 7.40243 12.4446 8.61806 12.4446H14.8891C15.2573 12.4446 15.5557 12.1461 15.5557 11.778C15.5557 11.4098 15.2573 11.1113 14.8891 11.1113H8.66685C7.39092 11.1113 6.50104 11.1099 5.82962 11.0196C5.17738 10.9319 4.83198 10.7715 4.58597 10.5255C4.37691 10.3165 4.22968 10.0356 4.13635 9.55574H13.1309C13.9837 9.55574 14.4101 9.55574 14.7441 9.33552C15.078 9.11531 15.246 8.72338 15.5819 7.93952L15.9629 7.05063C16.6824 5.37168 17.0422 4.5322 16.647 3.93286C16.2518 3.33351 15.3385 3.33351 13.5118 3.33351H3.99578C3.99054 3.06001 3.97906 2.81326 3.95393 2.59318C3.90473 2.16223 3.79752 1.76679 3.53877 1.40779C3.28002 1.0488 2.93878 0.822044 2.54551 0.63909C2.17552 0.466971 1.70501 0.310151 1.14823 0.124581L0.877666 0.034392Z"
      fill="#787FFF"
    />
    <path
      d="M5.55556 14.0002C6.29193 14.0002 6.88889 14.5972 6.88889 15.3335C6.88889 16.0699 6.29194 16.6669 5.55556 16.6669C4.81918 16.6669 4.22222 16.0699 4.22222 15.3335C4.22222 14.5972 4.81918 14.0002 5.55556 14.0002Z"
      fill="#787FFF"
    />
    <path
      d="M13.5556 14.0003C14.2919 14.0003 14.8889 14.5972 14.8889 15.3336C14.8889 16.07 14.2919 16.6669 13.5556 16.6669C12.8192 16.6669 12.2222 16.07 12.2222 15.3336C12.2222 14.5972 12.8192 14.0003 13.5556 14.0003Z"
      fill="#787FFF"
    />
  </svg>
);

export const RedArrowIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 6.5C7.72386 6.5 7.5 6.27614 7.5 6C7.5 5.72386 7.72386 5.5 8 5.5H14C14.2761 5.5 14.5 5.72386 14.5 6V12C14.5 12.2761 14.2761 12.5 14 12.5C13.7239 12.5 13.5 12.2761 13.5 12V7.20711L6.35355 14.3536C6.15829 14.5488 5.84171 14.5488 5.64645 14.3536C5.45118 14.1583 5.45118 13.8417 5.64645 13.6464L12.7929 6.5H8Z"
      fill="#FF3B30"
    />
  </svg>
);

export const GreenArrowIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 6.5C7.72386 6.5 7.5 6.27614 7.5 6C7.5 5.72386 7.72386 5.5 8 5.5H14C14.2761 5.5 14.5 5.72386 14.5 6V12C14.5 12.2761 14.2761 12.5 14 12.5C13.7239 12.5 13.5 12.2761 13.5 12V7.20711L6.35355 14.3536C6.15829 14.5488 5.84171 14.5488 5.64645 14.3536C5.45118 14.1583 5.45118 13.8417 5.64645 13.6464L12.7929 6.5H8Z"
      fill="#18a83c"
      transform="rotate(180 10 10)"
    />
  </svg>
);
export const DocIcon = () => (
  <svg
    width="15"
    height="21"
    viewBox="0 0 15 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 3.75V0.0975001C10.8658 0.199125 11.1996 0.392457 11.4697 0.659183L14.3408 3.53025C14.6077 3.80034 14.801 4.13415 14.9026 4.5H11.25C11.0511 4.4998 10.8605 4.42072 10.7199 4.28011C10.5793 4.1395 10.5002 3.94885 10.5 3.75ZM15 6V18.75C14.9993 19.3465 14.7621 19.9185 14.3403 20.3403C13.9185 20.7621 13.3465 20.9993 12.75 21H2.25C1.65346 20.9993 1.08154 20.7621 0.659729 20.3403C0.237913 19.9185 0.000651147 19.3465 0 18.75V2.25C0.000651147 1.65346 0.237913 1.08154 0.659729 0.659729C1.08154 0.237913 1.65346 0.000651147 2.25 0H9V3.75C9.00065 4.34654 9.23791 4.91846 9.65973 5.34027C10.0815 5.76209 10.6535 5.99935 11.25 6H15ZM3.75 14.25C3.75 14.1017 3.70601 13.9567 3.6236 13.8333C3.54119 13.71 3.42406 13.6139 3.28701 13.5571C3.14997 13.5003 2.99917 13.4855 2.85368 13.5144C2.7082 13.5433 2.57456 13.6148 2.46967 13.7197C2.36478 13.8246 2.29335 13.9582 2.26441 14.1037C2.23547 14.2492 2.25032 14.4 2.30709 14.537C2.36386 14.6741 2.45999 14.7912 2.58332 14.8736C2.70666 14.956 2.85166 15 3 15C3.19891 15 3.38968 14.921 3.53033 14.7803C3.67098 14.6397 3.75 14.4489 3.75 14.25ZM3.75 11.25C3.75 11.1017 3.70601 10.9567 3.6236 10.8333C3.54119 10.71 3.42406 10.6139 3.28701 10.5571C3.14997 10.5003 2.99917 10.4855 2.85368 10.5144C2.7082 10.5433 2.57456 10.6148 2.46967 10.7197C2.36478 10.8246 2.29335 10.9582 2.26441 11.1037C2.23547 11.2492 2.25032 11.4 2.30709 11.537C2.36386 11.6741 2.45999 11.7912 2.58332 11.8736C2.70666 11.956 2.85166 12 3 12C3.19891 12 3.38968 11.921 3.53033 11.7803C3.67098 11.6397 3.75 11.4489 3.75 11.25ZM3.75 8.25C3.75 8.10166 3.70601 7.95666 3.6236 7.83332C3.54119 7.70999 3.42406 7.61386 3.28701 7.55709C3.14997 7.50032 2.99917 7.48547 2.85368 7.51441C2.7082 7.54335 2.57456 7.61478 2.46967 7.71967C2.36478 7.82456 2.29335 7.9582 2.26441 8.10368C2.23547 8.24917 2.25032 8.39997 2.30709 8.53701C2.36386 8.67406 2.45999 8.79119 2.58332 8.8736C2.70666 8.95601 2.85166 9 3 9C3.19891 9 3.38968 8.92098 3.53033 8.78033C3.67098 8.63968 3.75 8.44891 3.75 8.25ZM12.75 14.25C12.75 14.1515 12.7306 14.054 12.693 13.963C12.6553 13.872 12.6 13.7893 12.5304 13.7196C12.4607 13.65 12.378 13.5947 12.287 13.557C12.196 13.5194 12.0985 13.5 12 13.5H5.25C5.05109 13.5 4.86032 13.579 4.71967 13.7197C4.57902 13.8603 4.5 14.0511 4.5 14.25C4.5 14.4489 4.57902 14.6397 4.71967 14.7803C4.86032 14.921 5.05109 15 5.25 15H12C12.0985 15 12.196 14.9806 12.287 14.943C12.378 14.9053 12.4607 14.85 12.5304 14.7804C12.6 14.7107 12.6553 14.628 12.693 14.537C12.7306 14.446 12.75 14.3485 12.75 14.25ZM12.75 11.25C12.75 11.1515 12.7306 11.054 12.693 10.963C12.6553 10.872 12.6 10.7893 12.5304 10.7196C12.4607 10.65 12.378 10.5947 12.287 10.557C12.196 10.5194 12.0985 10.5 12 10.5H5.25C5.05109 10.5 4.86032 10.579 4.71967 10.7197C4.57902 10.8603 4.5 11.0511 4.5 11.25C4.5 11.4489 4.57902 11.6397 4.71967 11.7803C4.86032 11.921 5.05109 12 5.25 12H12C12.0985 12 12.196 11.9806 12.287 11.943C12.378 11.9053 12.4607 11.85 12.5304 11.7804C12.6 11.7107 12.6553 11.628 12.693 11.537C12.7306 11.446 12.75 11.3485 12.75 11.25ZM12.75 8.25C12.75 8.1515 12.7306 8.05396 12.693 7.96296C12.6553 7.87195 12.6 7.78926 12.5304 7.71961C12.4607 7.64996 12.378 7.59472 12.287 7.55704C12.196 7.51936 12.0985 7.49997 12 7.5H5.25C5.05109 7.5 4.86032 7.57902 4.71967 7.71967C4.57902 7.86032 4.5 8.05109 4.5 8.25C4.5 8.44891 4.57902 8.63968 4.71967 8.78033C4.86032 8.92098 5.05109 9 5.25 9H12C12.0985 9.00003 12.196 8.98064 12.287 8.94296C12.378 8.90528 12.4607 8.85004 12.5304 8.78039C12.6 8.71074 12.6553 8.62805 12.693 8.53704C12.7306 8.44604 12.75 8.3485 12.75 8.25Z"
      fill="white"
    />
  </svg>
);

export const CardIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 9.75H1.5V17.25C1.5 17.8467 1.73705 18.419 2.15901 18.841C2.58097 19.2629 3.15326 19.5 3.75 19.5H20.25C20.8467 19.5 21.419 19.2629 21.841 18.841C22.2629 18.419 22.5 17.8467 22.5 17.25V9.75H3ZM5.25 15H7.5C7.69891 15 7.88968 15.079 8.03033 15.2197C8.17098 15.3603 8.25 15.5511 8.25 15.75C8.25 15.9489 8.17098 16.1397 8.03033 16.2803C7.88968 16.421 7.69891 16.5 7.5 16.5H5.25C5.05109 16.5 4.86032 16.421 4.71967 16.2803C4.57902 16.1397 4.5 15.9489 4.5 15.75C4.5 15.5511 4.57902 15.3603 4.71967 15.2197C4.86032 15.079 5.05109 15 5.25 15ZM22.5 6.75V8.25H1.5V6.75C1.5 6.15326 1.73705 5.58097 2.15901 5.15901C2.58097 4.73705 3.15326 4.5 3.75 4.5H20.25C20.8467 4.5 21.419 4.73705 21.841 5.15901C22.2629 5.58097 22.5 6.15326 22.5 6.75Z"
      fill="white"
    />
  </svg>
);
export const EyecircleIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
      fill="white"
    />
    <path
      d="M18.2 19.9996C18.2 19.0055 19.0059 18.1996 20 18.1996C20.9941 18.1996 21.8 19.0055 21.8 19.9996C21.8 20.9937 20.9941 21.7996 20 21.7996C19.0059 21.7996 18.2 20.9937 18.2 19.9996Z"
      fill="#141414"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 19.9996C12 21.3111 12.34 21.7528 13.0199 22.6361C14.3776 24.4 16.6545 26.3996 20 26.3996C23.3455 26.3996 25.6224 24.4 26.9801 22.6361C27.66 21.7528 28 21.3111 28 19.9996C28 18.6881 27.66 18.2464 26.9801 17.3631C25.6224 15.5993 23.3455 13.5996 20 13.5996C16.6545 13.5996 14.3776 15.5993 13.0199 17.3631C12.34 18.2464 12 18.6881 12 19.9996ZM20 16.9996C18.3431 16.9996 17 18.3428 17 19.9996C17 21.6565 18.3431 22.9996 20 22.9996C21.6569 22.9996 23 21.6565 23 19.9996C23 18.3428 21.6569 16.9996 20 16.9996Z"
      fill="#141414"
    />
  </svg>
);
export const ReportcircleIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.1716 26.8284C14.3431 28 16.2288 28 20 28C23.7712 28 25.6569 28 26.8284 26.8284C28 25.6569 28 23.7712 28 20C28 16.2288 28 14.3431 26.8284 13.1716C25.6569 12 23.7712 12 20 12C16.2288 12 14.3431 12 13.1716 13.1716C12 14.3431 12 16.2288 12 20C12 23.7712 12 25.6569 13.1716 26.8284ZM25.4 23.2C25.4 23.5314 25.1314 23.8 24.8 23.8H15.2C14.8686 23.8 14.6 23.5314 14.6 23.2C14.6 22.8686 14.8686 22.6 15.2 22.6H24.8C25.1314 22.6 25.4 22.8686 25.4 23.2ZM24.8 20.6C25.1314 20.6 25.4 20.3314 25.4 20C25.4 19.6686 25.1314 19.4 24.8 19.4H15.2C14.8686 19.4 14.6 19.6686 14.6 20C14.6 20.3314 14.8686 20.6 15.2 20.6H24.8ZM25.4 16.8C25.4 17.1314 25.1314 17.4 24.8 17.4H15.2C14.8686 17.4 14.6 17.1314 14.6 16.8C14.6 16.4686 14.8686 16.2 15.2 16.2H24.8C25.1314 16.2 25.4 16.4686 25.4 16.8Z"
      fill="#141414"
    />
  </svg>
);
export const SnowcircleIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
      fill="white"
    />
    <path
      d="M20.0007 10.375C19.6536 10.375 19.3066 10.6084 19.3132 11.0732V13.2244L18.0497 11.9595C17.7795 11.6815 17.3323 11.6814 17.0654 11.9567C16.7988 12.2322 16.8057 12.6671 17.0775 12.9316C17.8228 13.6768 18.568 14.422 19.3132 15.1673V18.8102L16.1578 16.9894C15.8849 15.9712 15.6129 14.9529 15.3401 13.9346C15.2469 13.567 14.874 13.3446 14.5022 13.4378C14.1304 13.5312 13.9065 13.9175 14.0121 14.2905L14.4753 16.0173L12.6116 14.9417C12.2858 14.7476 11.8647 14.8531 11.6677 15.1821C11.4708 15.5111 11.5857 15.9424 11.9241 16.1314L13.7865 17.207L12.0611 17.6689C11.6853 17.7639 11.462 18.1515 11.567 18.5202C11.6722 18.8889 12.052 19.1 12.4169 18.9969C13.4346 18.7242 14.4526 18.4518 15.4703 18.1791L18.6257 20.0013L15.4703 21.8221C14.4526 21.5494 13.4346 21.277 12.4169 21.0043C12.052 20.9012 11.6722 21.1124 11.567 21.481C11.462 21.8497 11.6853 22.2373 12.0611 22.3323L13.7878 22.7942L11.9241 23.8698C11.5857 24.0588 11.4708 24.4901 11.6677 24.8192C11.8647 25.1481 12.2858 25.2536 12.6116 25.0595L14.4753 23.9839L14.0121 25.7108C13.9065 26.0837 14.1304 26.47 14.5022 26.5634C14.874 26.6566 15.2469 26.4342 15.3401 26.0666C15.6129 25.0483 15.8849 24.03 16.1578 23.0118L19.3132 21.191V24.8339C18.568 25.5792 17.8228 26.3244 17.0775 27.0696C16.8057 27.3341 16.7988 27.7691 17.0654 28.0445C17.3323 28.3199 17.7795 28.3198 18.0497 28.0417L19.3132 26.7782V28.928C19.3077 29.3156 19.6227 29.6309 20.006 29.6249C20.3894 29.6187 20.6933 29.3071 20.6881 28.928V26.7809L21.9503 28.0417C22.2205 28.3197 22.6677 28.3198 22.9345 28.0445C23.2012 27.7691 23.1943 27.3341 22.9224 27.0696C22.1777 26.3248 21.4329 25.5801 20.6881 24.8353V21.1923L23.8422 23.0131C24.115 24.031 24.3886 25.0487 24.6613 26.0666C24.7544 26.4342 25.1273 26.6566 25.4992 26.5634C25.871 26.47 26.0949 26.0837 25.9893 25.7108L25.5274 23.9853L27.3884 25.0595C28.1869 25.5358 28.8876 24.322 28.0759 23.8685L26.2148 22.7942L27.9389 22.3323C28.3147 22.2373 28.538 21.8497 28.433 21.481C28.3278 21.1124 27.948 20.9012 27.5831 21.0043C26.5658 21.2769 25.5483 21.5495 24.531 21.8221L21.3756 20.0013L24.531 18.1791C25.5483 18.4517 26.5658 18.7243 27.5831 18.9969C27.948 19.1 28.3278 18.8889 28.433 18.5202C28.538 18.1515 28.3147 17.7639 27.9389 17.6689L26.2148 17.207L28.0759 16.1328C28.8876 15.6793 28.1869 14.4655 27.3884 14.9417L25.526 16.0173L25.9893 14.2905C26.0949 13.9175 25.871 13.5312 25.4992 13.4378C25.1273 13.3446 24.7544 13.567 24.6613 13.9346C24.3885 14.9529 24.1151 15.9712 23.8422 16.9894L20.6881 18.8102V15.166C21.4329 14.4211 22.1777 13.6764 22.9224 12.9316C23.1943 12.6671 23.2012 12.2322 22.9345 11.9567C22.6677 11.6814 22.2205 11.6815 21.9503 11.9595L20.6881 13.2217V11.0732C20.695 10.6084 20.3477 10.375 20.0007 10.375Z"
      fill="black"
    />
  </svg>
);
export const SettingscircleIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.5269 11.1421C21.1812 11 20.743 11 19.8667 11C18.9903 11 18.5521 11 18.2064 11.1421C17.7456 11.3315 17.3794 11.6949 17.1885 12.1523C17.1014 12.3611 17.0673 12.6039 17.0539 12.9581C17.0343 13.4786 16.7653 13.9604 16.3108 14.2209C15.8563 14.4813 15.3014 14.4716 14.8374 14.2282C14.5216 14.0625 14.2927 13.9704 14.0669 13.9409C13.5724 13.8763 13.0722 14.0093 12.6764 14.3107C12.3796 14.5368 12.1605 14.9134 11.7223 15.6666C11.2841 16.4198 11.065 16.7965 11.0162 17.1646C10.9511 17.6554 11.0851 18.1518 11.3888 18.5446C11.5274 18.7239 11.7222 18.8746 12.0245 19.0631C12.469 19.3403 12.755 19.8124 12.7549 20.3334C12.7549 20.8543 12.4689 21.3263 12.0245 21.6035C11.7221 21.792 11.5273 21.9427 11.3887 22.122C11.085 22.5148 10.951 23.0112 11.0161 23.502C11.0649 23.8702 11.284 24.2468 11.7222 25C12.1604 25.7532 12.3795 26.1298 12.6763 26.3559C13.0721 26.6573 13.5723 26.7903 14.0668 26.7257C14.2926 26.6962 14.5215 26.6041 14.8372 26.4385C15.3013 26.195 15.8562 26.1853 16.3108 26.4458C16.7653 26.7062 17.0343 27.188 17.0539 27.7086C17.0673 28.0628 17.1014 28.3056 17.1885 28.5143C17.3794 28.9717 17.7456 29.3351 18.2064 29.5246C18.5521 29.6667 18.9903 29.6667 19.8667 29.6667C20.743 29.6667 21.1812 29.6667 21.5269 29.5246C21.9878 29.3351 22.3539 28.9717 22.5448 28.5143C22.632 28.3055 22.6661 28.0627 22.6794 27.7085C22.699 27.188 22.968 26.7062 23.4225 26.4458C23.877 26.1853 24.432 26.195 24.896 26.4384C25.2117 26.604 25.4407 26.6961 25.6664 26.7256C26.161 26.7902 26.6612 26.6572 27.0569 26.3558C27.3537 26.1298 27.5728 25.7532 28.011 24.9999C28.4492 24.2467 28.6683 23.8701 28.7171 23.502C28.7823 23.0111 28.6482 22.5147 28.3446 22.122C28.2059 21.9427 28.0111 21.792 27.7088 21.6034C27.2643 21.3263 26.9784 20.8542 26.9784 20.3332C26.9784 19.8124 27.2644 19.3403 27.7088 19.0632C28.0112 18.8747 28.206 18.7239 28.3446 18.5446C28.6483 18.1519 28.7823 17.6555 28.7172 17.1646C28.6684 16.7965 28.4493 16.4199 28.0111 15.6667C27.5729 14.9134 27.3538 14.5368 27.057 14.3108C26.6613 14.0094 26.1611 13.8764 25.6665 13.941C25.4407 13.9705 25.2118 14.0626 24.8961 14.2282C24.432 14.4716 23.8771 14.4814 23.4226 14.2209C22.968 13.9604 22.699 13.4786 22.6794 12.9581C22.6661 12.6039 22.632 12.3611 22.5448 12.1523C22.3539 11.6949 21.9878 11.3315 21.5269 11.1421ZM19.8667 23.1333C21.4248 23.1333 22.688 21.8797 22.688 20.3333C22.688 18.7869 21.4248 17.5333 19.8667 17.5333C18.3085 17.5333 17.0453 18.7869 17.0453 20.3333C17.0453 21.8797 18.3085 23.1333 19.8667 23.1333Z"
      fill="#141414"
    />
  </svg>
);
export const FogsponIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.9701 9.69727C7.49322 10.2823 8.01072 10.8532 8.51697 11.4045C7.00385 13.1145 4.80447 15.567 4.09572 16.1576C2.70072 17.3163 0.928846 15.747 2.1326 14.1945C2.63322 13.5476 4.41635 11.8938 6.9701 9.69727Z"
      fill="#141414"
    />
    <path
      d="M16.6562 5.56578L16.6533 5.56859C16.6408 5.5867 16.6267 5.60364 16.6112 5.61922C13.4246 8.80297 13.4696 8.87047 12.7862 9.06172C11.8496 9.32328 11.4615 8.84797 10.8933 9.05328C10.3449 8.55265 9.77679 8.03797 9.19741 7.52047C9.49554 6.90172 8.95835 6.51641 9.22554 5.53484C9.42241 4.84859 9.48429 4.8964 12.6877 1.69578C12.7493 1.62072 12.8259 1.55938 12.9126 1.51571C12.9993 1.47205 13.0942 1.44702 13.1912 1.44225C13.2882 1.43747 13.3851 1.45306 13.4757 1.48799C13.5662 1.52293 13.6485 1.57645 13.7172 1.6451C13.7858 1.71375 13.8393 1.79601 13.8743 1.8866C13.9092 1.97718 13.9248 2.07408 13.92 2.17105C13.9152 2.26802 13.8902 2.36291 13.8465 2.44963C13.8029 2.53634 13.7415 2.61295 13.6665 2.67453L11.7033 4.64047C11.6686 4.67199 11.6407 4.71024 11.6212 4.7529C11.6016 4.79555 11.591 4.84172 11.5899 4.88861C11.5887 4.9355 11.5971 4.98213 11.6146 5.02568C11.632 5.06923 11.6581 5.10878 11.6912 5.14195C11.7244 5.17511 11.764 5.2012 11.8075 5.21862C11.8511 5.23605 11.8977 5.24445 11.9446 5.24332C11.9915 5.24218 12.0376 5.23154 12.0803 5.21204C12.1229 5.19253 12.1612 5.16457 12.1927 5.12984L14.1587 3.16672C14.2203 3.09164 14.2969 3.03028 14.3836 2.98658C14.4704 2.94288 14.5653 2.9178 14.6623 2.91297C14.7593 2.90813 14.8562 2.92363 14.9469 2.95849C15.0375 2.99334 15.1199 3.04677 15.1886 3.11535C15.2574 3.18392 15.3111 3.26612 15.3462 3.35667C15.3813 3.44722 15.3971 3.54412 15.3925 3.64113C15.388 3.73814 15.3632 3.83312 15.3197 3.91998C15.2763 4.00684 15.2151 4.08364 15.1402 4.14547L13.1743 6.1114C13.1396 6.14293 13.1116 6.18118 13.0921 6.22384C13.0726 6.26649 13.0619 6.31266 13.0608 6.35955C13.0597 6.40644 13.0681 6.45307 13.0855 6.49662C13.1029 6.54016 13.129 6.57972 13.1622 6.61288C13.1953 6.64605 13.2349 6.67213 13.2785 6.68956C13.322 6.70698 13.3686 6.71538 13.4155 6.71425C13.4624 6.71312 13.5086 6.70248 13.5512 6.68298C13.5939 6.66347 13.6321 6.63551 13.6637 6.60078L15.6296 4.63765C15.6889 4.56469 15.7625 4.50457 15.8458 4.46096C15.9291 4.41734 16.0205 4.39114 16.1142 4.38396C16.208 4.37677 16.3023 4.38875 16.3913 4.41916C16.4802 4.44958 16.5621 4.49779 16.6319 4.56086C16.7016 4.62393 16.7578 4.70054 16.797 4.78603C16.8362 4.87151 16.8576 4.96408 16.8599 5.0581C16.8622 5.15212 16.8453 5.24562 16.8102 5.3329C16.7752 5.42018 16.7228 5.49941 16.6562 5.56578Z"
      fill="#141414"
    />
    <path
      d="M15.5282 16.0565C15.2648 16.3073 14.9128 16.4436 14.5492 16.4357C14.1856 16.4278 13.8399 16.2763 13.5876 16.0143C10.3251 12.614 7.18632 9.09839 7.18632 9.09839C7.0357 8.92794 6.84675 8.7957 6.63503 8.71257C6.4233 8.62945 6.19485 8.59781 5.9685 8.62026C4.88007 8.72433 3.58632 8.22934 2.56538 7.20839C1.01569 5.65589 0.678192 3.47901 1.81444 2.34276C2.95069 1.20651 5.13038 1.54401 6.68007 3.0937C7.701 4.11464 8.196 5.40839 8.09194 6.49683C8.0704 6.7231 8.10246 6.95127 8.18552 7.16285C8.26859 7.37443 8.40033 7.56346 8.57007 7.71464C10.673 9.58375 13.7105 12.4091 15.486 14.1159C15.6164 14.2404 15.7209 14.3895 15.7936 14.5545C15.8664 14.7195 15.9058 14.8972 15.9097 15.0774C15.9136 15.2577 15.882 15.437 15.8165 15.605C15.751 15.773 15.653 15.9264 15.5282 16.0565Z"
      fill="#141414"
    />
  </svg>
);
export const BegIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.70654 8.04443e-07H7.6268C6.93798 -2.07497e-05 6.36356 -3.87224e-05 5.90757 0.0612679C5.42626 0.125978 4.99171 0.268326 4.64252 0.617519C4.29332 0.966713 4.15098 1.40126 4.08627 1.88257C4.02496 2.33856 4.02498 2.91296 4.025 3.60179V3.66138C3.89279 3.66571 3.76508 3.67098 3.64167 3.67742V9.96668L6.15976 9.96667C6.31701 9.96661 6.48705 9.96655 6.63059 9.98584C6.79873 10.0084 7.01355 10.0666 7.19433 10.2474C7.37511 10.4281 7.43325 10.643 7.45585 10.8111C7.47515 10.9546 7.47508 11.1247 7.47502 11.2819V12.1014C7.47508 12.2587 7.47515 12.4287 7.45585 12.5723C7.43325 12.7404 7.37511 12.9552 7.19433 13.136C7.01355 13.3168 6.79873 13.3749 6.63059 13.3975C6.48706 13.4168 6.31703 13.4167 6.15978 13.4167L3.64167 13.4167V15.8726C4.32753 15.9083 5.14617 15.9083 6.13333 15.9083H9.2C10.1872 15.9083 11.0058 15.9083 11.6917 15.8726V3.67742C11.5683 3.67098 11.4406 3.66571 11.3083 3.66138V3.60181C11.3084 2.91298 11.3084 2.33856 11.2471 1.88257C11.1824 1.40126 11.04 0.966713 10.6908 0.617519C10.3416 0.268326 9.90708 0.125978 9.42577 0.0612679C8.96978 -3.87224e-05 8.39536 -2.07497e-05 7.70654 8.04443e-07ZM10.1583 3.64311V3.64167C10.1583 2.90259 10.1571 2.40613 10.1073 2.0358C10.0598 1.68202 9.97756 1.5306 9.87765 1.43069C9.77774 1.33078 9.62632 1.24858 9.27254 1.20101C8.90221 1.15122 8.40575 1.15 7.66667 1.15C6.92759 1.15 6.43113 1.15122 6.0608 1.20101C5.70702 1.24858 5.5556 1.33078 5.45569 1.43069C5.35578 1.5306 5.27358 1.68202 5.22601 2.0358C5.17622 2.40613 5.175 2.90259 5.175 3.64167V3.64311C5.47556 3.64167 5.79452 3.64167 6.13333 3.64167H9.2C9.53882 3.64167 9.85778 3.64167 10.1583 3.64311Z"
      fill="#141414"
    />
    <path
      d="M14.4351 15.0101C14.0373 15.4079 13.5322 15.6295 12.8417 15.753V3.797C13.5322 3.92047 14.0373 4.14209 14.4351 4.53987C15.3333 5.43808 15.3333 6.88372 15.3333 9.775C15.3333 12.6663 15.3333 14.1119 14.4351 15.0101Z"
      fill="#141414"
    />
    <path
      d="M0.898206 4.53987C1.29599 4.14209 1.80114 3.92047 2.49167 3.797V9.99856C2.33821 10.0284 2.15962 10.0934 2.0057 10.2474C1.82492 10.4281 1.76678 10.643 1.74418 10.8111C1.72488 10.9546 1.72495 11.1247 1.72501 11.2819V12.1014C1.72495 12.2587 1.72488 12.4287 1.74418 12.5723C1.76678 12.7404 1.82492 12.9552 2.0057 13.136C2.15962 13.2899 2.33821 13.3549 2.49167 13.3848V15.753C1.80114 15.6295 1.29599 15.4079 0.898206 15.0101C0 14.1119 0 12.6663 0 9.775C0 6.88372 0 5.43808 0.898206 4.53987Z"
      fill="#141414"
    />
    <path
      d="M2.8759 11.1176C2.87504 11.1708 2.87501 11.2324 2.87501 11.3083V12.075C2.87501 12.151 2.87504 12.2125 2.8759 12.2658C2.92915 12.2667 2.99072 12.2667 3.06668 12.2667H6.13335C6.20931 12.2667 6.27088 12.2667 6.32413 12.2658C6.32499 12.2125 6.32501 12.151 6.32501 12.075V11.3083C6.32501 11.2324 6.32499 11.1708 6.32413 11.1176C6.27088 11.1167 6.20931 11.1167 6.13335 11.1167H3.06668C2.99072 11.1167 2.92915 11.1167 2.8759 11.1176Z"
      fill="#141414"
    />
  </svg>
);
export const NewCartIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0369718 0.434587C0.156039 0.0959228 0.527104 -0.0820955 0.865768 0.0369718L1.12698 0.128808C1.6613 0.316642 2.11512 0.476174 2.47226 0.651414C2.85414 0.838791 3.18161 1.06962 3.4279 1.43003C3.67228 1.78765 3.77318 2.18001 3.81974 2.6102C3.84059 2.80278 3.85159 3.01593 3.85738 3.25021H13.0772C14.5375 3.25021 15.852 3.25021 16.2367 3.75035C16.6215 4.25049 16.4711 5.00408 16.1702 6.51126L15.7371 8.61268C15.464 9.93772 15.3275 10.6002 14.8493 10.9899C14.3712 11.3795 13.6947 11.3795 12.3418 11.3795H7.74599C5.32894 11.3795 4.12041 11.3795 3.36953 10.5876C2.61865 9.79558 2.56385 8.95423 2.56385 6.40488L2.56385 4.15009C2.56385 3.5088 2.56296 3.07961 2.52729 2.7501C2.49321 2.4352 2.4328 2.27797 2.35457 2.16349C2.27826 2.05181 2.16241 1.94744 1.89961 1.81849C1.61982 1.6812 1.23956 1.5464 0.660968 1.34297L0.434587 1.26338C0.0959228 1.14432 -0.0820955 0.773251 0.0369718 0.434587Z"
      fill="#141414"
    />
    <path
      d="M4.7307 13.6502C5.44867 13.6502 6.0307 14.2322 6.0307 14.9502C6.0307 15.6682 5.44867 16.2502 4.7307 16.2502C4.01273 16.2502 3.4307 15.6682 3.4307 14.9502C3.4307 14.2322 4.01273 13.6502 4.7307 13.6502Z"
      fill="#141414"
    />
    <path
      d="M12.5307 13.6503C13.2487 13.6503 13.8307 14.2323 13.8307 14.9503C13.8307 15.6682 13.2487 16.2503 12.5307 16.2503C11.8127 16.2503 11.2307 15.6682 11.2307 14.9503C11.2307 14.2323 11.8127 13.6503 12.5307 13.6503Z"
      fill="#141414"
    />
  </svg>
);

export const WarningNewIcon = () => (
  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.9972 21.545H3.00272C1.93934 21.545 0.978079 21.0006 0.430944 20.0889C-0.116015 19.1773 -0.143916 18.0728 0.356367 17.1345C0.362859 17.1226 0.369527 17.1107 0.376722 17.0989L8.93346 2.97467C9.48095 2.06869 10.4405 1.52734 11.5 1.52734C12.5592 1.52734 13.5185 2.06834 14.0665 2.97467L22.6232 17.0989C22.6304 17.1107 22.6371 17.1226 22.6436 17.1347C23.1439 18.0728 23.116 19.1773 22.569 20.089C22.0219 21.0006 21.0606 21.545 19.9972 21.545ZM1.67086 17.8566C1.42975 18.3222 1.44642 18.8668 1.71683 19.3175C1.99022 19.7733 2.47103 20.0455 3.00272 20.0455H19.9972C20.5289 20.0455 21.0097 19.7733 21.2831 19.3175C21.5535 18.8668 21.5702 18.3222 21.3291 17.8566L12.7839 3.75168C12.7838 3.7515 12.7836 3.75115 12.7834 3.75098C12.5095 3.29755 12.0297 3.02679 11.5 3.02679C10.9702 3.02679 10.4905 3.29755 10.2165 3.75098L1.67086 17.8566Z" fill="#F59E09" />
    <path d="M11.4998 15.546C11.0857 15.546 10.75 15.2103 10.75 14.7962V7.29864C10.75 6.88451 11.0857 6.54883 11.4998 6.54883C11.9139 6.54883 12.2496 6.88451 12.2496 7.29864V14.7962C12.2496 15.2103 11.9139 15.546 11.4998 15.546Z" fill="#141414" />
    <path d="M11.4998 18.5444C11.0862 18.5444 10.75 18.2076 10.75 17.7947C10.75 17.3817 11.0862 17.0449 11.4998 17.0449C11.9134 17.0449 12.2496 17.3817 12.2496 17.7947C12.2496 18.2076 11.9134 18.5444 11.4998 18.5444Z" fill="#141414" />
  </svg>
);
export const RoundDateIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" fill="#787FFF" />
    <path
      d="M24.166 13.9577C23.8243 13.9577 23.541 13.6743 23.541 13.3327V11.666C23.541 11.3243 23.8243 11.041 24.166 11.041C24.5077 11.041 24.791 11.3243 24.791 11.666V13.3327C24.791 13.6743 24.5077 13.9577 24.166 13.9577Z"
      fill="white"
    />
    <path
      d="M15.834 13.9577C15.4923 13.9577 15.209 13.6743 15.209 13.3327V11.666C15.209 11.3243 15.4923 11.041 15.834 11.041C16.1757 11.041 16.459 11.3243 16.459 11.666V13.3327C16.459 13.6743 16.1757 13.9577 15.834 13.9577Z"
      fill="white"
    />
    <path
      d="M28.9577 16.8757V15.834C28.9577 14.109 27.5577 12.709 25.8327 12.709H14.166C12.441 12.709 11.041 14.109 11.041 15.834V16.8757H28.9577Z"
      fill="white"
    />
    <path
      d="M11.041 18.125V25.8333C11.041 27.5583 12.441 28.9583 14.166 28.9583H25.8327C27.5577 28.9583 28.9577 27.5583 28.9577 25.8333V18.125H11.041ZM15.8327 25.8333C15.3743 25.8333 14.9993 25.4583 14.9993 25C14.9993 24.5417 15.3743 24.1667 15.8327 24.1667C16.291 24.1667 16.666 24.5417 16.666 25C16.666 25.4583 16.291 25.8333 15.8327 25.8333ZM15.8327 21.6667C15.3743 21.6667 14.9993 21.2917 14.9993 20.8333C14.9993 20.375 15.3743 20 15.8327 20C16.291 20 16.666 20.375 16.666 20.8333C16.666 21.2917 16.291 21.6667 15.8327 21.6667ZM19.9993 25.8333C19.541 25.8333 19.166 25.4583 19.166 25C19.166 24.5417 19.541 24.1667 19.9993 24.1667C20.4577 24.1667 20.8327 24.5417 20.8327 25C20.8327 25.4583 20.4577 25.8333 19.9993 25.8333ZM19.9993 21.6667C19.541 21.6667 19.166 21.2917 19.166 20.8333C19.166 20.375 19.541 20 19.9993 20C20.4577 20 20.8327 20.375 20.8327 20.8333C20.8327 21.2917 20.4577 21.6667 19.9993 21.6667ZM24.166 25.8333C23.7077 25.8333 23.3327 25.4583 23.3327 25C23.3327 24.5417 23.7077 24.1667 24.166 24.1667C24.6243 24.1667 24.9993 24.5417 24.9993 25C24.9993 25.4583 24.6243 25.8333 24.166 25.8333ZM24.166 21.6667C23.7077 21.6667 23.3327 21.2917 23.3327 20.8333C23.3327 20.375 23.7077 20 24.166 20C24.6243 20 24.9993 20.375 24.9993 20.8333C24.9993 21.2917 24.6243 21.6667 24.166 21.6667Z"
      fill="white"
    />
  </svg>
);

export const ViewIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 11.9959C4 12.2611 4.10536 12.5155 4.29289 12.703C4.48043 12.8906 4.73478 12.9959 5 12.9959L15.59 12.9959L12.29 16.2859C12.1017 16.4742 11.9959 16.7296 11.9959 16.9959C11.9959 17.2622 12.1017 17.5176 12.29 17.7059C12.4783 17.8942 12.7337 18 13 18C13.2663 18 13.5217 17.8942 13.71 17.7059L18.71 12.7059C18.8037 12.6129 18.8781 12.5023 18.9289 12.3805C18.9797 12.2586 19.0058 12.1279 19.0058 11.9959C19.0058 11.8639 18.9797 11.7332 18.9289 11.6113C18.8781 11.4895 18.8037 11.3789 18.71 11.2859L13.71 6.28591C13.6168 6.19267 13.5061 6.11871 13.3843 6.06825C13.2624 6.01779 13.1319 5.99182 13 5.99182C12.8681 5.99182 12.7376 6.01779 12.6158 6.06825C12.4939 6.11871 12.3832 6.19267 12.29 6.28591C12.1968 6.37915 12.1228 6.48984 12.0723 6.61166C12.0219 6.73348 11.9959 6.86405 11.9959 6.99591C11.9959 7.12777 12.0219 7.25834 12.0723 7.38016C12.1228 7.50198 12.1968 7.61267 12.29 7.70591L15.59 10.9959L5 10.9959C4.73478 10.9959 4.48043 11.1013 4.29289 11.2888C4.10536 11.4763 4 11.7307 4 11.9959Z" fill="#141414" />
  </svg>
);
export const DownloadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 19H3C2.73478 19 2.48043 19.1054 2.29289 19.2929C2.10536 19.4804 2 19.7348 2 20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20C22 19.7348 21.8946 19.4804 21.7071 19.2929C21.5196 19.1054 21.2652 19 21 19Z" fill="white" />
    <path d="M12.0002 2C11.735 2 11.4806 2.10536 11.2931 2.29289C11.1055 2.48043 11.0002 2.73478 11.0002 3V13.59L7.71019 10.29C7.52188 10.1017 7.26649 9.99591 7.00019 9.99591C6.73388 9.99591 6.47849 10.1017 6.29019 10.29C6.10188 10.4783 5.99609 10.7337 5.99609 11C5.99609 11.2663 6.10188 11.5217 6.29019 11.71L11.2902 16.71C11.3831 16.8037 11.4937 16.8781 11.6156 16.9289C11.7375 16.9797 11.8682 17.0058 12.0002 17.0058C12.1322 17.0058 12.2629 16.9797 12.3848 16.9289C12.5066 16.8781 12.6172 16.8037 12.7102 16.71L17.7102 11.71C17.8034 11.6168 17.8774 11.5061 17.9278 11.3843C17.9783 11.2624 18.0043 11.1319 18.0043 11C18.0043 10.8681 17.9783 10.7376 17.9278 10.6158C17.8774 10.4939 17.8034 10.3832 17.7102 10.29C17.6169 10.1968 17.5063 10.1228 17.3844 10.0723C17.2626 10.0219 17.132 9.99591 17.0002 9.99591C16.8683 9.99591 16.7378 10.0219 16.6159 10.0723C16.4941 10.1228 16.3834 10.1968 16.2902 10.29L13.0002 13.59V3C13.0002 2.73478 12.8948 2.48043 12.7073 2.29289C12.5198 2.10536 12.2654 2 12.0002 2Z" fill="white" />
  </svg>
);
export const BulbIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="#787FFF" />
    <g clip-path="url(#clip0_2012_11190)">
      <path d="M15.4576 22.398C15.97 22.8322 16.3099 23.4203 16.4326 24.0623H19.4143V19.8864C18.4045 19.6255 17.6564 18.7069 17.6564 17.6167H18.8283C18.8283 18.2629 19.354 18.7886 20.0002 18.7886C20.6464 18.7886 21.1722 18.2629 21.1722 17.6167H22.3441C22.3441 18.7068 21.596 19.6255 20.5862 19.8864V24.0623H23.5685C23.6926 23.4204 24.0357 22.8293 24.553 22.3894C26.1283 21.0499 27.0318 19.0968 27.0318 17.0308C27.0318 10.7277 19.3447 7.63222 14.9671 12.1295C12.1101 15.0647 12.3543 19.7693 15.4576 22.398Z" fill="white" />
      <path d="M20.0001 30.0001C21.2925 30.0001 22.3439 28.9486 22.3439 27.6562H17.6562C17.6562 28.9486 18.7077 30.0001 20.0001 30.0001Z" fill="white" />
      <path d="M16.4844 25.2344H23.5159V26.4844H16.4844V25.2344Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_2012_11190">
        <rect width="20" height="20" fill="white" transform="translate(10 10)" />
      </clipPath>
    </defs>
  </svg>
);

export const TimeIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="white" />
    <path d="M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z" fill="#141414" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M24 19.25C24.4142 19.25 24.75 19.5858 24.75 20V23.6893L27.0303 25.9697C27.3232 26.2626 27.3232 26.7374 27.0303 27.0303C26.7374 27.3232 26.2626 27.3232 25.9697 27.0303L23.4697 24.5303C23.329 24.3897 23.25 24.1989 23.25 24V20C23.25 19.5858 23.5858 19.25 24 19.25Z" fill="white" />
  </svg>
);

export const CalenderIcon = () => {
  return (
    <svg className="react-datepicker__calendar-icon " width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.166 3.95768C13.8243 3.95768 13.541 3.67435 13.541 3.33268V1.66602C13.541 1.32435 13.8243 1.04102 14.166 1.04102C14.5077 1.04102 14.791 1.32435 14.791 1.66602V3.33268C14.791 3.67435 14.5077 3.95768 14.166 3.95768Z" fill="#141414" />
      <path d="M5.83398 3.95768C5.49232 3.95768 5.20898 3.67435 5.20898 3.33268V1.66602C5.20898 1.32435 5.49232 1.04102 5.83398 1.04102C6.17565 1.04102 6.45898 1.32435 6.45898 1.66602V3.33268C6.45898 3.67435 6.17565 3.95768 5.83398 3.95768Z" fill="#141414" />
      <path d="M18.9577 6.87565V5.83398C18.9577 4.10898 17.5577 2.70898 15.8327 2.70898H4.16602C2.44102 2.70898 1.04102 4.10898 1.04102 5.83398V6.87565H18.9577Z" fill="#141414" />
      <path d="M1.04102 8.125V15.8333C1.04102 17.5583 2.44102 18.9583 4.16602 18.9583H15.8327C17.5577 18.9583 18.9577 17.5583 18.9577 15.8333V8.125H1.04102ZM5.83268 15.8333C5.37435 15.8333 4.99935 15.4583 4.99935 15C4.99935 14.5417 5.37435 14.1667 5.83268 14.1667C6.29102 14.1667 6.66602 14.5417 6.66602 15C6.66602 15.4583 6.29102 15.8333 5.83268 15.8333ZM5.83268 11.6667C5.37435 11.6667 4.99935 11.2917 4.99935 10.8333C4.99935 10.375 5.37435 10 5.83268 10C6.29102 10 6.66602 10.375 6.66602 10.8333C6.66602 11.2917 6.29102 11.6667 5.83268 11.6667ZM9.99935 15.8333C9.54102 15.8333 9.16602 15.4583 9.16602 15C9.16602 14.5417 9.54102 14.1667 9.99935 14.1667C10.4577 14.1667 10.8327 14.5417 10.8327 15C10.8327 15.4583 10.4577 15.8333 9.99935 15.8333ZM9.99935 11.6667C9.54102 11.6667 9.16602 11.2917 9.16602 10.8333C9.16602 10.375 9.54102 10 9.99935 10C10.4577 10 10.8327 10.375 10.8327 10.8333C10.8327 11.2917 10.4577 11.6667 9.99935 11.6667ZM14.166 15.8333C13.7077 15.8333 13.3327 15.4583 13.3327 15C13.3327 14.5417 13.7077 14.1667 14.166 14.1667C14.6243 14.1667 14.9993 14.5417 14.9993 15C14.9993 15.4583 14.6243 15.8333 14.166 15.8333ZM14.166 11.6667C13.7077 11.6667 13.3327 11.2917 13.3327 10.8333C13.3327 10.375 13.7077 10 14.166 10C14.6243 10 14.9993 10.375 14.9993 10.8333C14.9993 11.2917 14.6243 11.6667 14.166 11.6667Z" fill="#141414" />
    </svg>
  );
};

export const MerchantcardIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.4931 13.0627C15.5064 13.0681 14.5426 12.7653 13.7362 12.1965C12.9385 12.7669 11.9807 13.0701 11 13.0627C10.0199 13.0663 9.06232 12.7687 8.25688 12.2102C7.44608 12.763 6.48816 13.0599 5.50688 13.0627C5.34188 13.0627 5.18375 13.0559 5.01875 13.0421C4.19623 12.9619 3.41149 12.6575 2.75 12.1621V18.5627C2.75163 19.1092 2.96945 19.6329 3.3559 20.0193C3.74234 20.4058 4.26599 20.6236 4.8125 20.6252H8.25V17.0846C8.26485 16.734 8.41775 16.4035 8.67534 16.1653C8.93294 15.927 9.27432 15.8003 9.625 15.8127H12.375C12.7257 15.8003 13.0671 15.927 13.3247 16.1653C13.5823 16.4035 13.7352 16.734 13.75 17.0846V20.6252H17.1875C17.734 20.6236 18.2577 20.4058 18.6441 20.0193C19.0305 19.6329 19.2484 19.1092 19.25 18.5627V12.1621C18.5885 12.6575 17.8038 12.9619 16.9813 13.0421C16.8163 13.0559 16.6581 13.0627 16.4931 13.0627Z" fill="#141414" />
      <path d="M5.15643 11.6703C5.2733 11.682 5.39018 11.6875 5.50636 11.6875C6.03985 11.6899 6.56656 11.5681 7.04482 11.3317C7.52308 11.0953 7.93975 10.7508 8.26186 10.3256C8.58083 10.75 8.99446 11.0941 9.46985 11.3306C9.94523 11.567 10.4692 11.6892 11.0002 11.6875C11.5347 11.6923 12.0623 11.5667 12.5373 11.3216C13.0122 11.0765 13.4203 10.7193 13.7261 10.2809C14.0784 10.7654 14.5519 11.1489 15.0991 11.3927C15.6463 11.6366 16.2481 11.7323 16.8439 11.6703C17.7041 11.5632 18.4948 11.1433 19.0653 10.4907C19.6358 9.83817 19.9464 8.99851 19.9377 8.13175C19.9374 7.69747 19.8843 7.26483 19.7796 6.84338L18.8026 2.937C18.691 2.49075 18.4334 2.09462 18.0708 1.8116C17.7081 1.52857 17.2613 1.3749 16.8013 1.375H5.19905C4.73905 1.3749 4.29222 1.52857 3.92959 1.8116C3.56697 2.09462 3.30937 2.49075 3.19774 2.937L2.2208 6.84338C2.11603 7.26483 2.06293 7.69747 2.06268 8.13175C2.054 8.99851 2.36452 9.83817 2.93505 10.4907C3.50559 11.1433 4.29627 11.5632 5.15643 11.6703Z" fill="#141414" />
    </svg>
  );
};

export const OnlinecardIcon = () => {
  return (
    <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.9246 5.36328H4.71211C3.89961 5.36328 3.24961 5.85078 3.00586 6.58203H13.1621C15.1121 6.58203 16.6559 8.12578 16.6559 10.0758V16.0883C17.3871 15.8445 17.8746 15.1945 17.8746 14.382V7.23203C17.7934 6.17578 16.9809 5.36328 15.9246 5.36328Z" fill="#141414" />
      <path d="M13.0813 8.20703H1.86875C0.8125 8.20703 0 9.01953 0 10.0758V11.0508H14.95V10.0758C14.95 9.01953 14.1375 8.20703 13.0813 8.20703Z" fill="#141414" />
      <path d="M0 17.2258C0 18.2008 0.8125 19.0945 1.86875 19.0945H13.1625C14.1375 19.0945 15.0312 18.282 15.0312 17.2258V12.6758H0V17.2258Z" fill="#141414" />
      <path d="M17.9561 0C17.4686 0 17.1436 0.325 17.1436 0.8125C17.1436 1.3 17.4686 1.625 17.9561 1.625C19.6623 1.625 21.1248 3.00625 21.1248 4.79375C21.1248 5.28125 21.4498 5.60625 21.9373 5.60625C22.4248 5.60625 22.7498 5.28125 22.7498 4.79375C22.7498 2.1125 20.6373 0 17.9561 0Z" fill="#141414" />
      <path d="M17.4688 2.51953C16.9812 2.51953 16.6562 2.84453 16.6562 3.33203C16.6562 3.81953 16.9812 4.14453 17.4688 4.14453C18.1187 4.14453 18.6062 4.63203 18.6062 5.28203C18.6062 5.76953 18.9312 6.09453 19.4187 6.09453C19.9062 6.09453 20.2312 5.76953 20.2312 5.28203C20.2312 3.73828 19.0125 2.51953 17.4688 2.51953Z" fill="#141414" />
    </svg>
  );
};

export const TapcardIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_959_12621)">
        <path d="M0 2.3302V18.715H10.7843C9.9623 18.3 9.20519 17.7538 8.55293 17.0981C6.93988 15.4954 6.00445 13.2722 6.01262 11C5.94215 6.8097 9.31691 2.95841 13.4681 2.44278C13.527 1.1202 12.4657 -0.00342963 11.1379 7.86643e-06H2.3302C1.04543 7.86643e-06 0 1.04544 0 2.3302ZM5.02391 3.23255C5.02391 2.87891 5.3148 2.58802 5.66844 2.58802H7.63812C7.99176 2.58802 8.28266 2.87891 8.28266 3.23255C8.28266 3.58618 7.99176 3.87708 7.63812 3.87708H5.66844C5.3148 3.87708 5.02391 3.58618 5.02391 3.23255ZM13.4449 20.0041H0.0240625C0.186484 21.1312 1.15887 22 2.3302 22H11.1379C12.3131 22.003 13.2795 21.1234 13.4449 20.0041Z" fill="#141414" />
        <path d="M7.30176 10.9998C7.30176 15.0315 10.6189 18.3491 14.6507 18.3491C18.6825 18.3491 22.0001 15.0315 22.0001 10.9998C22.0001 6.96801 18.6825 3.65039 14.6507 3.65039C10.6189 3.65039 7.30176 6.96801 7.30176 10.9998ZM13.2203 13.5044C13.6027 13.122 14.1106 12.9114 14.6511 12.9114C15.1913 12.9114 15.6996 13.122 16.082 13.5044C16.3334 13.7562 16.3334 14.164 16.082 14.4158C15.8302 14.6676 15.422 14.6676 15.1702 14.4158C14.8843 14.1254 14.4058 14.1342 14.1316 14.4158C14.0057 14.5417 13.8412 14.6044 13.6762 14.6044C13.5112 14.6044 13.3462 14.5417 13.2203 14.4158C12.9685 14.164 12.9685 13.7562 13.2203 13.5044ZM11.2695 11.5541C12.1723 10.6509 13.3732 10.1533 14.6511 10.1533C15.929 10.1533 17.13 10.6509 18.0323 11.5541C18.2841 11.8059 18.2841 12.2136 18.0323 12.4654C17.7805 12.7168 17.3723 12.7168 17.1205 12.465C16.7987 12.1432 16.4253 11.8918 16.0184 11.7186C15.7223 11.5927 15.3081 11.4007 14.6511 11.4423C13.7174 11.4423 12.8404 11.8054 12.1813 12.465C12.0554 12.5909 11.8904 12.6541 11.7254 12.6541C11.5604 12.6541 11.3958 12.5913 11.2699 12.4654C11.0181 12.2136 11.0181 11.8059 11.2695 11.5541ZM9.32 10.5155C9.0682 10.2637 9.06777 9.85551 9.31957 9.60371C10.7427 8.1793 12.6363 7.39512 14.6511 7.39512C16.6659 7.39512 18.5591 8.1793 19.9827 9.60371C20.2341 9.85551 20.2341 10.2637 19.9823 10.5155C19.7305 10.7669 19.3223 10.7669 19.0709 10.5151C17.891 9.3343 16.3213 8.68418 14.6511 8.68418C12.9809 8.68418 11.4113 9.3343 10.2314 10.5151C10.1055 10.641 9.94047 10.7041 9.77547 10.7041C9.61047 10.7041 9.44547 10.641 9.32 10.5155Z" fill="#141414" />
      </g>
      <defs>
        <clipPath id="clip0_959_12621">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EditNewIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.12298 12.2608C2.97898 12.2608 2.83526 12.206 2.72529 12.096C2.50563 11.8764 2.50563 11.5203 2.72529 11.3006L11.5155 2.51045C11.7349 2.29079 12.0912 2.29079 12.3109 2.51045C12.5305 2.7301 12.5305 3.08616 12.3109 3.30582L3.52066 12.096C3.41098 12.2057 3.26698 12.2608 3.12298 12.2608Z" fill="#141414" />
    <path d="M2.25447 16.3127C2.21537 16.3127 2.17572 16.3085 2.13606 16.3C1.83231 16.2348 1.63881 15.9358 1.70406 15.6321L2.57312 11.5812C2.63837 11.2775 2.93875 11.0845 3.24109 11.1492C3.54484 11.2145 3.73834 11.5134 3.67309 11.8172L2.80403 15.868C2.7475 16.1321 2.51406 16.3127 2.25447 16.3127Z" fill="#141414" />
    <path d="M6.30462 15.4441C6.16062 15.4441 6.0169 15.3893 5.90693 15.2793C5.68727 15.0597 5.68727 14.7036 5.90693 14.4839L14.6971 5.69404C14.9165 5.47438 15.2728 5.47438 15.4925 5.69404C15.7121 5.9137 15.7121 6.26976 15.4925 6.48941L6.70259 15.2793C6.59262 15.3893 6.44862 15.4441 6.30462 15.4441Z" fill="#141414" />
    <path d="M2.25354 16.3124C1.99395 16.3124 1.76079 16.1319 1.70398 15.8678C1.63901 15.564 1.83223 15.2651 2.13598 15.1998L6.18682 14.3308C6.49085 14.2663 6.78982 14.4593 6.85479 14.7628C6.91976 15.0665 6.72654 15.3655 6.42279 15.4307L2.37195 16.2998C2.33229 16.3085 2.29263 16.3124 2.25354 16.3124Z" fill="#141414" />
    <path d="M13.504 8.24421C13.36 8.24421 13.216 8.18937 13.1063 8.0794L9.92451 4.89762C9.70485 4.67796 9.70485 4.3219 9.92451 4.10224C10.1439 3.88259 10.5005 3.88259 10.7199 4.10224L13.9017 7.28402C14.1213 7.50368 14.1213 7.85974 13.9017 8.0794C13.792 8.18937 13.648 8.24421 13.504 8.24421Z" fill="#141414" />
    <path d="M15.0954 6.65263C14.9514 6.65263 14.8074 6.59778 14.6974 6.48781C14.4777 6.26816 14.4777 5.91209 14.6974 5.69216C15.0104 5.37913 15.1828 4.95528 15.1828 4.49909C15.1828 4.04291 15.0104 3.61906 14.6974 3.30603C14.3841 2.99272 13.9602 2.82031 13.504 2.82031C13.0479 2.82031 12.624 2.99272 12.311 3.30603C12.0916 3.52569 11.7355 3.52597 11.5153 3.30603C11.2957 3.08638 11.2957 2.73031 11.5153 2.51037C12.0407 1.98472 12.7469 1.69531 13.504 1.69531C14.2609 1.69531 14.9674 1.98472 15.4928 2.51037C16.0184 3.03575 16.3078 3.74197 16.3078 4.49909C16.3078 5.25622 16.0184 5.96244 15.4928 6.48781C15.3834 6.5975 15.2394 6.65263 15.0954 6.65263Z" fill="#141414" />
  </svg>
);
export const AlertCircle = ({ size = 28, color = "black" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" />
    <line x1="12" y1="7" x2="12" y2="13" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="17" r="1.2" fill={color} />
  </svg>
);

